import React from 'react';

function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var classnames$1 = {exports: {}};

/*!
  Copyright (c) 2018 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/

(function (module) {
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames() {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg)) {
				if (arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				}
			} else if (argType === 'object') {
				if (arg.toString === Object.prototype.toString) {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				} else {
					classes.push(arg.toString());
				}
			}
		}

		return classes.join(' ');
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
}(classnames$1));

var classnames = classnames$1.exports;

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (!css || typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ".enterprise-icon {\n  fill: currentColor;\n  vertical-align: middle;\n}\n.enterprise-icon.--size-inline {\n  height: 1.935ex;\n  min-width: 1.935ex;\n  vertical-align: middle;\n}\n.enterprise-icon.--size-sm {\n  height: 16px;\n  min-width: 16px;\n}\n.enterprise-icon.--size-md {\n  height: 20px;\n  min-width: 20px;\n}\n.enterprise-icon.--size-lg {\n  height: 24px;\n  min-width: 24px;\n}\n.enterprise-icon.--size-xl {\n  height: 32px;\n  min-width: 36px;\n}\n";
styleInject(css_248z);

var _excluded = ["className", "aria-hidden", "aria-label", "size", "icon"];
var EnterpriseIcon = function EnterpriseIcon(_ref) {
  var className = _ref.className,
    _ref$ariaHidden = _ref['aria-hidden'],
    ariaHidden = _ref$ariaHidden === void 0 ? true : _ref$ariaHidden,
    ariaLabel = _ref['aria-label'],
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 'md' : _ref$size,
    icon = _ref.icon,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  var finalClasses = classnames('enterprise-icon', _defineProperty({}, "--size-".concat(size), size), className);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: finalClasses,
    "aria-hidden": ariaHidden,
    "aria-label": ariaLabel ? ariaLabel : "Icon showing ".concat(icon.name),
    focusable: "false",
    role: "img",
    "data-testid": "enterprise-icon-".concat(icon.name),
    viewBox: "0 0 24 24"
  }, otherProps), icon.path);
};
EnterpriseIcon.displayName = 'EnterpriseIcon';

var AccessibilityIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C11.4477 3 11 3.44772 11 4C11 4.55228 11.4477 5 12 5C12.5523 5 13 4.55228 13 4C13 3.44772 12.5523 3 12 3ZM9 4C9 2.34315 10.3431 1 12 1C13.6569 1 15 2.34315 15 4C15 5.65685 13.6569 7 12 7C10.3431 7 9 5.65685 9 4ZM5.00014 8.35538C5.00008 8.35592 5 8.35689 5 8.35839V9.23644C6.44312 9.61422 7.43961 9.76926 9.1401 10.0099L10 10.1315V21H11V16C11 15.4477 11.4477 15 12 15C12.5523 15 13 15.4477 13 16V21H14V10.1205L14.8723 10.0082C16.5002 9.79856 17.5027 9.59342 19 9.22113V8.35839C19 8.35689 18.9999 8.35592 18.9999 8.35538C18.9992 8.35423 18.9966 8.35031 18.9906 8.34578C18.9839 8.34076 18.9769 8.3379 18.9714 8.33677C18.9674 8.33595 18.9629 8.33559 18.9549 8.33772C17.3034 8.78122 14.2927 9.5 12 9.5C9.70727 9.5 6.69661 8.78122 5.04507 8.33772C5.03713 8.33559 5.03255 8.33595 5.02858 8.33677C5.02313 8.3379 5.01611 8.34076 5.00945 8.34578C5.00342 8.35032 5.00081 8.35423 5.00014 8.35538ZM3 8.35839C3 7.00688 4.29657 6.06587 5.56376 6.40615C7.22075 6.85111 10.0003 7.5 12 7.5C13.9997 7.5 16.7793 6.85111 18.4362 6.40615C19.7034 6.06587 21 7.00688 21 8.35839V9.22333C21 10.1358 20.3808 10.9386 19.4879 11.1607C18.2077 11.4791 17.2512 11.6853 16 11.8714V21C16 22.1046 15.1046 23 14 23H10C8.89543 23 8 22.1046 8 21V11.8663C6.73605 11.6793 5.76777 11.5055 4.47609 11.1667C3.59239 10.9349 3 10.134 3 9.24376V8.35839Z"
  })),
  name: 'AccessibilityIcon',
  tags: ["accessibility", "accessible", "ada", "a11y", "aria"],
  category: 'system'
};
var ActivityIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00804 4.28731C7.71121 2.52939 10.2366 2.6419 10.7806 4.4554L15.135 18.9699L17.8201 12.2572C18.1238 11.4979 18.8592 11 19.677 11H23V13L19.677 13L16.992 19.7127C16.2888 21.4706 13.7634 21.3581 13.2194 19.5446L8.865 5.03009L6.17992 11.7428C5.87619 12.5021 5.14078 13 4.32297 13H1V11H4.32297L7.00804 4.28731Z"
  })),
  name: 'ActivityIcon',
  tags: ["activity", "chart", "graph"],
  category: 'data'
};
var AddCalendarIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 9.39978H6.00039V10.9998H4.40039V9.39978Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00039 13.3999H4.40039V14.9999H6.00039V13.3999Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.40039 9.39978H10.0004V10.9998H8.40039V9.39978Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15 19V17H13V15H15V13H17V15H19V17H17V19H15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 9.14002V3.99997C17.4 2.8954 16.5045 1.99997 15.4 1.99997H13.4004V1.3999H11.4004V1.99997H7V1.3999H5V1.99997H3C1.89543 1.99997 1 2.8954 1 3.99997V16.3999C1 17.5045 1.89543 18.3999 3 18.3999H9.42224C10.4017 21.0839 12.9771 23 16 23C19.866 23 23 19.866 23 16C23 12.6134 20.5951 9.78859 17.4 9.14002ZM5 3.99997V4.59989H7V3.99997H11.4004V4.59989H13.4004V3.99997H15.4V5.99997H3V3.99997H5ZM3 7.99997V16.3999H9.01123C9.00378 16.2676 9 16.1342 9 16C9 15.6604 9.02418 15.3265 9.07092 14.9998H8.40039V13.3998H9.49885C10.07 11.973 11.0973 10.778 12.4004 9.9952V9.39978H13.6625C14.2133 9.20473 14.7957 9.07666 15.4 9.02536V7.99997H3ZM11 16C11 13.2386 13.2386 11 16 11C18.7614 11 21 13.2386 21 16C21 18.7614 18.7614 21 16 21C13.2386 21 11 18.7614 11 16Z"
  })),
  name: 'AddCalendarIcon',
  tags: ["add", "calendar", "date"],
  category: 'sasc'
};
var AppSwitcherIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10 10H14V14H10V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 2H14V6H10V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18H14V22H10V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 10H6V14H2V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 2H6V6H2V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 18H6V22H2V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10H22V14H18V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 2H22V6H18V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 18H22V22H18V18Z"
  })),
  name: 'AppSwitcherIcon',
  tags: ["app", "switcher"],
  category: 'navigation'
};
var ArchiveIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 9C2 7.89543 2.89543 7 4 7H20C21.1046 7 22 7.89543 22 9V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V9ZM20 9H4V20H20V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H21C22.1046 2 23 2.89543 23 4V7C23 8.10457 22.1046 9 21 9H3C1.89543 9 1 8.10457 1 7V4ZM21 4H3V7H21V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13H8V11H16V13Z"
  })),
  name: 'ArchiveIcon',
  tags: ["archive", "files"],
  category: 'system'
};
var ArrowDiagonalBackIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6H15V8H9.41421L17.9142 16.5L16.5 17.9142L8 9.41421V15H6V6Z"
  })),
  name: 'ArrowDiagonalBackIcon',
  tags: ["arrow", "diagonal", "left", "back", "directions"],
  category: 'navigation'
};
var ArrowDiagonalForwardIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5 6H8.5V8H14.0858L5.58579 16.5L7 17.9142L15.5 9.41421V15H17.5V6Z"
  })),
  name: 'ArrowDiagonalForwardIcon',
  tags: ["arrow", "diagonal", "right", "forward", "directions"],
  category: 'navigation'
};
var ArrowDownIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 17.5858V4H13V17.5858L16.2929 14.2929L17.7071 15.7071L12 21.4142L6.29291 15.7071L7.70712 14.2929L11 17.5858Z"
  })),
  name: 'ArrowDownIcon',
  tags: ["arrow", "down", "directions"],
  category: 'navigation'
};
var ArrowLeftIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41424 11L20 11V13L6.41424 13L9.70714 16.2929L8.29292 17.7071L2.58582 12L8.29292 6.29289L9.70714 7.70711L6.41424 11Z"
  })),
  name: 'ArrowLeftIcon',
  tags: ["arrow", "left", "directions"],
  category: 'navigation'
};
var ArrowRightIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5858 13L4 13L4 11L17.5858 11L14.2929 7.70711L15.7071 6.29289L21.4142 12L15.7071 17.7071L14.2929 16.2929L17.5858 13Z"
  })),
  name: 'ArrowRightIcon',
  tags: ["arrow", "right", "directions"],
  category: 'navigation'
};
var ArrowUpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6.41421L13 20H11L11 6.41421L7.70712 9.7071L6.29291 8.29289L12 2.58578L17.7071 8.29289L16.2929 9.70711L13 6.41421Z"
  })),
  name: 'ArrowUpIcon',
  tags: ["arrow", "up", "directions"],
  category: 'navigation'
};
var ArrowsHorizontalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.41424 16L20 16V18H6.41424L8.70714 20.2929L7.29292 21.7071L2.58582 17L7.29292 12.2929L8.70714 13.7071L6.41424 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5858 8L4.00003 8L4.00003 6L17.5858 6L15.2929 3.70711L16.7071 2.29289L21.4142 7L16.7071 11.7071L15.2929 10.2929L17.5858 8Z"
  })),
  name: 'ArrowsHorizontalIcon',
  tags: ["arrows", "horizontal", "directions"],
  category: 'navigation'
};
var ArrowsVerticalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.5858V4H18V17.5858L20.2929 15.2929L21.7071 16.7071L17 21.4142L12.2929 16.7071L13.7071 15.2929L16 17.5858Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 6.41421L8.00001 20H6.00001L6.00001 6.41421L3.70712 8.7071L2.29291 7.29289L7.00001 2.58578L11.7071 7.29289L10.2929 8.70711L8.00001 6.41421Z"
  })),
  name: 'ArrowsVerticalIcon',
  tags: ["arrows", "vertical", "directions"],
  category: 'navigation'
};
var BackroomLocationManagementIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.001 21.0002C10.001 19.8957 10.8964 19.0002 12.001 19.0002C13.1055 19.0002 14.001 19.8957 14.001 21.0002C14.001 22.1048 13.1055 23.0002 12.001 23.0002C10.8964 23.0002 10.001 22.1048 10.001 21.0002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.00098 21.0002C3.00098 19.8957 3.89641 19.0002 5.00098 19.0002C6.10555 19.0002 7.00098 19.8957 7.00098 21.0002C7.00098 22.1048 6.10555 23.0002 5.00098 23.0002C3.89641 23.0002 3.00098 22.1048 3.00098 21.0002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.0005 20.9998C17.0005 19.8952 17.8959 18.9998 19.0005 18.9998C20.1051 18.9998 21.0005 19.8952 21.0005 20.9998C21.0005 22.1043 20.1051 22.9998 19.0005 22.9998C17.8959 22.9998 17.0005 22.1043 17.0005 20.9998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9999 3C9.42206 3 7.3999 4.99966 7.3999 7.38462C7.3999 8.33421 7.71566 9.21377 8.25782 9.93489L8.30127 9.99152L11.9999 14.4366L15.6985 9.99154L15.742 9.93488C16.2842 9.21375 16.5999 8.3342 16.5999 7.38462C16.5999 4.99966 14.5777 3 11.9999 3ZM5.3999 7.38462C5.3999 3.82189 8.39215 1 11.9999 1C15.6077 1 18.5999 3.82189 18.5999 7.38462C18.5999 8.79063 18.1291 10.09 17.3369 11.1416L17.3316 11.1487L17.2612 11.2404L11.9999 17.5634L6.73859 11.2404L6.66284 11.1416C5.87068 10.0901 5.3999 8.79063 5.3999 7.38462ZM11.9999 6.73333C11.5213 6.73333 11.1332 7.12135 11.1332 7.6C11.1332 8.07865 11.5213 8.46667 11.9999 8.46667C12.4785 8.46667 12.8666 8.07865 12.8666 7.6C12.8666 7.12135 12.4785 6.73333 11.9999 6.73333ZM9.13323 7.6C9.13323 6.01678 10.4167 4.73333 11.9999 4.73333C13.5831 4.73333 14.8666 6.01678 14.8666 7.6C14.8666 9.18322 13.5831 10.4667 11.9999 10.4667C10.4167 10.4667 9.13323 9.18322 9.13323 7.6Z"
  })),
  name: 'BackroomLocationManagementIcon',
  tags: ["backroom", "location", "management"],
  category: 'sasc'
};
var BackstockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.99991 7C6.79077 7 4.99991 8.79086 4.99991 11H2.99991C2.99991 7.68629 5.6862 5 8.99991 5H14.9999C18.3136 5 20.9999 7.68629 20.9999 11V13C20.9999 16.3137 18.3136 19 14.9999 19L5.41412 19L7.70701 21.2929L6.2928 22.7071L1.58569 18L6.2928 13.2929L7.70701 14.7071L5.41412 17L14.9999 17C17.209 17 18.9999 15.2091 18.9999 13V11C18.9999 8.79086 17.209 7 14.9999 7H8.99991Z"
  })),
  name: 'BackstockIcon',
  tags: ["backstock", "arrow"],
  category: 'sasc'
};
var BadgeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V3ZM19 3L5 3V21H19V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C10.8954 10 10 10.8954 10 12C10 13.1046 10.8954 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8 12C8 9.79086 9.79086 8 12 8C14.2091 8 16 9.79086 16 12C16 14.2091 14.2091 16 12 16C9.79086 16 8 14.2091 8 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 22C6 19.2386 8.23858 17 11 17H13C15.7614 17 18 19.2386 18 22H16C16 20.3431 14.6569 19 13 19H11C9.34315 19 8 20.3431 8 22H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 6H10V4H14V6Z"
  })),
  name: 'BadgeIcon',
  tags: ["badge", "person", "user"],
  category: 'system'
};
var BagIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.50016 1.99972C8.50018 1.44745 8.94789 0.999756 9.50016 0.999756H14.5C14.7653 0.999756 15.0196 1.10512 15.2072 1.29267C15.3947 1.48022 15.5001 1.73459 15.5 1.99981L15.4999 3.99976H19C19.5523 3.99976 20 4.44747 20 4.99976V22C20 22.5522 19.5523 23 19 23H5C4.44772 23 4 22.5522 4 22V4.99976C4 4.44747 4.44772 3.99976 5 3.99976H8.50008L8.50016 1.99972ZM10.5001 3.99976H13.4999L13.5 2.99976H10.5001L10.5001 3.99976ZM6 5.99976V21H18V5.99976H6Z"
  })),
  name: 'BagIcon',
  tags: ["bag", "order", "pickup"],
  category: 'sasc'
};
var BellIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20C11 20.5523 11.4477 21 12 21C12.5523 21 13 20.5523 13 20H15C15 21.6569 13.6569 23 12 23C10.3431 23 9 21.6569 9 20H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.94045 12.139C6.96176 12.5925 6.98291 13.0428 6.99384 13.5095C7.00822 14.1241 6.7325 14.6913 6.28037 15.0681L4 16.9684L4 18H20V16.9684L17.7196 15.0681C17.2675 14.6913 16.9918 14.1241 17.0062 13.5095C17.0171 13.0428 17.0382 12.5925 17.0596 12.139C17.0892 11.5075 17.1192 10.8698 17.1222 10.1728C17.1272 9.02949 17.0501 7.95061 16.7834 7.02275C16.5207 6.10897 16.0877 5.38642 15.402 4.88031C14.7121 4.37104 13.6568 4 12 4C10.3432 4 9.28785 4.37104 8.59797 4.88031C7.91235 5.38642 7.47932 6.10897 7.21662 7.02275C6.94988 7.95061 6.8728 9.02949 6.87778 10.1728C6.88081 10.8698 6.91078 11.5075 6.94045 12.139ZM7.41017 3.27123C8.53769 2.43891 10.0489 2 12 2C13.9511 2 15.4623 2.43891 16.5898 3.27123C17.7216 4.1067 18.3569 5.25739 18.7055 6.47017C19.0501 7.66887 19.1275 8.96989 19.1222 10.1815C19.1191 10.8832 19.0848 11.64 19.0534 12.33C19.0334 12.77 19.0147 13.1827 19.0061 13.5367L21.2804 15.4319C21.7364 15.8119 22 16.3748 22 16.9684V18C22 19.1046 21.1046 20 20 20H4C2.89543 20 2 19.1046 2 18V16.9684C2 16.3748 2.26365 15.8119 2.71963 15.4319L4.99392 13.5367C4.9853 13.1827 4.96656 12.77 4.94657 12.3301C4.91523 11.64 4.88085 10.8832 4.8778 10.1815C4.87252 8.96989 4.94987 7.66887 5.29448 6.47017C5.64313 5.25739 6.27837 4.1067 7.41017 3.27123Z"
  })),
  name: 'BellIcon',
  tags: ["bell", "ring", "alert", "notification"],
  category: 'system'
};
var BlockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("g", {
    "clip-path": "url(#clip0_6025_249)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.99998 0.833344C8.7962 0.833344 7.6042 1.07045 6.49205 1.53111C5.3799 1.99178 4.36937 2.66699 3.51817 3.5182C2.66696 4.3694 1.99175 5.37993 1.53108 6.49208C1.07042 7.60423 0.833313 8.79623 0.833313 10C0.833313 11.2038 1.07042 12.3958 1.53108 13.5079C1.99175 14.6201 2.66696 15.6306 3.51817 16.4818C4.36937 17.333 5.3799 18.0082 6.49205 18.4689C7.6042 18.9296 8.7962 19.1667 9.99998 19.1667C11.2038 19.1667 12.3958 18.9296 13.5079 18.4689C14.6201 18.0082 15.6306 17.333 16.4818 16.4818C17.333 15.6306 18.0082 14.6201 18.4689 13.5079C18.9295 12.3958 19.1666 11.2038 19.1666 10C19.1666 8.79623 18.9295 7.60423 18.4689 6.49208C18.0082 5.37993 17.333 4.3694 16.4818 3.5182C15.6306 2.667 14.6201 1.99178 13.5079 1.53111C12.3958 1.07045 11.2038 0.833344 9.99998 0.833344ZM7.12985 3.07091C8.0398 2.694 9.01507 2.50001 9.99998 2.50001C10.9849 2.50001 11.9602 2.694 12.8701 3.07091C13.5223 3.34107 14.1318 3.7014 14.6812 4.14029L4.14026 14.6812C3.70136 14.1318 3.34103 13.5223 3.07088 12.8701C2.69397 11.9602 2.49998 10.9849 2.49998 10C2.49998 9.01509 2.69397 8.03983 3.07088 7.12988C3.44779 6.21994 4.00024 5.39315 4.69668 4.69671C5.39312 4.00027 6.21991 3.44782 7.12985 3.07091ZM5.31877 15.8597C5.86816 16.2986 6.47765 16.659 7.12985 16.9291C8.0398 17.306 9.01507 17.5 9.99998 17.5C10.9849 17.5 11.9602 17.306 12.8701 16.9291C13.78 16.5522 14.6068 15.9998 15.3033 15.3033C15.9997 14.6069 16.5522 13.7801 16.9291 12.8701C17.306 11.9602 17.5 10.9849 17.5 10C17.5 9.0151 17.306 8.03983 16.9291 7.12989C16.6589 6.47768 16.2986 5.86819 15.8597 5.3188L5.31877 15.8597Z"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6025_249"
  }, /*#__PURE__*/React.createElement("rect", {
    width: "20",
    height: "20"
  })))),
  name: 'BlockIcon',
  tags: ["block", "blocked", "not allowed"],
  category: 'status'
};
var BookIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5.67018V18.382C3 18.382 2.99973 18.3856 3.00435 18.3936C3.01101 18.4052 3.02762 18.4269 3.06007 18.4493C3.13318 18.4997 3.21294 18.5067 3.25972 18.494C4.19439 18.2396 5.47799 18 7 18C8.61022 18 9.9537 18.2682 10.8997 18.5385C10.9337 18.5482 10.9671 18.5579 11 18.5676V5.67018C10.822 5.60613 10.6041 5.53405 10.3503 5.46152C9.5463 5.23182 8.38978 5 7 5C5.16903 5 3.74424 5.4024 3 5.67018ZM13 5.67018V18.5676C13.0329 18.5579 13.0663 18.5482 13.1003 18.5385C14.0463 18.2682 15.3898 18 17 18C18.522 18 19.8056 18.2396 20.7403 18.494C20.7871 18.5067 20.8668 18.4997 20.9399 18.4493C20.9724 18.4269 20.989 18.4052 20.9957 18.3936C21.0003 18.3856 21 18.3822 21 18.3822L21 5.67018C20.2558 5.4024 18.831 5 17 5C15.6102 5 14.4537 5.23182 13.6497 5.46152C13.3959 5.53405 13.178 5.60613 13 5.67018ZM12 3.91048C11.738 3.80609 11.3661 3.67174 10.8997 3.53848C9.9537 3.26818 8.61022 3 7 3C4.80076 3 3.09767 3.50023 2.22194 3.82517C1.43194 4.1183 1 4.86883 1 5.61803V18.382C1 19.8892 2.5365 20.7636 3.78497 20.4238C4.58136 20.207 5.68656 20 7 20C8.38978 20 9.5463 20.2318 10.3503 20.4615C10.7517 20.5762 11.0631 20.6898 11.2692 20.7722C11.3722 20.8134 11.4487 20.8467 11.4966 20.8684C11.5206 20.8792 11.5374 20.8871 11.5469 20.8916L11.5537 20.8949L11.5553 20.8957L12 21.118L12.4445 20.8958L12.4455 20.8953L12.4531 20.8916C12.4626 20.8871 12.4794 20.8792 12.5034 20.8684C12.5513 20.8467 12.6278 20.8134 12.7308 20.7722C12.9369 20.6898 13.2483 20.5762 13.6497 20.4615C14.4537 20.2318 15.6102 20 17 20C18.3134 20 19.4186 20.207 20.215 20.4238C21.4635 20.7636 23 19.8892 23 18.382V5.61803C23 4.86883 22.5681 4.1183 21.7781 3.82517C20.9023 3.50023 19.1992 3 17 3C15.3898 3 14.0463 3.26818 13.1003 3.53848C12.6339 3.67174 12.262 3.80609 12 3.91048Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 10H15V8H19V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10H5V8H9V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15H15V13H19V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15H5V13H9V15Z"
  })),
  name: 'BookIcon',
  tags: ["book", "read", "library"],
  category: 'system'
};
var BookmarkFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4 3C4 2.44772 4.44772 2 5 2H19C19.5523 2 20 2.44772 20 3V21.382C20 22.1253 19.2177 22.6088 18.5528 22.2764L12.4472 19.2236C12.1657 19.0828 11.8343 19.0828 11.5528 19.2236L5.44721 22.2764C4.78231 22.6088 4 22.1253 4 21.382V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21.382C21 22.8687 19.4354 23.8357 18.1056 23.1708L12 20.118L5.89443 23.1708C4.56462 23.8357 3 22.8687 3 21.382V3ZM19 3H5V21.382L11.1056 18.3292C11.6686 18.0477 12.3314 18.0477 12.8944 18.3292L19 21.382V3Z"
  })),
  name: 'BookmarkFilledIcon',
  tags: ["bookmark", "filled", "favorite", "save"],
  category: 'toggle'
};
var BookmarkIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21.382C21 22.8687 19.4354 23.8357 18.1056 23.1708L12 20.118L5.89443 23.1708C4.56462 23.8357 3 22.8687 3 21.382V3ZM19 3H5V21.382L11.1056 18.3292C11.6686 18.0477 12.3314 18.0477 12.8944 18.3292L19 21.382V3Z"
  })),
  name: 'BookmarkIcon',
  tags: ["bookmark", "filled", "favorite", "save"],
  category: 'toggle'
};
var BoxIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.47 1.152C11.7943 0.949333 12.2057 0.949333 12.53 1.152L20.53 6.152C20.8224 6.33474 21 6.65521 21 7C21 7.34479 20.8224 7.66526 20.53 7.848L12.53 12.848C12.2057 13.0507 11.7943 13.0507 11.47 12.848L3.47 7.848C3.17762 7.66526 3 7.34479 3 7C3 6.65521 3.17762 6.33474 3.47 6.152L11.47 1.152ZM5.8868 7L12 10.8208L18.1132 7L12 3.17925L5.8868 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.51523 6.12536C3.83319 5.94913 4.22173 5.95933 4.53 6.152L12 10.8208L19.47 6.152C19.7783 5.95933 20.1668 5.94913 20.4848 6.12536C20.8027 6.30158 21 6.63647 21 7V17C21 17.3448 20.8224 17.6653 20.53 17.848L12.53 22.848C12.2057 23.0507 11.7943 23.0507 11.47 22.848L3.47 17.848C3.17762 17.6653 3 17.3448 3 17V7C3 6.63647 3.19728 6.30158 3.51523 6.12536ZM11 12.5542L5 8.80425V16.4458L11 20.1958V12.5542ZM13 20.1958L19 16.4458V8.80425L13 12.5542V20.1958Z"
  })),
  name: 'BoxIcon',
  tags: ["box", "ship", "package"],
  category: 'system'
};
var BrandIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9301 2.00036C17.431 1.95375 21.953 6.38249 21.9996 11.9301C22.0463 17.4777 17.5709 21.953 12.0699 21.9996C6.52234 22.0463 2.00036 17.6175 2.00036 12.0699C1.95375 6.52234 6.38249 2.04698 11.9301 2.00036ZM11.8835 5.35689C8.20061 5.4035 5.26365 8.38708 5.26365 12.0699C5.35689 15.7062 8.38708 18.6897 12.0233 18.6431C15.7062 18.5965 18.6431 15.6129 18.5965 11.9301C18.5499 8.24722 15.5663 5.31027 11.8835 5.35689ZM11.9301 8.48031C13.8414 8.4337 15.4265 9.9721 15.4265 11.8835C15.4731 13.7948 13.9347 15.3798 12.0233 15.3798C10.112 15.3798 8.57355 13.888 8.48032 11.9767C8.48032 10.0653 10.0187 8.48031 11.9301 8.48031Z"
  })),
  name: 'BrandIcon',
  tags: ["target", "brand", "logo"],
  category: 'system'
};
var BulkIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.04589 4.93018L4.73663 5.81842C4.90725 6.03782 4.99988 6.30783 4.99988 6.58577V18.5H21.9999V20.5H1.99988V18.5H2.99988V6.84306L1.52582 4.94752C0.887297 4.12643 1.47243 2.93018 2.51257 2.93018H8.87765C9.26326 2.93018 9.62728 3.10814 9.86411 3.41245L11.7363 5.81809C11.9071 6.03756 11.9999 6.30772 11.9999 6.58582V10.3131H9.99988V6.84328L8.51098 4.93018H4.04589Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 20.5002C10.0004 21.3287 9.32879 22.0002 8.50037 22.0002C7.67194 22.0002 7.00037 21.3287 7.00037 20.5002C7.00037 19.6718 7.67194 19.0002 8.50037 19.0002C9.32879 19.0002 10.0004 19.6718 10.0004 20.5002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9999 20.5002C20.9999 21.3287 20.3283 22.0002 19.4999 22.0002C18.6715 22.0002 17.9999 21.3287 17.9999 20.5002C17.9999 19.6718 18.6715 19.0002 19.4999 19.0002C20.3283 19.0002 20.9999 19.6718 20.9999 20.5002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.00037 20.5002C6.00037 21.3287 5.32879 22.0002 4.50037 22.0002C3.67194 22.0002 3.00037 21.3287 3.00037 20.5002C3.00037 19.6718 3.67194 19.0002 4.50037 19.0002C5.32879 19.0002 6.00037 19.6718 6.00037 20.5002Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9999 20.5002C16.9999 21.3287 16.3283 22.0002 15.4999 22.0002C14.6715 22.0002 13.9999 21.3287 13.9999 20.5002C13.9999 19.6718 14.6715 19.0002 15.4999 19.0002C16.3283 19.0002 16.9999 19.6718 16.9999 20.5002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.49986 9.00006H20.0003L20.0004 20.5L6.4999 20.5001L6.49986 9.00006ZM8.49987 11.0001L8.49989 18.5001H13.8602L13.8602 11.0001H8.49987ZM15.8602 11.0001L15.8602 18.5001L18.0003 18.5001L18.0003 11.0001H15.8602Z"
  })),
  name: 'BulkIcon',
  tags: ["bulk, flattop"],
  category: 'sasc'
};
var CalculationIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11V3H7V11H5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.2929 20.2929L20.2929 14.2929L21.7071 15.7071L15.7071 21.7071L14.2929 20.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 8H2V6H10V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.2929 21.7071L14.2929 15.7071L15.7071 14.2929L21.7071 20.2929L20.2929 21.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 8H14V6H22V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17H2V15H10V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 21H2V19H10V21Z"
  })),
  name: 'CalculationIcon',
  tags: ["calculation", "math", "calculator", "equation"],
  category: 'data'
};
var CalendarIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5V1H9V5H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5V1H17V5H15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9H3V7H21V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 11H8V13H6V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 16H8V18H6V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 11H13V13H11V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 16H13V18H11V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11H18V13H16V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 16H18V18H16V16Z"
  })),
  name: 'CalendarIcon',
  tags: ["calendar", "date", "month"],
  category: 'system'
};
var CameraIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.72435 3C9.18198 3 8.66286 3.22028 8.286 3.61034L6.72868 5.22222H3C1.89543 5.22222 1 6.11765 1 7.22222V18C1 19.1046 1.89543 20 3 20H21C22.1046 20 23 19.1046 23 18V7.22222C23 6.11765 22.1046 5.22222 21 5.22222H17.2714L15.714 3.61034C15.3372 3.22028 14.8181 3 14.2757 3H9.72435ZM9.72435 5H14.2757L16.4227 7.22222H21V18H3V7.22222L7.57735 7.22222L9.72435 5ZM12 7C9.23972 7 7 9.23972 7 12C7 14.7603 9.23972 17 12 17C14.7603 17 17 14.7603 17 12C17 9.23972 14.7603 7 12 7ZM9 12C9 10.3443 10.3443 9 12 9C13.6557 9 15 10.3443 15 12C15 13.6557 13.6557 15 12 15C10.3443 15 9 13.6557 9 12Z"
  })),
  name: 'CameraIcon',
  tags: ["camera", "photo", "picture"],
  category: 'system'
};
var CampaignIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.2579 3.84402C12.313 3.39647 13.4827 4.17088 13.4827 5.31699L13.4827 9.72664L13.5162 13.2642C13.5272 14.4216 12.3436 15.2074 11.2812 14.7479L6.85086 12.832V15.4817C6.85086 15.7279 6.77609 15.9789 6.58988 16.1769L6.58733 16.1796C6.55917 16.2097 6.45308 16.3231 6.27324 16.3988C6.11482 16.4655 5.96277 16.4778 5.85086 16.4778H3.73964C3.62773 16.4778 3.47568 16.4655 3.31725 16.3988C3.13742 16.3231 3.03133 16.2097 3.00317 16.1796L3.00062 16.1769C2.81441 15.9789 2.73964 15.7279 2.73964 15.4817V12.6876H2.64951C1.88326 12.6876 1.24951 12.0886 1.24951 11.2993V7.29857C1.24951 6.51196 1.87896 5.91432 2.64171 5.91027L6.53677 5.84661L11.2579 3.84402ZM5.90211 7.4572L2.84951 7.50709V11.0874H5.88619L5.90211 7.4572ZM4.33964 12.6876V14.8778H5.25086V12.6876H4.33964ZM7.485 11.363L11.9163 13.2794L11.8827 9.73044L11.8827 5.31699L7.50336 7.1746L7.485 11.363Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5658 3.75203L18.2389 5.20357L18.1563 5.24194L17.9274 5.3486C17.7328 5.43942 17.4613 5.56653 17.1536 5.71163C16.5367 6.00251 15.7797 6.36314 15.2055 6.64842L14.4935 5.21554C15.0833 4.92253 15.8527 4.55607 16.4712 4.26443C16.7812 4.11826 17.0547 3.99025 17.2507 3.89877L17.4816 3.79117L17.5658 3.75203ZM15.3204 8.48157H18.8495V10.0816H15.3204V8.48157ZM15.2437 11.9459L18.3853 13.3472L17.7335 14.8084L14.592 13.4071L15.2437 11.9459Z"
  })),
  name: 'CampaignIcon',
  tags: ["megaphone", "microphone", "announcement", "marketing", "feedback", "broadcast"],
  category: 'system'
};
var CancelCircleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 16.7071L7.29289 8.70711L8.70711 7.29289L16.7071 15.2929L15.2929 16.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 15.2929L15.2929 7.29289L16.7071 8.70711L8.70711 16.7071L7.29289 15.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  })),
  name: 'CancelCircleIcon',
  tags: ["cancel", "circle", "x", "close", "no", "reject"],
  category: 'system'
};
var CancelIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2929 19.7072L4.29291 5.70718L5.70712 4.29297L19.7071 18.293L18.2929 19.7072Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29291 18.293L18.2929 4.29297L19.7071 5.70718L5.70712 19.7072L4.29291 18.293Z"
  })),
  name: 'CancelIcon',
  tags: ["cancel", "x", "close", "no", "reject"],
  category: 'system'
};
var CaretDownIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18 10L12 16L6 10H18Z"
  })),
  name: 'CaretDownIcon',
  tags: ["caret", "down", "arrow", "controls"],
  category: 'navigation'
};
var CaretLeftIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14 18L8 12L14 6L14 18Z"
  })),
  name: 'CaretLeftIcon',
  tags: ["caret", "left", "arrow", "controls"],
  category: 'navigation'
};
var CaretRightIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10 6L16 12L10 18L10 6Z"
  })),
  name: 'CaretRightIcon',
  tags: ["caret", "right", "arrow", "controls"],
  category: 'navigation'
};
var CaretUpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18 14L12 8L6 14H18Z"
  })),
  name: 'CaretUpIcon',
  tags: ["caret", "up", "arrow", "controls"],
  category: 'navigation'
};
var CaretsHorizontalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14 18L20 12L14 6V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 18L4 12L10 6L10 18Z"
  })),
  name: 'CaretsHorizontalIcon',
  tags: ["carets", "horizontal", "arrow", "controls", "move"],
  category: 'navigation'
};
var CaretsVerticalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18 10L12 4L6 10H18Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 14L12 20L6 14H18Z"
  })),
  name: 'CaretsVerticalIcon',
  tags: ["carets", "vertical", "arrow", "controls", "move"],
  category: 'navigation'
};
var CartIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.1997 4.18706L1.85461 3.98936L2.14545 2.01062L4.1903 2.31117L21.0986 3.95997C22.2005 4.06742 23.0054 5.04958 22.8944 6.1511L22.3922 11.1339C22.2925 12.1226 21.482 12.8882 20.4892 12.9314L6.74851 13.5291L6.98822 15H20.6207V17H6.98822C6.00781 17 5.17195 16.2893 5.01426 15.3217L3.1997 4.18706ZM5.26493 4.42545L6.42457 11.5413L20.4022 10.9333L20.9045 5.95053L5.26493 4.42545Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00003 20C5.00003 18.8954 5.89546 18 7.00003 18C8.1046 18 9.00003 18.8954 9.00003 20C9.00003 21.1046 8.1046 22 7.00003 22C5.89546 22 5.00003 21.1046 5.00003 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 20C15 18.8954 15.8955 18 17 18C18.1046 18 19 18.8954 19 20C19 21.1046 18.1046 22 17 22C15.8955 22 15 21.1046 15 20Z"
  })),
  name: 'CartIcon',
  tags: ["cart", "checkout", "shop"],
  category: 'system'
};
var CashIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C5 3.89543 5.89543 3 7 3H21C22.1046 3 23 3.89543 23 5V15C23 16.1046 22.1046 17 21 17H7C5.89543 17 5 16.1046 5 15V5ZM21 5L7 5V15H21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9C1 7.89543 1.89543 7 3 7H6V9H3V19H18V16H20V19C20 20.1046 19.1046 21 18 21H3C1.89543 21 1 20.1046 1 19V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0036 6.31206C11.4036 7.21207 11 8.51303 11 10C11 11.487 11.4036 12.7879 12.0036 13.6879C12.6083 14.5949 13.3338 15 14 15C14.6662 15 15.3917 14.5949 15.9964 13.6879C16.5964 12.7879 17 11.487 17 10C17 8.51303 16.5964 7.21207 15.9964 6.31206C15.3917 5.40506 14.6662 5 14 5C13.3338 5 12.6083 5.40506 12.0036 6.31206ZM10.3395 5.20266C11.1826 3.93809 12.457 3 14 3C15.543 3 16.8174 3.93809 17.6605 5.20266C18.5082 6.47422 19 8.17326 19 10C19 11.8267 18.5082 13.5258 17.6605 14.7973C16.8174 16.0619 15.543 17 14 17C12.457 17 11.1826 16.0619 10.3395 14.7973C9.49182 13.5258 9 11.8267 9 10C9 8.17326 9.49182 6.47422 10.3395 5.20266Z"
  })),
  name: 'CashIcon',
  tags: ["cash", "money", "bills", "dollar"],
  category: 'system'
};
var CatalogIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 2.89543 4.89543 2 6 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H6C4.89543 22 4 21.1046 4 20V4ZM20 4L6 4V20H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 8H2V6H8V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11H10V9H18V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 15H10V13H18V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 13H2V11H8V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 18H2V16H8V18Z"
  })),
  name: 'CatalogIcon',
  tags: ["catalog", "lookup", "reference"],
  category: 'system'
};
var CautionFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7889 2.34164C13.0518 0.867548 10.9482 0.867541 10.2112 2.34164L1.8292 19.1056C1.1643 20.4354 2.13129 22 3.61806 22H20.382C21.8688 22 22.8357 20.4354 22.1708 19.1056L13.7889 2.34164ZM13 15V8H11V15H13ZM12 19C12.8285 19 13.5 18.3284 13.5 17.5C13.5 16.6716 12.8285 16 12 16C11.1716 16 10.5 16.6716 10.5 17.5C10.5 18.3284 11.1716 19 12 19Z"
  })),
  name: 'CautionFilledIcon',
  tags: ["caution", "filled", "triangle", "warning", "alert"],
  category: 'status'
};
var CautionIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13.5 17.5C13.5 18.3284 12.8285 19 12 19C11.1716 19 10.5 18.3284 10.5 17.5C10.5 16.6716 11.1716 16 12 16C12.8285 16 13.5 16.6716 13.5 17.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 8V15H11V8H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2112 2.34164C10.9482 0.867541 13.0518 0.867548 13.7889 2.34164L22.1708 19.1056C22.8357 20.4354 21.8688 22 20.382 22H3.61806C2.13129 22 1.1643 20.4354 1.8292 19.1056L10.2112 2.34164ZM12 3.23607L3.61806 20L20.382 20L12 3.23607Z"
  })),
  name: 'CautionIcon',
  tags: ["caution", "triangle", "warning", "alert"],
  category: 'status'
};
var ChartAreaIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.20557 20V2H4.20557V16.7639L6.75793 11.6592C7.32736 10.5203 8.8019 10.1965 9.79617 10.9919L11.1303 12.0592L13.0781 7.08142C13.7479 5.36972 16.1779 5.39203 16.8162 7.11576L21.5868 20H22.2056V22H4.20557C3.101 22 2.20557 21.1046 2.20557 20ZM10.367 14.0098L8.54678 12.5536L4.82359 20H8.02304L10.367 14.0098ZM12.0027 15.3183L17.8548 20H10.1707L12.0027 15.3183ZM18.7797 18.1787L12.766 13.3677L14.9406 7.81022L18.7797 18.1787Z"
  })),
  name: 'ChartAreaIcon',
  tags: ["chart", "area", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarHorizontalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H22V22H4C2.89543 22 2 21.1046 2 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6C2 4.89543 2.89543 4 4 4H14C15.1046 4 16 4.89543 16 6V8C16 9.10457 15.1046 10 14 10H4C2.89543 10 2 9.10457 2 8V6ZM14 6H4V8H14V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 14C2 12.8954 2.89543 12 4 12H18C19.1046 12 20 12.8954 20 14V16C20 17.1046 19.1046 18 18 18H4C2.89543 18 2 17.1046 2 16V14ZM18 14H4V16H18V14Z"
  })),
  name: 'ChartBarHorizontalIcon',
  tags: ["chart", "bar", "horizontal", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarLineIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2V20C2 21.1046 2.89543 22 4 22H22V20L20 20V12C20 10.8954 19.1046 10 18 10H16C14.8954 10 14 10.8954 14 12V20H12V16C12 14.8954 11.1046 14 10 14H8C6.89543 14 6 14.8954 6 16V20L4 20V2H2ZM16 12H18V20H16V12ZM8 20H10V16H8V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91917 11.908L19.9192 5.90796L19.0811 4.09204L6.08105 10.092L6.91917 11.908Z"
  })),
  name: 'ChartBarLineIcon',
  tags: ["chart", "bar", "line", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarStacked100PercentIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V4H18C19.1046 4 20 4.89543 20 6V8C20 9.10457 19.1046 10 18 10H4V12H18C19.1046 12 20 12.8954 20 14V16C20 17.1046 19.1046 18 18 18H4V20H22V22H4C2.89543 22 2 21.1046 2 20ZM15 8H18V6H15V8ZM13 6H9V8H13V6ZM7 8V6H4V8H7ZM9 14H13L13 16H9V14ZM15 14V16H18V14H15ZM7 14V16H4V14H7Z"
  })),
  name: 'ChartBarStacked100PercentIcon',
  tags: ["chart", "bar", "stacked", "100", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarStackedGroupIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H6V10C6 8.89543 6.89543 8 8 8H10C11.1046 8 12 8.89543 12 10V20H14V5C14 3.89543 14.8954 3 16 3H18C19.1046 3 20 3.89543 20 5V20H22V22H4C2.89543 22 2 21.1046 2 20ZM10 12V10H8V12H10ZM8 14V16H10V14H8ZM10 18H8V20H10V18ZM16 14V11H18V14H16ZM16 9H18V5H16V9ZM16 16H18V20H16V16Z"
  })),
  name: 'ChartBarStackedGroupIcon',
  tags: ["chart", "bar", "stacked", "group", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarStackedLineIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M2 21.1667V2H3.66667V20.3333H22V22H2.83333C2.3731 22 2 21.6269 2 21.1667Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.88868 13.9445C5.88868 13.4842 6.26178 13.1111 6.72202 13.1111H10.6109C11.0711 13.1111 11.4442 13.4842 11.4442 13.9445L11.4442 20.3995L9.77757 20.3995L9.77757 14.7778H7.55535V20.3995H5.88868V13.9445Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9106 10.0219C14.0669 9.86559 14.2789 9.77779 14.4999 9.77779H18.3888C18.849 9.77779 19.2221 10.1509 19.2221 10.6111L19.2221 20.3466H17.5555L17.5555 11.4445H15.3332V20.3466H13.6666V10.6111C13.6666 10.3901 13.7544 10.1781 13.9106 10.0219Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.1936 4.88993L6.50551 10.539L5.82762 9.01647L18.5157 3.36735L19.1936 4.88993Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.79762 18.3426H6.72884V16.6759H9.79762V18.3426Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.5754 16.2262H15.1944V14.5595H17.5754V16.2262Z"
  })),
  name: 'ChartBarStackedLineIcon',
  tags: ["chart", "bar", "stacked", "line", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarStackedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20L6 20V10C6 8.89543 6.89543 8 8 8H10C11.1046 8 12 8.89543 12 10V20H14V6C14 4.89543 14.8954 4 16 4H18C19.1046 4 20 4.89543 20 6V20L22 20V22H4C2.89543 22 2 21.1046 2 20ZM18 12V6H16V12H18ZM16 14V20H18V14H16ZM10 14V10H8V14H10ZM8 16V20H10V16H8Z"
  })),
  name: 'ChartBarStackedIcon',
  tags: ["chart", "bar", "stacked", "graph", "data", "visualization"],
  category: 'data'
};
var ChartBarVerticalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H22V22H4C2.89543 22 2 21.1046 2 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 22C6.89543 22 6 21.1046 6 20L6 10C6 8.89543 6.89543 8 8 8H10C11.1046 8 12 8.89543 12 10L12 20C12 21.1046 11.1046 22 10 22H8ZM8 10L8 20H10L10 10H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 22C14.8954 22 14 21.1046 14 20L14 6C14 4.89543 14.8954 4 16 4H18C19.1046 4 20 4.89543 20 6V20C20 21.1046 19.1046 22 18 22H16ZM16 6L16 20H18L18 6L16 6Z"
  })),
  name: 'ChartBarVerticalIcon',
  tags: ["chart", "bar", "vertical", "graph", "data", "visualization"],
  category: 'data'
};
var ChartLineIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H22V22H4C2.89543 22 2 21.1046 2 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.9398 3.34174L18.285 13.3925C17.9048 14.4379 16.7447 14.9723 15.7031 14.5817L9.42889 12.2288L3.85749 21.5145L2.14251 20.4855L7.7139 11.1998C8.2105 10.3722 9.22737 10.0173 10.1311 10.3562L16.4054 12.709L20.0602 2.65826L21.9398 3.34174Z"
  })),
  name: 'ChartLineIcon',
  tags: ["chart", "line", "graph", "data", "visualization"],
  category: 'data'
};
var ChartMaximumIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H22V22H4C2.89543 22 2 21.1046 2 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9C11.1509 9 9.55876 10.3052 9.19612 12.1184L7.98058 18.1961L6.01942 17.8039L7.23495 11.7262C7.78457 8.97812 10.1975 7 13 7C15.8025 7 18.2154 8.97812 18.765 11.7262L19.9806 17.8039L18.0194 18.1961L16.8039 12.1184C16.4412 10.3052 14.8491 9 13 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 5H7V3H18.5V5Z"
  })),
  name: 'ChartMaximumIcon',
  tags: ["chart", "maximum", "graph", "data", "visualization"],
  category: 'data'
};
var ChartMinimumIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 20V2H4V20H22V22H4C2.89543 22 2 21.1046 2 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 12C14.8491 12 16.4412 10.6948 16.8039 8.88156L18.0194 2.80388L19.9806 3.19612L18.765 9.27379C18.2154 12.0219 15.8025 14 13 14C10.1975 14 7.78457 12.0219 7.23496 9.27379L6.01942 3.19611L7.98058 2.80388L9.19612 8.88156C9.55876 10.6948 11.1509 12 13 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.5 18H7V16H18.5V18Z"
  })),
  name: 'ChartMinimumIcon',
  tags: ["chart", "minimum", "graph", "data", "visualization"],
  category: 'data'
};
var ChartParetoIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2V20C2 21.1046 2.89543 22 4 22H22V20L20 20V14C20 12.8954 19.1046 12 18 12H16C14.8954 12 14 12.8954 14 14V20H12V16C12 14.8954 11.1046 14 10 14H8C6.89543 14 6 14.8954 6 16V20L4 20V2H2ZM18 14V20H16V14H18ZM8 20H10V16H8V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9C12 10.6569 10.6569 12 9 12C7.34315 12 6 10.6569 6 9C6 7.34315 7.34315 6 9 6C9.40402 6 9.78938 6.07986 10.1412 6.22467C10.4137 5.77961 10.783 5.34914 11.2829 4.98174C12.0201 4.4399 12.9721 4.08599 14.178 3.9797C14.5955 2.82512 15.7014 2 17 2C18.6569 2 20 3.34315 20 5C20 6.65685 18.6569 8 17 8C15.6904 8 14.5768 7.16087 14.1675 5.99096C13.3639 6.08782 12.828 6.32819 12.4674 6.59326C12.0836 6.87531 11.8308 7.23493 11.6652 7.62138C11.8791 8.03416 12 8.50296 12 9ZM10 9C10 9.55228 9.55228 10 9 10C8.44772 10 8 9.55228 8 9C8 8.44772 8.44772 8 9 8C9.55228 8 10 8.44772 10 9ZM16 5.00113C16.0006 5.55289 16.4481 6 17 6C17.5523 6 18 5.55228 18 5C18 4.44772 17.5523 4 17 4C16.5166 4 16.1133 4.34302 16.0202 4.79894L16 5.00113Z"
  })),
  name: 'ChartParetoIcon',
  tags: ["chart", "pareto", "graph", "data", "visualization"],
  category: 'data'
};
var ChartPieIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4242 11.1616L18.2929 4.29289L19.7071 5.70711L13.4142 12L19.7071 18.2929L18.2929 19.7071L11.7785 13.1927L3.40614 16.9138L2.59386 15.0862L11.4242 11.1616Z"
  })),
  name: 'ChartPieIcon',
  tags: ["chart", "pie", "graph", "data", "visualization"],
  category: 'data'
};
var ChartRingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8ZM6 12C6 8.68629 8.68629 6 12 6C15.3137 6 18 8.68629 18 12C18 15.3137 15.3137 18 12 18C8.68629 18 6 15.3137 6 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 7.29289L18.2929 4.29289L19.7071 5.70711L16.7071 8.70711L15.2929 7.29289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11H7V13H2V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22V17H13V22H11Z"
  })),
  name: 'ChartRingIcon',
  tags: ["chart", "ring", "graph", "data", "visualization"],
  category: 'data'
};
var ChartWaveSquareIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M2 2V20C2 21.1046 2.89543 22 4 22H22V20H4V2H2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 4C9.89543 4 9 4.89543 9 6V11H6V13H9C10.1046 13 11 12.1046 11 11V6H13V16C13 17.1046 13.8954 18 15 18H17C18.1046 18 19 17.1046 19 16V13H22V11H19C17.8954 11 17 11.8954 17 13V16H15V6C15 4.89543 14.1046 4 13 4H11Z"
  })),
  name: 'ChartWaveSquareIcon',
  tags: ["chart", "wave", "square"],
  category: 'data'
};
var ChatIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V17.0526C23 18.1572 22.1046 19.0526 21 19.0526H11.8836L7.24991 21.9106C5.91743 22.7324 4.2 21.7739 4.2 20.2083L4.2 19.0526H3C1.89543 19.0526 1 18.1572 1 17.0526V5ZM21 5L3 5V17.0526H4.2C5.30457 17.0526 6.2 17.9481 6.2 19.0526V20.2083L10.8337 17.3504C11.1493 17.1557 11.5128 17.0526 11.8836 17.0526L21 17.0526V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 10H6V8H18V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 14H6V12H18V14Z"
  })),
  name: 'ChatIcon',
  tags: ["chat", "talk", "message", "speech"],
  category: 'system'
};
var CheckCircleFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM16.2929 7.29289L10 13.5858L7.70711 11.2929L6.29289 12.7071L9.29289 15.7071L10 16.4142L10.7071 15.7071L17.7071 8.70711L16.2929 7.29289Z"
  })),
  name: 'CheckCircleFilledIcon',
  tags: ["check", "circle", "filled", "ok", "approved", "success", "yes", "complete"],
  category: 'status'
};
var CheckCircleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 13.5858L16.2929 7.29289L17.7071 8.70711L10 16.4142L6.29289 12.7071L7.70711 11.2929L10 13.5858Z"
  })),
  name: 'CheckCircleIcon',
  tags: ["check", "circle", "ok", "approved", "success", "yes", "complete"],
  category: 'status'
};
var CheckDatesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 9.39978H6.00039V10.9998H4.40039V9.39978Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.40039 13.3999H6.00039V14.9999H4.40039V13.3999Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.0004 9.39978H8.40039V10.9998H10.0004V9.39978Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.8751 16.6483L18.293 13.2304L19.7072 14.6446L14.8751 19.4767L12.293 16.8946L13.7072 15.4804L14.8751 16.6483Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.4 9.14002V3.99997C17.4 2.8954 16.5045 1.99997 15.4 1.99997H13.4004V1.3999H11.4004V1.99997H7V1.3999H5V1.99997H3C1.89543 1.99997 1 2.8954 1 3.99997V16.3999C1 17.5045 1.89543 18.3999 3 18.3999H9.42224C10.4017 21.0839 12.9771 23 16 23C19.866 23 23 19.866 23 16C23 12.6134 20.5951 9.78859 17.4 9.14002ZM5 3.99997V4.59989H7V3.99997H11.4004V4.59989H13.4004V3.99997H15.4V5.99997H3V3.99997H5ZM3 7.99997V16.3999H9.01123C9.00378 16.2676 9 16.1342 9 16C9 15.6604 9.02418 15.3265 9.07092 14.9998H8.40039V13.3998H9.49885C10.07 11.973 11.0973 10.778 12.4004 9.9952V9.39978H13.6625C14.2133 9.20473 14.7957 9.07666 15.4 9.02536V7.99997H3ZM16 11C13.2386 11 11 13.2386 11 16C11 18.7614 13.2386 21 16 21C18.7614 21 21 18.7614 21 16C21 13.2386 18.7614 11 16 11Z"
  })),
  name: 'CheckDatesIcon',
  tags: ["check", "dates"],
  category: 'sasc'
};
var CheckIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 15.5858L19.2929 5.29291L20.7071 6.70712L9.00001 18.4142L3.29291 12.7071L4.70712 11.2929L9.00001 15.5858Z"
  })),
  name: 'CheckIcon',
  tags: ["check", "filled", "ok", "approved", "success", "yes", "complete"],
  category: 'system'
};
var CheckboxIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z"
  })),
  name: 'CheckboxIcon',
  tags: ["checkbox", "square", "box", "shape", "block"],
  category: 'system'
};
var ChecklistIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H8V5L5 5V21H19V5H16V3H19C20.1046 3 21 3.89543 21 5V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 15.5858L16.2929 9.29289L17.7071 10.7071L10 18.4142L6.29289 14.7071L7.70711 13.2929L10 15.5858Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V5C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5V3ZM15 3H9V5H15V3Z"
  })),
  name: 'ChecklistIcon',
  tags: ["checklist", "clipboard", "complete", "approved", "passed"],
  category: 'system'
};
var ChevronDownDoubleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 18.5858L4.70712 11.2929L3.29291 12.7071L12 21.4142L20.7071 12.7071L19.2929 11.2929L12 18.5858Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5858L4.70712 3.29291L3.29291 4.70712L12 13.4142L20.7071 4.70712L19.2929 3.29291L12 10.5858Z"
  })),
  name: 'ChevronDownDoubleIcon',
  tags: ["chevron", "down", "double", "arrow"],
  category: 'navigation'
};
var ChevronDownIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5858L4.70712 8.29291L3.29291 9.70712L12 18.4142L20.7071 9.70712L19.2929 8.29291L12 15.5858Z"
  })),
  name: 'ChevronDownIcon',
  tags: ["chevron", "down", "arrow"],
  category: 'navigation'
};
var ChevronLeftDoubleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.41424 12L12.7071 4.70712L11.2929 3.29291L2.58582 12L11.2929 20.7071L12.7071 19.2929L5.41424 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4142 12L20.7071 4.70712L19.2929 3.29291L10.5858 12L19.2929 20.7071L20.7071 19.2929L13.4142 12Z"
  })),
  name: 'ChevronLeftDoubleIcon',
  tags: ["chevron", "left", "double", "arrow"],
  category: 'navigation'
};
var ChevronLeftIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.41424 12L15.7071 4.70712L14.2929 3.29291L5.58582 12L14.2929 20.7071L15.7071 19.2929L8.41424 12Z"
  })),
  name: 'ChevronLeftIcon',
  tags: ["chevron", "left", "arrow"],
  category: 'navigation'
};
var ChevronRightDoubleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.4142 12L12.7071 20.7071L11.2929 19.2929L18.5858 12L11.2929 4.70712L12.7071 3.29291L21.4142 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.4142 12L4.70712 20.7071L3.29291 19.2929L10.5858 12L3.29291 4.70712L4.70712 3.29291L13.4142 12Z"
  })),
  name: 'ChevronRightDoubleIcon',
  tags: ["chevron", "right", "double", "arrow"],
  category: 'navigation'
};
var ChevronRightIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.4142 12L9.70708 20.7071L8.29286 19.2929L15.5858 12L8.29286 4.70712L9.70708 3.29291L18.4142 12Z"
  })),
  name: 'ChevronRightIcon',
  tags: ["chevron", "right", "arrow"],
  category: 'navigation'
};
var ChevronUpDoubleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.58582L20.7071 11.2929L19.2929 12.7071L12 5.41424L4.70712 12.7071L3.29291 11.2929L12 2.58582Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10.5858L20.7071 19.2929L19.2929 20.7071L12 13.4142L4.70712 20.7071L3.29291 19.2929L12 10.5858Z"
  })),
  name: 'ChevronUpDoubleIcon',
  tags: ["chevron", "up", "double", "arrow"],
  category: 'navigation'
};
var ChevronUpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.58582L20.7071 14.2929L19.2929 15.7071L12 8.41424L4.70712 15.7071L3.29291 14.2929L12 5.58582Z"
  })),
  name: 'ChevronUpIcon',
  tags: ["chevron", "up", "arrow"],
  category: 'navigation'
};
var CleaningIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.10536 2H14.4912C16.4218 2 17.9 3.56287 17.9 5.59734V6.59734H16.9C16.3682 6.59734 16.0622 6.78975 15.8743 7.01044C15.6673 7.25366 15.5514 7.59744 15.5489 7.93861C15.5494 7.9546 15.5508 7.9796 15.5536 8.01008C15.5569 8.04539 15.5615 8.08069 15.567 8.11182C15.589 8.14131 15.6146 8.1761 15.6433 8.21619C15.7398 8.35052 15.8722 8.54452 16.0291 8.79868C16.3429 9.30703 16.7546 10.0562 17.1711 11.0501C18.005 13.0399 18.855 16.0027 18.9834 19.9651C19.0201 21.0998 18.0991 22 17 22H8C6.89543 22 6 21.1046 6 20V18.1875C6 15.5531 7.52151 13.6151 8.90355 12.3956C9.60345 11.778 10.299 11.3154 10.8183 11.0071C10.9306 10.9404 11.0352 10.8807 11.1304 10.8279V7.93675L11.1307 7.9236C11.1307 7.92355 11.1308 7.91906 11.1302 7.90971C11.1295 7.89962 11.1281 7.88548 11.1254 7.86713C11.12 7.82981 11.1104 7.78165 11.0951 7.72327C11.0642 7.60531 11.0157 7.46744 10.9531 7.32453C10.8173 7.01454 10.6671 6.79657 10.5956 6.72501C10.398 6.52724 10.1281 6.41962 9.84927 6.42703L9.836 6.42738H7.09843L7.10536 2ZM12.5401 12.3497L12.5359 12.3517L12.5041 12.3667C12.474 12.381 12.4269 12.4041 12.365 12.4357C12.2412 12.4989 12.0595 12.5962 11.8392 12.7269C11.3966 12.9897 10.8096 13.381 10.2269 13.8952C9.04369 14.9393 8 16.3763 8 18.1875V20H16.9834C16.8602 16.312 16.0705 13.5984 15.3265 11.8231C14.9531 10.9321 14.5904 10.2755 14.3273 9.84925C14.1957 9.63613 14.0891 9.48064 14.0185 9.38231C13.9832 9.33316 13.957 9.2983 13.9411 9.27769L13.9254 9.25746C13.9249 9.25692 13.9246 9.25647 13.9243 9.25613L13.9125 9.24171L13.8994 9.22427C13.8452 9.15186 13.8007 9.07564 13.7639 9H13.1304V12.0846L12.5418 12.349L12.5401 12.3497ZM12.9667 7C12.9118 6.8289 12.8484 6.66684 12.785 6.52211C12.6013 6.10272 12.3305 5.63185 12.0105 5.31149C11.4284 4.72885 10.6338 4.40951 9.81078 4.42738H9.10157L9.10223 4H14.4912C14.9987 4 15.4789 4.27426 15.7262 4.78344C15.1688 4.97283 14.706 5.29746 14.3513 5.71407C14.0227 6.10011 13.803 6.54552 13.6778 7H12.9667ZM13.9237 9.25535C13.9237 9.25531 13.9243 9.25609 13.9243 9.25613Z"
  })),
  name: 'CleaningIcon',
  tags: ["cleaning", "disinfect", "spray", "safety", "clean"],
  category: 'sasc'
};
var ClipboardIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H8V5L5 5V21H19V5H16V3H19C20.1046 3 21 3.89543 21 5V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V5C17 6.10457 16.1046 7 15 7H9C7.89543 7 7 6.10457 7 5V3ZM15 3H9V5H15V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 13H7V11H17V13ZM17 17H7V15H17V17Z"
  })),
  name: 'ClipboardIcon',
  tags: ["clipboard", "notepad", "list", "todo"],
  category: 'system'
};
var ClockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6H13V12.5L16.6 15.2L15.4 16.8L11 13.5V6Z"
  })),
  name: 'ClockIcon',
  tags: ["clock", "time", "early", "late", "hour", "minute"],
  category: 'system'
};
var CloudAlertIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13 7V13H11V7H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16C12.5523 16 13 15.5523 13 15C13 14.4477 12.5523 14 12 14C11.4477 14 11 14.4477 11 15C11 15.5523 11.4477 16 12 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.50887 8.18699C5.64722 5.1572 8.57054 3 12 3C15.7256 3 18.8548 5.54578 19.7458 8.99266C22.1881 9.58923 24.0001 11.7908 24.0001 14.4166C24.0001 17.5002 21.5004 19.9999 18.4168 19.9999C18.3366 19.9999 18.2567 19.9982 18.1771 19.9948C18.1184 19.9983 18.0594 20 18 20H6C2.68629 20 0 17.3137 0 14C0 11.2006 1.91629 8.85033 4.50887 8.18699ZM12 5C9.2671 5 6.95854 6.82797 6.23521 9.32997L6.05621 9.94914L5.41838 10.0418C3.48521 10.3228 2 11.9888 2 14C2 16.2091 3.79086 18 6 18H18C18.0286 18 18.0567 17.9988 18.0843 17.9966L18.1522 17.991L18.2202 17.9946C18.2852 17.9981 18.3508 17.9999 18.4168 17.9999C20.3958 17.9999 22.0001 16.3956 22.0001 14.4166C22.0001 12.5679 20.5992 11.045 18.8017 10.8537L18.0439 10.773L17.9207 10.021C17.4539 7.17316 14.9798 5 12 5Z"
  })),
  name: 'CloudAlertIcon',
  tags: ["cloud", "alert", "warning", "caution", "error"],
  category: 'system'
};
var CloudCheckIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M16.2071 10.7071L14.7929 9.29289L10.5 13.5858L8.70711 11.7929L7.29289 13.2071L10.5 16.4142L16.2071 10.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57054 3 5.64722 5.1572 4.50887 8.18699C1.91629 8.85033 0 11.2006 0 14C0 17.3137 2.68629 20 6 20H18C18.0594 20 18.1184 19.9983 18.1771 19.9948C18.2567 19.9982 18.3366 19.9999 18.4168 19.9999C21.5004 19.9999 24.0001 17.5002 24.0001 14.4166C24.0001 11.7908 22.1881 9.58923 19.7458 8.99266C18.8548 5.54578 15.7256 3 12 3ZM6.23521 9.32997C6.95854 6.82797 9.2671 5 12 5C14.9798 5 17.4539 7.17316 17.9207 10.021L18.0439 10.773L18.8017 10.8537C20.5992 11.045 22.0001 12.5679 22.0001 14.4166C22.0001 16.3956 20.3958 17.9999 18.4168 17.9999C18.3508 17.9999 18.2852 17.9981 18.2202 17.9946L18.1522 17.991L18.0843 17.9966C18.0567 17.9988 18.0286 18 18 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997Z"
  })),
  name: 'CloudCheckIcon',
  tags: ["cloud", "check"],
  category: 'system'
};
var CloudDownloadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14.2929 11.2929L13 12.5858L13 8H11L11 12.5858L9.70711 11.2929L8.29289 12.7071L12 16.4142L15.7071 12.7071L14.2929 11.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57054 3 5.64722 5.1572 4.50887 8.18699C1.91629 8.85033 0 11.2006 0 14C0 17.3137 2.68629 20 6 20H18C18.0594 20 18.1184 19.9983 18.1771 19.9948C18.2567 19.9982 18.3366 19.9999 18.4168 19.9999C21.5004 19.9999 24.0001 17.5002 24.0001 14.4166C24.0001 11.7908 22.1881 9.58923 19.7458 8.99266C18.8548 5.54578 15.7256 3 12 3ZM6.23521 9.32997C6.95854 6.82797 9.2671 5 12 5C14.9798 5 17.4539 7.17316 17.9207 10.021L18.0439 10.773L18.8017 10.8537C20.5992 11.045 22.0001 12.5679 22.0001 14.4166C22.0001 16.3956 20.3958 17.9999 18.4168 17.9999C18.3508 17.9999 18.2852 17.9981 18.2202 17.9946L18.1522 17.991L18.0843 17.9966C18.0567 17.9988 18.0286 18 18 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997Z"
  })),
  name: 'CloudDownloadIcon',
  tags: ["cloud", "download"],
  category: 'system'
};
var CloudLockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.5 10C9.5 8.61929 10.6193 7.5 12 7.5C13.3807 7.5 14.5 8.61929 14.5 10V11C15.0523 11 15.5 11.4477 15.5 12V15.5C15.5 16.0523 15.0523 16.5 14.5 16.5H9.5C8.94771 16.5 8.5 16.0523 8.5 15.5V12C8.5 11.4477 8.94772 11 9.5 11V10ZM13.5 10V11H10.5V10C10.5 9.17157 11.1716 8.5 12 8.5C12.8284 8.5 13.5 9.17157 13.5 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57054 3 5.64722 5.1572 4.50887 8.18699C1.91629 8.85033 0 11.2006 0 14C0 17.3137 2.68629 20 6 20H18C18.0594 20 18.1184 19.9983 18.1771 19.9948C18.2567 19.9982 18.3366 19.9999 18.4168 19.9999C21.5004 19.9999 24.0001 17.5002 24.0001 14.4166C24.0001 11.7908 22.1881 9.58923 19.7458 8.99266C18.8548 5.54578 15.7256 3 12 3ZM6.23521 9.32997C6.95854 6.82797 9.2671 5 12 5C14.9798 5 17.4539 7.17316 17.9207 10.021L18.0439 10.773L18.8017 10.8537C20.5992 11.045 22.0001 12.5679 22.0001 14.4166C22.0001 16.3956 20.3958 17.9999 18.4168 17.9999C18.3508 17.9999 18.2852 17.9981 18.2202 17.9946L18.1522 17.991L18.0843 17.9966C18.0567 17.9988 18.0286 18 18 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997Z"
  })),
  name: 'CloudLockIcon',
  tags: ["cloud", "lock"],
  category: 'system'
};
var CloudOffIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M24.0001 14.4166C24.0001 15.9024 23.4198 17.2526 22.4734 18.253L21.0583 16.8379C21.6432 16.2002 22.0001 15.3501 22.0001 14.4166C22.0001 12.5679 20.5992 11.045 18.8017 10.8537L18.0439 10.773L17.9207 10.021C17.4539 7.17316 14.9798 5 12 5C11.1792 5 10.3966 5.1649 9.68382 5.46343L8.18621 3.96582C9.31968 3.34991 10.6188 3 12 3C15.7256 3 18.8548 5.54578 19.7458 8.99266C22.1881 9.58923 24.0001 11.7908 24.0001 14.4166Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.26584 6.67998L3.29297 4.70711L4.70718 3.29289L21.7072 20.2929L20.293 21.7071L18.5833 19.9975C18.528 19.9991 18.4725 19.9999 18.4168 19.9999C18.3366 19.9999 18.2567 19.9982 18.1771 19.9948C18.1184 19.9983 18.0594 20 18 20H6C2.68629 20 0 17.3137 0 14C0 11.2006 1.91629 8.85033 4.50887 8.18699C4.70856 7.65549 4.96319 7.15084 5.26584 6.67998ZM16.5859 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997C6.35596 8.91231 6.52088 8.51343 6.72457 8.13871L16.5859 18Z"
  })),
  name: 'CloudOffIcon',
  tags: ["cloud", "off", "slash", "offline"],
  category: 'system'
};
var CloudRefreshIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.6464 7.35355L12.3043 8.0114C12.2039 8.00385 12.1024 8 12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12H14C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C12.093 10 12.1846 10.0064 12.2742 10.0186L11.6464 10.6464L12.3536 11.3536L14.7071 9L12.3536 6.64645L11.6464 7.35355Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57054 3 5.64722 5.1572 4.50887 8.18699C1.91629 8.85033 0 11.2006 0 14C0 17.3137 2.68629 20 6 20H18C18.0594 20 18.1184 19.9983 18.1771 19.9948C18.2567 19.9982 18.3366 19.9999 18.4168 19.9999C21.5004 19.9999 24.0001 17.5002 24.0001 14.4166C24.0001 11.7908 22.1881 9.58923 19.7458 8.99266C18.8548 5.54578 15.7256 3 12 3ZM6.23521 9.32997C6.95854 6.82797 9.2671 5 12 5C14.9798 5 17.4539 7.17316 17.9207 10.021L18.0439 10.773L18.8017 10.8537C20.5992 11.045 22.0001 12.5679 22.0001 14.4166C22.0001 16.3956 20.3958 17.9999 18.4168 17.9999C18.3508 17.9999 18.2852 17.9981 18.2202 17.9946L18.1522 17.991L18.0843 17.9966C18.0567 17.9988 18.0286 18 18 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997Z"
  })),
  name: 'CloudRefreshIcon',
  tags: ["cloud", "refresh"],
  category: 'system'
};
var CloudUploadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.29289 11.2929L12 7.58579L15.7071 11.2929L14.2929 12.7071L13 11.4142L13 16H11L11 11.4142L9.70711 12.7071L8.29289 11.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57054 3 5.64722 5.1572 4.50887 8.18699C1.91629 8.85033 0 11.2006 0 14C0 17.3137 2.68629 20 6 20H18C18.0594 20 18.1184 19.9983 18.1771 19.9948C18.2567 19.9982 18.3366 19.9999 18.4168 19.9999C21.5004 19.9999 24.0001 17.5002 24.0001 14.4166C24.0001 11.7908 22.1881 9.58923 19.7458 8.99266C18.8548 5.54578 15.7256 3 12 3ZM6.23521 9.32997C6.95854 6.82797 9.2671 5 12 5C14.9798 5 17.4539 7.17316 17.9207 10.021L18.0439 10.773L18.8017 10.8537C20.5992 11.045 22.0001 12.5679 22.0001 14.4166C22.0001 16.3956 20.3958 17.9999 18.4168 17.9999C18.3508 17.9999 18.2852 17.9981 18.2202 17.9946L18.1522 17.991L18.0843 17.9966C18.0567 17.9988 18.0286 18 18 18H6C3.79086 18 2 16.2091 2 14C2 11.9888 3.48521 10.3228 5.41838 10.0418L6.05621 9.94914L6.23521 9.32997Z"
  })),
  name: 'CloudUploadIcon',
  tags: ["cloud", "upload"],
  category: 'system'
};
var CloudIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5C9.2671 5 6.95854 6.82797 6.23521 9.32997L6.05621 9.94914L5.41838 10.0418C3.48521 10.3228 2 11.9888 2 14C2 16.2091 3.79086 18 6 18H18C18.0286 18 18.0567 17.9988 18.0843 17.9966L18.1522 17.991L18.2202 17.9946C18.2852 17.9981 18.3508 17.9999 18.4168 17.9999C20.3958 17.9999 22.0001 16.3956 22.0001 14.4166C22.0001 12.5679 20.5992 11.045 18.8017 10.8537L18.0439 10.773L17.9207 10.021C17.4539 7.17316 14.9798 5 12 5ZM4.50887 8.18699C5.64722 5.1572 8.57054 3 12 3C15.7256 3 18.8548 5.54578 19.7458 8.99266C22.1881 9.58923 24.0001 11.7908 24.0001 14.4166C24.0001 17.5002 21.5004 19.9999 18.4168 19.9999C18.3366 19.9999 18.2567 19.9982 18.1771 19.9948C18.1184 19.9983 18.0594 20 18 20H6C2.68629 20 0 17.3137 0 14C0 11.2006 1.91629 8.85033 4.50887 8.18699Z"
  })),
  name: 'CloudIcon',
  tags: ["cloud"],
  category: 'system'
};
var CollectionIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 2.89543 6.89543 2 8 2H16C17.1046 2 18 2.89543 18 4V7H16V4H8V7H6V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 8C4 6.89543 4.89543 6 6 6H18C19.1046 6 20 6.89543 20 8V11H18V8H6V11H4V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 12C2 10.8954 2.89543 10 4 10H20C21.1046 10 22 10.8954 22 12V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V12ZM20 12H4V20H20V12Z"
  })),
  name: 'CollectionIcon',
  tags: ["collection", "group", "bunch", "unit"],
  category: 'system'
};
var CommIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3H18V5H23V17.5C23 19.433 21.433 21 19.5 21H19.625H5C2.79086 21 1 19.2091 1 17V3ZM16.3368 19C16.1208 18.5454 16 18.0368 16 17.5V5H3V17C3 18.1046 3.89543 19 5 19H16.3368ZM18 7V17.5C18 18.3284 18.6716 19 19.5 19C20.3284 19 21 18.3284 21 17.5V7H18ZM14 9H5V7H14V9ZM14 13H5V11H14V13ZM12 17H5V15H12V17Z"
  })),
  name: 'CommIcon',
  tags: ["comm", "communications", "message", "list", "note"],
  category: 'sasc'
};
var CommentIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18H15.4806L12.6793 21.5017C11.8086 22.59 10.1196 22.4764 9.40257 21.2813L7.43381 18H4C2.89543 18 2 17.1046 2 16V4ZM20 4L4 4V16H7.43381C8.13634 16 8.78735 16.3686 9.1488 16.971L11.1176 20.2523L13.9189 16.7506C14.2984 16.2762 14.8731 16 15.4806 16H20V4Z"
  })),
  name: 'CommentIcon',
  tags: ["comment", "message", "speech", "talk", "announcement"],
  category: 'system'
};
var CreateBarcodeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 4C1 2.89543 1.89543 2 3 2H18C19.1046 2 20 2.89543 20 4V10H19.899C21.1955 11.2705 22 13.0413 22 15C22 18.866 18.866 22 15 22C12.2076 22 9.7971 20.3649 8.67363 18H3C1.89543 18 1 17.1046 1 16V4ZM8.07089 16C8.02417 15.6734 8 15.3395 8 15C8 14.6778 8.02177 14.3607 8.06392 14.05H7.95005V13.2H7.25005V14.05H6.25005L6.25005 6.5L6.25005 5.5H7.95005V6.5H7.25005L7.25005 8.95002H7.95005V7.25002H8.80005H8.95005L9.65005 7.25002V6.40002H8.80005V5.55002H9.65005L10.65 5.55002V8.10002H11.35V7.25002H12.2V6.40002H11.35V5.55002H12.35V6.25002H13.05V5.55005H14.05V6.25002H14.75V7.25002H14.05V8.06391C14.3607 8.02177 14.6778 8 15 8C15.1681 8 15.3348 8.00593 15.5 8.01758V5.5H16.5V8.16109C17.0244 8.27558 17.5268 8.44884 18 8.67363V4L3 4V16H8.07089ZM13.05 8.27519V7.25002H12.35V8.51898C12.5776 8.42583 12.8112 8.34432 13.05 8.27519ZM11.4767 8.95002H11.35H10.65L10.5 8.95002L9.65005 8.95002V8.10002H8.95005V8.95002H8.10005V9.80002H7.25005V10.5H8.80005V9.80002H9.65005H9.80005H10.3137C10.6701 9.47866 11.0597 9.1934 11.4767 8.95002ZM8.93646 11.5H7.25005V12.35H8.10005V13.2H8.23359C8.39342 12.5976 8.63157 12.0271 8.93646 11.5ZM4.55005 5.50001V14.05H5.55005V5.50001H4.55005ZM10 15C10 12.2386 12.2386 10 15 10C17.7614 10 20 12.2386 20 15C20 17.7614 17.7614 20 15 20C12.2386 20 10 17.7614 10 15ZM14 11.7692V14L11.7692 14V16L14 16V18.2308H16V16H18.2308V14H16V11.7692H14Z"
  })),
  name: 'CreateBarcodeIcon',
  tags: ["create", "barcode", "new", "add"],
  category: 'sasc'
};
var CreditCardIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6C1 4.89543 1.89543 4 3 4H21C22.1046 4 23 4.89543 23 6V18C23 19.1046 22.1046 20 21 20H3C1.89543 20 1 19.1046 1 18V6ZM21 6L3 6V18H21V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 11H2V9H22V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 16H5V14H10V16ZM15 16H12V14H15V16Z"
  })),
  name: 'CreditCardIcon',
  tags: ["credit", "card", "money"],
  category: 'system'
};
var DashboardIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM21 5H3V19H21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20V4H8V20H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 10H7V8H22V10Z"
  })),
  name: 'DashboardIcon',
  tags: ["dashboard", "layout", "wireframe", "view"],
  category: 'system'
};
var DataTableIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 9H3V7H21V9H13V21H11V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 15H3V13H21V15Z"
  })),
  name: 'DataTableIcon',
  tags: ["data", "table", "grid", "excel", "spread", "sheet"],
  category: 'data'
};
var DataTreeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 10C16 8.89543 16.8954 8 18 8H20C21.1046 8 22 8.89543 22 10V12C22 13.1046 21.1046 14 20 14H18C16.8954 14 16 13.1046 16 12V10ZM20 10H18V12H20V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H6C7.10457 2 8 2.89543 8 4V6C8 7.10457 7.10457 8 6 8H4C2.89543 8 2 7.10457 2 6V4ZM6 4H4V6H6V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4H11C12.1046 4 13 4.89543 13 6V18H17V20H13C11.8954 20 11 19.1046 11 18V6H7V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10H17V12H12V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 18C16 16.8954 16.8954 16 18 16H20C21.1046 16 22 16.8954 22 18V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20V18ZM20 18H18V20H20V18Z"
  })),
  name: 'DataTreeIcon',
  tags: ["data", "tree", "branch", "fork", "relation", "merge"],
  category: 'data'
};
var DatabaseCheckIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V12H20V4L4 4V20H10V22H4C2.89543 22 2 21.1046 2 20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10H4V8H20V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16H4V14H16V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17C7.55228 17 8 17.4477 8 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 20.5858L21.2929 15.2929L22.7071 16.7071L16 23.4142L12.2929 19.7071L13.7071 18.2929L16 20.5858Z"
  })),
  name: 'DatabaseCheckIcon',
  tags: ["database", "check", "ok", "approved", "success", "health", "up"],
  category: 'data'
};
var DatabaseXIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V13H20V4L4 4V20H13V22H4C2.89543 22 2 21.1046 2 20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2929 22.7071L15.2929 16.7071L16.7071 15.2929L22.7071 21.2929L21.2929 22.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 21.2929L21.2929 15.2929L22.7071 16.7071L16.7071 22.7071L15.2929 21.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10H4V8H20V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 16H4V14H13V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17C7.55228 17 8 17.4477 8 18Z"
  })),
  name: 'DatabaseXIcon',
  tags: ["database", "x", "down", "no", "unhealthy", "bug", "rejected"],
  category: 'data'
};
var DatabaseIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 10H4V8H20V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 16H4V14H20V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 6C8 6.55228 7.55228 7 7 7C6.44772 7 6 6.55228 6 6C6 5.44772 6.44772 5 7 5C7.55228 5 8 5.44772 8 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 12C8 12.5523 7.55228 13 7 13C6.44772 13 6 12.5523 6 12C6 11.4477 6.44772 11 7 11C7.55228 11 8 11.4477 8 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8 18C8 18.5523 7.55228 19 7 19C6.44772 19 6 18.5523 6 18C6 17.4477 6.44772 17 7 17C7.55228 17 8 17.4477 8 18Z"
  })),
  name: 'DatabaseIcon',
  tags: ["database", "data", "backend", "save"],
  category: 'data'
};
var DeviceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V20C19 21.1046 18.1046 22 17 22H7C5.89543 22 5 21.1046 5 20V4ZM17 4L7 4V20H17V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11 18C11 17.4477 11.4477 17 12 17C12.5523 17 13 17.4477 13 18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18Z"
  })),
  name: 'DeviceIcon',
  tags: ["device", "mobile", "phone", "small", "screen"],
  category: 'system'
};
var DevicesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.11101 4C4.00644 4 3.11101 4.89543 3.11101 6V14.4537L2.16471 15.9105C1.30042 17.2411 2.25532 19 3.84192 19H16.2676C16.6134 19.5978 17.2597 20 18 20H21C22.1046 20 23 19.1046 23 18V11C23 9.89543 22.1046 9 21 9H20.9443V6C20.9443 4.89543 20.0489 4 18.9443 4H5.11101ZM18.9443 9V6H5.11101V13.75H16V11C16 9.89543 16.8954 9 18 9H18.9443ZM16 15.75H4.65389L3.84192 17H16V15.75ZM18 11H21V18H18V11Z"
  })),
  name: 'DevicesIcon',
  tags: ["device", "mobile", "desktop", "tablet", "phone", "computer", "laptop"],
  category: 'system'
};
var DivisionBabyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 1H3.38197C4.13951 1 4.83204 1.42801 5.17082 2.10558L5.79798 3.35989L19.4446 14.4478C20.906 15.6352 20.0664 18 18.1834 18H8C5.79086 18 4 16.2091 4 14V4.23607L3.38197 3H2V1ZM6 6.10097V14C6 15.1046 6.89543 16 8 16L18.1834 16L6 6.10097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 21C3 19.8954 3.89543 19 5 19C6.10457 19 7 19.8954 7 21C7 22.1046 6.10457 23 5 23C3.89543 23 3 22.1046 3 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 21C17 19.8954 17.8954 19 19 19C20.1046 19 21 19.8954 21 21C21 22.1046 20.1046 23 19 23C17.8954 23 17 22.1046 17 21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.4769 4.10891C12.1337 2.43898 8.85959 2.65513 6.75736 4.75736L5.34315 3.34315C8.46734 0.218951 13.5327 0.218951 16.6569 3.34315L17.364 4.05025L11.7071 9.70711L10.2929 8.2929L14.4769 4.10891Z"
  })),
  name: 'DivisionBabyIcon',
  tags: ["division", "baby", "stroller"],
  category: 'merchandising'
};
var DivisionBakeryIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.8828 3.00002C14.922 3.00002 14.9611 3.00003 15 3.00003C15.0389 3.00003 15.078 3.00002 15.1172 3.00002C16.774 2.9997 18.6785 2.99933 20.1656 3.56546C20.9632 3.86908 21.6982 4.35325 22.2238 5.12435C22.7476 5.89293 23 6.85378 23 8.00003C23 9.8098 21.7968 10.9579 21.1188 11.4665C21.0682 11.5044 21.0343 11.5458 21.0159 11.5782C21.0022 11.6024 21.0002 11.6155 21 11.6182V19C21 20.1046 20.1046 21 19 21H11C9.89543 21 9 20.1046 9 19V11.6182C8.99977 11.6155 8.99777 11.6024 8.98409 11.5782C8.9657 11.5458 8.93178 11.5044 8.88124 11.4665C8.20316 10.9579 7 9.8098 7 8.00003C7 6.85378 7.25241 5.89293 7.77622 5.12435C8.30175 4.35325 9.03682 3.86908 9.83435 3.56546C11.3215 2.99933 13.226 2.9997 14.8828 3.00002ZM9.42889 6.25071C9.18597 6.60714 9 7.14629 9 8.00003C9 8.85663 9.57422 9.48621 10.0813 9.86658C10.5714 10.2342 11 10.8516 11 11.6181V19H19V11.6181C19 10.8516 19.4286 10.2342 19.9187 9.86658C20.4258 9.48621 21 8.85663 21 8.00003C21 7.14629 20.814 6.60714 20.5711 6.25071C20.3299 5.89681 19.9699 5.63098 19.4541 5.4346C18.3496 5.01413 16.8093 5.00003 15 5.00003C13.1907 5.00003 11.6504 5.01413 10.5459 5.4346C10.0301 5.63098 9.67008 5.89681 9.42889 6.25071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.88281 3.00002C8.92201 3.00002 8.96108 3.00003 9 3.00003L15 3.00003V5.00003H9C7.19072 5.00003 5.6504 5.01413 4.54593 5.4346C4.03008 5.63098 3.67008 5.89681 3.42889 6.25071C3.18597 6.60714 3 7.14629 3 8.00003C3 8.85663 3.57422 9.48621 4.08132 9.86658C4.5714 10.2342 5 10.8516 5 11.6181V19H14V21H5C3.89543 21 3 20.1046 3 19V11.6182C2.99977 11.6155 2.99777 11.6024 2.98409 11.5782C2.9657 11.5458 2.93178 11.5044 2.88124 11.4665C2.20316 10.9579 1 9.8098 1 8.00003C1 6.85378 1.25241 5.89293 1.77622 5.12435C2.30175 4.35325 3.03682 3.86908 3.83435 3.56546C5.32146 2.99933 7.22596 2.9997 8.88281 3.00002Z"
  })),
  name: 'DivisionBakeryIcon',
  tags: ["division", "bakery", "toast", "bread"],
  category: 'merchandising'
};
var DivisionBeautyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.8292 18.8944C1.1643 17.5646 2.1313 16 3.61806 16H20.382C21.8688 16 22.8357 17.5646 22.1708 18.8944L21.1708 20.8944C20.8321 21.572 20.1395 22 19.382 22H4.61806C3.86052 22 3.16799 21.572 2.8292 20.8944L1.8292 18.8944ZM20.382 18H3.61806L4.61806 20H19.382L20.382 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C8.13403 4 5.00003 7.13401 5.00003 11C5.00003 13.0906 5.91522 14.9661 7.37011 16.2503L6.04664 17.7497C4.17985 16.1021 3.00003 13.6882 3.00003 11C3.00003 6.02944 7.02946 2 12 2C16.9706 2 21 6.02944 21 11C21 13.6882 19.8202 16.1021 17.9534 17.7497L16.6299 16.2503C18.0848 14.9661 19 13.0906 19 11C19 7.13401 15.866 4 12 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29292 12.2929L13.2929 6.29289L14.7071 7.70711L8.70713 13.7071L7.29292 12.2929ZM11.2929 13.2929L14.2929 10.2929L15.7071 11.7071L12.7071 14.7071L11.2929 13.2929Z"
  })),
  name: 'DivisionBeautyIcon',
  tags: ["division", "beauty", "mirror", "makeup"],
  category: 'merchandising'
};
var DivisionCenterStoreGroceryIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14C8 10.6863 10.6863 8 14 8H16C19.3137 8 22 10.6863 22 14V20C22 21.1046 21.1046 22 20 22H10C8.89543 22 8 21.1046 8 20V14ZM14 10C11.7909 10 10 11.7909 10 14V20H20V14C20 11.7909 18.2091 10 16 10H14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4C13.8954 4 13 4.89543 13 6C13 7.10457 13.8954 8 15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4ZM11 6C11 3.79086 12.7909 2 15 2C17.2091 2 19 3.79086 19 6C19 8.20914 17.2091 10 15 10C12.7909 10 11 8.20914 11 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.89543 2.89543 5 4 5H12V7H4V20H13V22H4C2.89543 22 2 21.1046 2 20V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 16H12V14H18V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 12H3V10H10V12Z"
  })),
  name: 'DivisionCenterStoreGroceryIcon',
  tags: ["division", "center", "store", "grocery", "person", "user"],
  category: 'merchandising'
};
var DivisionDecorIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.89543 3.89543 9 5 9H19C20.1046 9 21 9.89543 21 11V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V11ZM19 11H5V21H19V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6625 1.25097L12 2L11.3375 1.25097C11.7158 0.916342 12.2842 0.916342 12.6625 1.25097ZM12 3.3811C11.7731 3.60879 11.5119 3.88233 11.2524 4.1788C10.897 4.58478 10.5639 5.01194 10.325 5.40789C10.0681 5.83374 10 6.09469 10 6.2C10 7.13025 10.8293 8 12 8C13.1707 8 14 7.13025 14 6.2C14 6.09469 13.9319 5.83374 13.675 5.40789C13.4361 5.01194 13.103 4.58478 12.7476 4.1788C12.4881 3.88233 12.2269 3.60879 12 3.3811ZM11.3375 1.25097C11.3375 1.25097 11.3375 1.25097 12 2C12.6625 1.25097 12.6625 1.25097 12.6625 1.25097L12.6664 1.25442L12.6746 1.26172L12.7034 1.28752C12.7278 1.30958 12.7627 1.34125 12.8065 1.38161C12.894 1.46226 13.0176 1.57792 13.1652 1.72116C13.4592 2.0065 13.8543 2.4067 14.2524 2.8614C14.647 3.31213 15.0639 3.83832 15.3875 4.37483C15.6931 4.88146 16 5.53211 16 6.2C16 8.36254 14.143 10 12 10C9.85696 10 8 8.36254 8 6.2C8 5.53211 8.30687 4.88146 8.61248 4.37483C8.93613 3.83832 9.35301 3.31213 9.74759 2.8614C10.1457 2.4067 10.5408 2.0065 10.8348 1.72116C10.9824 1.57792 11.106 1.46226 11.1935 1.38161C11.2373 1.34125 11.2722 1.30958 11.2966 1.28752L11.3254 1.26172L11.3336 1.25442L11.3375 1.25097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 19H8V17H16V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15H4V13H20V15Z"
  })),
  name: 'DivisionDecorIcon',
  tags: ["division", "decor", "candle"],
  category: 'merchandising'
};
var DivisionDecorativeHomeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4V20H3L3 4L21 4ZM19 6L5 6L5 18H19V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3L23 3V5L20 5V3ZM20 7H23V9H20V7ZM20 11H23V13H20V11ZM20 15H23V17H20V15ZM20 19H23V21H20V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 3L4 3V5L1 5L1 3ZM1 7H4L4 9H1L1 7ZM1 11H4L4 13H1L1 11ZM1 15H4V17H1L1 15ZM1 19H4V21H1L1 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4383 7.35139C11.2389 6.35058 12.7611 6.35058 13.5617 7.35139L16.2811 10.7506C16.8655 11.481 16.8655 12.519 16.2811 13.2494L13.5617 16.6486C12.7611 17.6494 11.2389 17.6494 10.4383 16.6486L7.71889 13.2494C7.13454 12.519 7.13454 11.481 7.71889 10.7506L9.28063 12L12 15.3992L14.7194 12L12 8.60078L9.28063 12L7.71889 10.7506L10.4383 7.35139Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 11H8V13H4L4 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11L20 11V13L16 13V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 8V4H13V8H11ZM11 20V16H13V20H11Z"
  })),
  name: 'DivisionDecorativeHomeIcon',
  tags: ["division", "decorative", "home", "rug"],
  category: 'merchandising'
};
var DivisionDeliIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.3039 3.23909C14.5907 3.08467 14.9276 2.99317 15.2846 3.00455C19.699 3.14528 23 6.5467 23 11V19C23 20.1046 22.1046 21 21 21H20C18.8475 21 18.1437 20.0762 17.8907 19.3453C17.6191 18.5609 16.8738 18 16 18C15.1262 18 14.3809 18.5609 14.1093 19.3453C13.8563 20.0762 13.1525 21 12 21H3C1.89543 21 1 20.1046 1 19V18C1 17.4197 1.25277 16.9526 1.53874 16.6191C1.82036 16.2908 2.16853 16.0482 2.47879 15.8784C2.79154 15.7072 3 15.3772 3 15C3 14.6228 2.79154 14.2929 2.47879 14.1217C2.16853 13.9518 1.82036 13.7093 1.53874 13.3809C1.25277 13.0475 1 12.5804 1 12V11.5973C1 10.8616 1.40398 10.1852 2.0518 9.83638L14.3039 3.23909ZM15.2441 5.00432L3 11.5973L3 11.9939C3.00384 12.0048 3.01706 12.0325 3.05689 12.0789C3.13365 12.1684 3.26496 12.272 3.43915 12.3673C4.36711 12.8753 5 13.863 5 15C5 16.137 4.36711 17.1247 3.43915 17.6327C3.26496 17.7281 3.13365 17.8316 3.05689 17.9211C3.01706 17.9676 3.00384 17.9953 3 18.0062V19H11.9973C12.0048 18.9974 12.0226 18.9886 12.0511 18.9628C12.1099 18.9097 12.1768 18.814 12.2194 18.691C12.7612 17.1261 14.2478 16 16 16C17.7522 16 19.2388 17.1261 19.7806 18.691C19.8232 18.814 19.8901 18.9097 19.9489 18.9628C19.9774 18.9886 19.9952 18.9974 20.0027 19H21V11C21 7.63061 18.5638 5.12147 15.2441 5.00432Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12H2V10H22V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 16C9 16.5523 8.55228 17 8 17C7.44772 17 7 16.5523 7 16C7 15.4477 7.44772 15 8 15C8.55228 15 9 15.4477 9 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 14C13 14.5523 12.5523 15 12 15C11.4477 15 11 14.5523 11 14C11 13.4477 11.4477 13 12 13C12.5523 13 13 13.4477 13 14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8.00003C17 8.55231 16.5523 9.00003 16 9.00003C15.4477 9.00003 15 8.55231 15 8.00003C15 7.44774 15.4477 7.00003 16 7.00003C16.5523 7.00003 17 7.44774 17 8.00003Z"
  })),
  name: 'DivisionDeliIcon',
  tags: ["division", "deli", "cheese", "food"],
  category: 'merchandising'
};
var DivisionDomesticsIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 13C1 11.8954 1.89543 11 3 11H21C22.1046 11 23 11.8954 23 13V19H1V13ZM21 13H3V17H21V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 5C2 3.89543 2.89543 3 4 3H20C21.1046 3 22 3.89543 22 5V11C22 12.1046 21.1046 13 20 13H4C2.89543 13 2 12.1046 2 11V5ZM20 5H4V11H20V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9C6 7.89543 6.89543 7 8 7H16C17.1046 7 18 7.89543 18 9V11C18 12.1046 17.1046 13 16 13H8C6.89543 13 6 12.1046 6 11V9ZM16 9H8V11H16V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 21V18H3V21H1ZM21 21V18H23V21H21Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12V8H13V12H11Z"
  })),
  name: 'DivisionDomesticsIcon',
  tags: ["division", "domestics", "bed", "home", "sleep"],
  category: 'merchandising'
};
var DivisionElectronicsIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 5H7V3H17V5ZM17 15H7V13H17V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 9V17.5279C3 18.3409 3.6591 19 4.47214 19C5.02974 19 5.53949 18.685 5.78885 18.1862L8.10557 13.5528L9.89443 14.4472L7.57771 19.0807C6.98956 20.257 5.78728 21 4.47214 21C2.55453 21 1 19.4455 1 17.5279V9H3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 17.5279V9H23V17.5279C23 19.4455 21.4455 21 19.5279 21C18.2127 21 17.0104 20.257 16.4223 19.0807L14.1056 14.4472L15.8944 13.5528L18.2111 18.1862C18.4605 18.685 18.9703 19 19.5279 19C20.3409 19 21 18.3409 21 17.5279Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 5C4.79086 5 3 6.79086 3 9C3 11.2091 4.79086 13 7 13V15C3.68629 15 1 12.3137 1 9C1 5.68629 3.68629 3 7 3V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 9C21 6.79086 19.2091 5 17 5V3C20.3137 3 23 5.68629 23 9C23 12.3137 20.3137 15 17 15V13C19.2091 13 21 11.2091 21 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 7C16 6.44772 16.4477 6 17 6C17.5523 6 18 6.44772 18 7C18 7.55228 17.5523 8 17 8C16.4477 8 16 7.55228 16 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 11C16 10.4477 16.4477 10 17 10C17.5523 10 18 10.4477 18 11C18 11.5523 17.5523 12 17 12C16.4477 12 16 11.5523 16 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 9C14 8.44772 14.4477 8 15 8C15.5523 8 16 8.44772 16 9C16 9.55228 15.5523 10 15 10C14.4477 10 14 9.55228 14 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 9C18 8.44772 18.4477 8 19 8C19.5523 8 20 8.44772 20 9C20 9.55228 19.5523 10 19 10C18.4477 10 18 9.55228 18 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 10H5V8H9V10Z"
  })),
  name: 'DivisionElectronicsIcon',
  tags: ["division", "electronics", "headphones", "music"],
  category: 'merchandising'
};
var DivisionEntertainmentIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16C2 14.8954 2.89543 14 4 14H6C7.10457 14 8 14.8954 8 16V20C8 21.1046 7.10457 22 6 22H4C2.89543 22 2 21.1046 2 20V16ZM6 16H4V20H6V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C16 14.8954 16.8954 14 18 14H20C21.1046 14 22 14.8954 22 16V20C22 21.1046 21.1046 22 20 22H18C16.8954 22 16 21.1046 16 20V16ZM20 16H18V20H20V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 4C7.58172 4 4 7.58172 4 12V16H2V12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12V16H20V12C20 7.58172 16.4183 4 12 4Z"
  })),
  name: 'DivisionEntertainmentIcon',
  tags: ["division", "entertainment", "video", "game", "controller"],
  category: 'merchandising'
};
var DivisionFoodServiceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.81106 2.11765C6.14741 1.43345 6.8435 1 7.6059 1H16.3941C17.1565 1 17.8526 1.43345 18.1889 2.11765L18.6227 3H19.2192C20.137 3 20.9369 3.62459 21.1595 4.51493L21.6595 6.51493C21.9751 7.77722 21.0204 9 19.7192 9H4.28077C2.97963 9 2.02491 7.77722 2.34049 6.51493L2.84049 4.51493C3.06307 3.62459 3.86304 3 4.78077 3L5.37729 3L5.81106 2.11765ZM16.3941 3H7.6059L7.17213 3.88235C6.83578 4.56655 6.1397 5 5.37729 5L4.78077 5L4.28077 7L19.7192 7L19.2192 5H18.6227C17.8603 5 17.1642 4.56655 16.8279 3.88235L16.3941 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.1731 9.28284C4.00098 8.07797 4.93591 7 6.153 7H17.847C19.0641 7 19.999 8.07798 19.8269 9.28284L18.1126 21.2828C17.9718 22.2681 17.128 23 16.1327 23H7.86729C6.87199 23 6.02815 22.2681 5.88739 21.2828L4.1731 9.28284ZM17.847 9H6.153L7.86729 21H16.1327L17.847 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 13C11.4477 13 11 13.4477 11 14C11 14.5523 11.4477 15 12 15C12.5523 15 13 14.5523 13 14C13 13.4477 12.5523 13 12 13ZM8.99999 14C8.99999 12.3431 10.3431 11 12 11C13.6568 11 15 12.3431 15 14C15 15.6569 13.6568 17 12 17C10.3431 17 8.99999 15.6569 8.99999 14Z"
  })),
  name: 'DivisionFoodServiceIcon',
  tags: ["division", "food", "service", "coffee", "latte", "beverage", "cup"],
  category: 'merchandising'
};
var DivisionHealthcareIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V8ZM20 8L4 8V20H20V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18V10H13V18H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 15H8V13H16V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 4C7 2.89543 7.89543 2 9 2H15C16.1046 2 17 2.89543 17 4V7H15V4H9V7H7V4Z"
  })),
  name: 'DivisionHealthcareIcon',
  tags: ["division", "healthcare", "fix", "medical", "doctor", "help"],
  category: 'merchandising'
};
var DivisionHouseholdPaperPetIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71073 5.87272C3.29169 6.50129 3 7.42725 3 8.5C3 9.57275 3.29169 10.4987 3.71073 11.1273C4.13443 11.7628 4.60996 12 5 12H15.0246C14.3691 11.013 14 9.76453 14 8.5C14 7.23547 14.3691 5.98702 15.0246 5H5C4.60996 5 4.13443 5.23716 3.71073 5.87272ZM18.5 3H5C3.73319 3 2.70871 3.7702 2.04663 4.76332C1.37989 5.76343 1 7.08747 1 8.5C1 9.91253 1.37989 11.2366 2.04663 12.2367C2.30971 12.6313 2.63001 12.9907 3 13.2806V18.4612C3 19.9086 4.4897 20.8767 5.81228 20.2889L5.40614 19.375L5.81228 20.2889L6.25 20.0943L7.68772 20.7333L8.09386 19.8195L7.68772 20.7333C8.20485 20.9631 8.79515 20.9631 9.31228 20.7333L8.90614 19.8195L9.31228 20.7333L10.75 20.0943L12.1877 20.7333C12.7049 20.9631 13.2951 20.9631 13.8123 20.7333L15.25 20.0943L16.6877 20.7333C17.2049 20.9631 17.7951 20.9631 18.3123 20.7333L19.75 20.0943L20.1877 20.2889C21.5058 20.8747 23 19.9166 23 18.4643V8.5C23 5.71088 21.2046 3 18.5 3ZM21 8.5C21 6.31856 19.6614 5 18.5 5C17.3386 5 16 6.31856 16 8.5C16 10.6814 17.3386 12 18.5 12C19.6614 12 21 10.6814 21 8.5ZM21 13.0904L21 18.4612L20.5623 18.2667C20.0451 18.0369 19.4549 18.0369 18.9377 18.2667L17.5 18.9057L16.0623 18.2667C15.5451 18.0369 14.9549 18.0369 14.4377 18.2667L13 18.9057L11.5623 18.2667C11.0451 18.0369 10.4549 18.0369 9.93772 18.2667L8.5 18.9057L7.06228 18.2667C6.54515 18.0369 5.95485 18.0369 5.43772 18.2667L5 18.4612V14H18.5C19.4615 14 20.3081 13.6574 21 13.0904Z"
  })),
  name: 'DivisionHouseholdPaperPetIcon',
  tags: ["division", "household", "paper", "pet"],
  category: 'merchandising'
};
var DivisionIntimatesHosierySleepwareIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 10.1397V3H4V10.9098L3.16682 15.4923C2.49863 19.1674 5.9086 22.1497 9.44362 21.397C10.6079 21.149 11.5317 21 12 21C12.4683 21 13.3921 21.149 14.5564 21.397C18.0914 22.1497 21.5014 19.1674 20.8332 15.4923L20 10.9098V3H18V10.1397C17.828 10.1805 17.6381 10.2332 17.4338 10.3013C16.5541 10.5946 15.4151 11.1707 14.2929 12.2929C13.4332 13.1526 12.7502 14.01 12.2422 14.7245C12.2299 14.7418 12.159 14.8077 12 14.8077C11.841 14.8077 11.7701 14.7418 11.7578 14.7245C11.2498 14.01 10.5668 13.1526 9.70711 12.2929C8.58495 11.1707 7.44594 10.5946 6.56623 10.3013C6.36188 10.2332 6.17199 10.1805 6 10.1397ZM18.1942 12.158C18.1527 12.1705 18.1101 12.1841 18.0662 12.1987C17.4459 12.4054 16.5849 12.8293 15.7071 13.7071C14.9413 14.4729 14.3291 15.2409 13.8722 15.8835C13.4069 16.5378 12.6594 16.8077 12 16.8077C11.3406 16.8077 10.5931 16.5378 10.1278 15.8835C9.67094 15.2409 9.05871 14.4729 8.2929 13.7071C7.41506 12.8293 6.55407 12.4054 5.93377 12.1987C5.88995 12.1841 5.84728 12.1705 5.80585 12.158L5.13456 15.8501C4.74235 18.0073 6.76423 19.9227 9.02708 19.4408C10.165 19.1985 11.2892 19 12 19C12.7108 19 13.835 19.1985 14.9729 19.4408C17.2358 19.9227 19.2577 18.0073 18.8654 15.8501L18.1942 12.158Z"
  })),
  name: 'DivisionIntimatesHosierySleepwareIcon',
  tags: ["division", "intimates", "hosiery", "sleepware", "bra", "underwear"],
  category: 'merchandising'
};
var DivisionJewelryAccessoriesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9492 1.78099C19.2986 1.2775 21.0096 2.33221 20.6877 4.00694C20.3379 5.82665 19.6326 8.73416 18.3469 11.211C17.0855 13.6409 15.0749 16 12 16C8.925 16 6.91437 13.6409 5.65301 11.211C4.36732 8.73416 3.66204 5.82665 3.31222 4.00694C2.99028 2.33221 4.70128 1.2775 6.05071 1.78099C7.54349 2.33796 9.79384 2.99999 12 2.99999C14.2061 2.99999 16.4564 2.33796 17.9492 1.78099ZM18.6923 3.64985C18.6796 3.64777 18.6658 3.64829 18.6483 3.65481C17.0664 4.24506 14.5553 4.99999 12 4.99999C9.44463 4.99999 6.93355 4.24506 5.35157 3.65481C5.33412 3.64829 5.32028 3.64777 5.30758 3.64985C5.29814 3.65139 5.2893 3.65448 5.28182 3.65823C5.62122 5.41544 6.28202 8.08168 7.4281 10.2895C8.6048 12.5564 10.1033 14 12 14C13.8967 14 15.3951 12.5564 16.5718 10.2895C17.7179 8.08168 18.3787 5.41544 18.7181 3.65823C18.7106 3.65448 18.7018 3.65139 18.6923 3.64985Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5857 16C11.3668 15.2189 12.6331 15.2189 13.4142 16L10.4142 19L8.99996 17.5858L10.5857 16ZM8.99996 17.5858C8.21891 18.3668 8.21891 19.6332 8.99996 20.4142L10.5857 22C11.3668 22.781 12.6331 22.781 13.4142 22L15 20.4142C15.781 19.6332 15.781 18.3668 15 17.5858L13.4142 16L12 17.4142L13.5857 19L12 20.5858L8.99996 17.5858Z"
  })),
  name: 'DivisionJewelryAccessoriesIcon',
  tags: ["division", "jewelry", "accessories", "necklace"],
  category: 'merchandising'
};
var DivisionKidsApparelIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9982 20C13.0014 19.9985 13.0109 19.9934 13.0246 19.9803C13.0586 19.9481 13.097 19.8872 13.1126 19.8089C13.6115 17.3154 15.5894 16.4488 16.7791 16.1636C16.8557 16.1453 16.924 16.1024 16.9657 16.0563C16.9849 16.0351 16.9937 16.0185 16.9972 16.0099C17.0002 16.0028 17 16.0003 17 16L17 9C17 7.89543 17.8954 7 19 7H20V4.72076L15.2705 3.14424C15.2705 3.14424 15.2706 3.14428 15.2705 3.14424C15.2681 3.14361 15.2484 3.13909 15.2051 3.14673C15.1532 3.15589 15.0846 3.17992 15.0111 3.22345C14.3992 3.58588 13.3914 4 12 4C10.6086 4 9.60078 3.58588 8.98891 3.22345C8.91542 3.17992 8.84678 3.15589 8.79487 3.14673C8.75154 3.13908 8.73222 3.1435 8.72991 3.14412L4 4.72076V7H5C6.10457 7 7 7.89543 7 9V16C6.99998 16.0003 6.99982 16.0028 7.00277 16.0099C7.00633 16.0185 7.01512 16.0351 7.03429 16.0563C7.07599 16.1024 7.14428 16.1453 7.22086 16.1636C8.41062 16.4488 10.3885 17.3154 10.8874 19.8089C10.903 19.8872 10.9414 19.9481 10.9754 19.9803C10.9891 19.9934 10.9986 19.9985 11.0018 20H11C10.9997 20 11.0004 19.9997 11.0018 20C11.0027 20.0004 11.0031 20.0003 11.0018 20C11.0021 20.0002 11.0016 19.9999 11.0018 20H12.9982ZM8.09745 1.24676C8.8195 1.00608 9.52515 1.21654 10.0082 1.50268C10.3622 1.71238 11.022 2 12 2C12.978 2 13.6378 1.71238 13.9918 1.50268C14.4749 1.21654 15.1805 1.00608 15.9025 1.24676L20.6325 2.82339C21.4491 3.09562 22 3.8599 22 4.72076V7C22 8.10457 21.1046 9 20 9H19V16C19 17.1241 18.1164 17.8998 17.2453 18.1085C16.3848 18.3148 15.3487 18.8269 15.0738 20.2012C14.8976 21.082 14.1486 22 13 22H11C9.8514 22 9.10242 21.082 8.92623 20.2012C8.65129 18.8269 7.61525 18.3148 6.7547 18.1085C5.88359 17.8998 5 17.1241 5 16V9H4C2.89543 9 2 8.10457 2 7V4.72076C2 3.8599 2.55086 3.09562 3.36754 2.82339L8.09745 1.24676Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 8C13 8.55229 12.5523 9 12 9C11.4477 9 11 8.55229 11 8C11 7.44772 11.4477 7 12 7C12.5523 7 13 7.44772 13 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 12C13 12.5523 12.5523 13 12 13C11.4477 13 11 12.5523 11 12C11 11.4477 11.4477 11 12 11C12.5523 11 13 11.4477 13 12Z"
  })),
  name: 'DivisionKidsApparelIcon',
  tags: ["division", "kids", "apparel"],
  category: 'merchandising'
};
var DivisionKitchenIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8V2H4V8H2ZM12 2V8H10V2H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 8V2H8V8H6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13H18.9402C19.5255 13 20 13.4745 20 14.0598V19C20 20.6569 18.6569 22 17 22C15.3431 22 14 20.6569 14 19V13ZM16 15V19C16 19.5523 16.4477 20 17 20C17.5523 20 18 19.5523 18 19V15H16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7H12V10C12 11.3062 11.1652 12.4175 10 12.8293V19C10 20.6569 8.65685 22 7 22C5.34315 22 4 20.6569 4 19V12.8293C2.83481 12.4175 2 11.3062 2 10V7ZM6 13V19C6 19.5523 6.44772 20 7 20C7.55228 20 8 19.5523 8 19V13H6ZM4 9V10C4 10.5523 4.44772 11 5 11H9C9.55228 11 10 10.5523 10 10V9H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 3.14634C14 2.51323 14.5132 2 15.1463 2C18.9315 2 22 5.06849 22 8.85366V13.7317C22 14.4322 21.4322 15 20.7317 15H16C14.8954 15 14 14.1046 14 13V3.14634ZM16 4.07483V13H20V8.85366C20 6.46431 18.2735 4.47821 16 4.07483Z"
  })),
  name: 'DivisionKitchenIcon',
  tags: ["division", "kitchen", "fork", "knife", "silverwear"],
  category: 'merchandising'
};
var DivisionMeatFrozenDairyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3C5 1.89543 5.89543 1 7 1H17C18.1046 1 19 1.89543 19 3V5.76393L20.7889 9.34164C20.9277 9.61935 21 9.92558 21 10.2361V20.2192C21 21.137 20.3754 21.9369 19.4851 22.1595L16.362 22.9403C16.2033 22.9799 16.0404 23 15.8769 23H5C3.89543 23 3 22.1046 3 21V10.2361C3 9.92558 3.07229 9.61935 3.21115 9.34164L5 5.76393V3ZM6.61803 7L5 10.2361V21H15.8769L19 20.2192V10.2361L18 8.23607L16.8944 10.4472L15.1056 9.55279L16.382 7H6.61803ZM17 5H7V3H17V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 11H4V9H16V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 10V21H15V10H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17H7V15H13V17Z"
  })),
  name: 'DivisionMeatFrozenDairyIcon',
  tags: ["division", "meat", "frozen", "dairy", "milk", "carton"],
  category: 'merchandising'
};
var DivisionMensIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.89543 2.89543 5 4 5H6V7H4V20H20V7H18V5H20C21.1046 5 22 5.89543 22 7V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.07612 2.61732C5.2309 2.24364 5.59554 2 6 2H18C18.4045 2 18.7691 2.24364 18.9239 2.61732C19.0787 2.99099 18.9931 3.42111 18.7071 3.70711L12.7071 9.70711C12.3166 10.0976 11.6834 10.0976 11.2929 9.70711L5.29289 3.70711C5.0069 3.42111 4.92134 2.99099 5.07612 2.61732ZM8.41421 4L12 7.58579L15.5858 4H8.41421Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.9355 5.96872L17.0513 3.31623L18.9487 2.68377L19.9487 5.68377C20.0235 5.90816 20.0163 6.15179 19.9285 6.37139L17.9285 11.3714C17.8036 11.6835 17.5303 11.912 17.2011 11.9796C16.8718 12.0472 16.5306 11.9448 16.2929 11.7071L13.2929 8.70711L14.7071 7.29289L16.6348 9.22054L17.9355 5.96872Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.05132 5.68377L5.05132 2.68377L6.94868 3.31623L6.06452 5.96872L7.36525 9.22054L9.29289 7.29289L10.7071 8.70711L7.70711 11.7071C7.46942 11.9448 7.12821 12.0472 6.79893 11.9796C6.46966 11.912 6.19636 11.6835 6.07152 11.3714L4.07152 6.37139C3.98368 6.15179 3.97652 5.90816 4.05132 5.68377Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13C13 13.5523 12.5523 14 12 14C11.4477 14 11 13.5523 11 13C11 12.4477 11.4477 12 12 12C12.5523 12 13 12.4477 13 13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16C12.5523 16 13 16.4477 13 17Z"
  })),
  name: 'DivisionMensIcon',
  tags: ["division", "mens", "shirt"],
  category: 'merchandising'
};
var DivisionOutdoorLivingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 4H3V2H21V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.1802 20L7.01942 10.8039L8.98058 11.1961L7.2198 20H9V22H3V20H5.1802Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.4072 17.442L15.0238 11.2169L16.9762 10.7831L18.3595 17.0082L16.4072 17.442Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17H6.5V15H17V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 3V5C20 9.41828 16.4183 13 12 13C7.58172 13 4 9.41828 4 5V3.5H6V5C6 8.31371 8.68629 11 12 11C15.3137 11 18 8.31371 18 5V3H20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 19C17.4477 19 17 19.4477 17 20C17 20.5523 17.4477 21 18 21C18.5523 21 19 20.5523 19 20C19 19.4477 18.5523 19 18 19ZM15 20C15 18.3431 16.3431 17 18 17C19.6569 17 21 18.3431 21 20C21 21.6569 19.6569 23 18 23C16.3431 23 15 21.6569 15 20Z"
  })),
  name: 'DivisionOutdoorLivingIcon',
  tags: ["division", "outdoor", "living", "grill", "cook"],
  category: 'merchandising'
};
var DivisionPerformanceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 5C15.4477 5 15 5.44772 15 6C15 6.55228 15.4477 7 16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5ZM13 6C13 4.34315 14.3431 3 16 3C17.6569 3 19 4.34315 19 6C19 7.65685 17.6569 9 16 9C14.3431 9 13 7.65685 13 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 15C17.8954 15 17 15.8954 17 17C17 18.1046 17.8954 19 19 19C20.1046 19 21 18.1046 21 17C21 15.8954 20.1046 15 19 15ZM15 17C15 14.7909 16.7909 13 19 13C21.2091 13 23 14.7909 23 17C23 19.2091 21.2091 21 19 21C16.7909 21 15 19.2091 15 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.0508 7.0451C10.0599 7.05561 10.0709 7.07059 10.0819 7.09064C10.0983 7.12053 10.1112 7.15527 10.1185 7.19126C10.6715 9.9342 13.0934 12 16 12V10C14.0642 10 12.4476 8.62387 12.079 6.79597C11.9081 5.94854 11.1409 4.92683 9.90196 5.04987C8.90092 5.14928 8.05713 5.407 7.28512 5.89836C6.52869 6.37979 5.90269 7.04708 5.27938 7.86409C4.76655 8.53629 4.80345 9.33785 5.08348 9.93962C5.3571 10.5276 5.89703 11.0236 6.58383 11.211C9.12976 11.9057 11 14.2357 11 17V18H13V17C13 13.311 10.5039 10.2075 7.11029 9.28153C7.07238 9.27118 7.02923 9.24936 6.98757 9.2133C6.9452 9.17663 6.91445 9.13382 6.89677 9.09584C6.88945 9.0801 6.88549 9.06775 6.88334 9.05904C7.43631 8.33658 7.89112 7.88338 8.35898 7.58561C8.80528 7.30156 9.32044 7.12303 10.0508 7.0451Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15C3.89543 15 3 15.8954 3 17C3 18.1046 3.89543 19 5 19C6.10457 19 7 18.1046 7 17C7 15.8954 6.10457 15 5 15ZM1 17C1 14.7909 2.79086 13 5 13C7.20914 13 9 14.7909 9 17C9 19.2091 7.20914 21 5 21C2.79086 21 1 19.2091 1 17Z"
  })),
  name: 'DivisionPerformanceIcon',
  tags: ["division", "performance", "bike", "sport"],
  category: 'merchandising'
};
var DivisionProduceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.75887 6.46055C4.23924 7.44248 4 8.81092 4 10.2013C4 12.0074 4.6938 14.5607 5.66034 16.6868C6.14019 17.7423 6.66236 18.6364 7.15446 19.2487C7.40096 19.5554 7.61643 19.7618 7.78901 19.884C7.92907 19.9833 7.99916 19.9982 8.00725 20C8.7709 19.9989 9.11427 19.8283 9.55443 19.6097L9.56509 19.6044C10.1205 19.3285 10.7852 19 12 19C13.2148 19 13.8795 19.3285 14.435 19.6043L14.4456 19.6096C14.8858 19.8283 15.2292 19.9989 15.9929 20C16.001 19.9982 16.0711 19.9832 16.2111 19.8841C16.3836 19.7618 16.5991 19.5555 16.8456 19.2488C17.3377 18.6365 17.8598 17.7423 18.3397 16.6868C19.3062 14.5607 20 12.0074 20 10.2013C20 8.59639 19.7556 7.24397 19.2497 6.328C18.784 5.48484 18.1027 4.99999 17 5C15.6452 5.00001 15.0212 5.21854 14.4964 5.42848C14.437 5.45224 14.377 5.47682 14.3159 5.50184C13.753 5.73243 13.1 5.99997 12 5.99997C10.9 5.99997 10.247 5.73241 9.68409 5.5018C9.62302 5.47678 9.56301 5.4522 9.5036 5.42843C8.97876 5.21849 8.35477 4.99996 7.00001 4.99997C5.95223 4.99999 5.25249 5.52776 4.75887 6.46055ZM2.99113 5.52507C3.74751 4.09577 5.04777 3 6.99999 2.99997C8.64523 2.99995 9.52124 3.28142 10.2464 3.57149C10.3137 3.59839 10.3775 3.62436 10.4388 3.64929C10.9634 3.86268 11.301 3.99997 12 3.99997C12.6991 3.99997 13.0366 3.86268 13.5613 3.6493C13.6225 3.62438 13.6864 3.59842 13.7536 3.57152C14.4788 3.28147 15.3548 3.00001 17 3C18.8973 2.99998 20.2161 3.94096 21.0004 5.36105C21.7445 6.70832 22 8.45657 22 10.2013C21.9999 12.3952 21.1938 15.2412 20.1604 17.5145C19.6402 18.6587 19.0374 19.7142 18.4045 20.5016C18.0885 20.8948 17.7415 21.2509 17.3672 21.516C16.9989 21.7769 16.5325 22 16.0001 22C14.775 21.9999 14.1052 21.6737 13.5453 21.3956L13.528 21.387C13.0854 21.1671 12.749 21 12 21C11.251 21 10.9146 21.1671 10.4721 21.387L10.4548 21.3956C9.89487 21.6737 9.2251 22 8 22C7.46756 22 7.00115 21.7769 6.63286 21.516C6.25857 21.2508 5.91154 20.8948 5.59554 20.5016C4.96264 19.7142 4.35981 18.6587 3.83966 17.5145C2.8062 15.2412 2 12.3952 2 10.2013C2 8.63743 2.26076 6.90523 2.99113 5.52507Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.99931C13 4.99931 13 5 12 5C11 5 11 5.00062 11 5.00062L11 5.00208L10.9998 4.98853C10.9994 4.97442 10.9987 4.95066 10.9972 4.91866C10.9942 4.85438 10.9878 4.75841 10.9749 4.64168C10.9484 4.40314 10.8968 4.10261 10.8013 3.81623C10.5949 3.19688 10.3357 3 10 3V1C11.6643 1 12.4051 2.30312 12.6987 3.18377C12.8532 3.64739 12.9266 4.09686 12.9626 4.42082C12.9809 4.58534 12.9902 4.72374 12.995 4.82353C12.9973 4.87355 12.9986 4.91425 12.9993 4.94409L12.9999 4.98064L13 4.99253L13 4.99683L13 4.99931ZM11 5.00312L11 5.00208L11 5.00312Z"
  })),
  name: 'DivisionProduceIcon',
  tags: ["division", "produce", "apple", "food", "fruit"],
  category: 'merchandising'
};
var DivisionReadyToWearIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.29289 1.29289C4.48043 1.10536 4.73478 1 5 1L16 1C16.5523 1 17 1.44772 17 2V22C17 22.5523 16.5523 23 16 23H8C7.60786 23 7.2519 22.7708 7.08963 22.4138L2.08963 11.4138C1.98519 11.184 1.9715 10.9232 2.05132 10.6838L4 4.83772V2C4 1.73478 4.10536 1.48043 4.29289 1.29289ZM5.72076 6L4.07286 10.9437L8.64391 21H15V6H5.72076ZM15 4V3H6V4H15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 11.2929C15.4804 11.1054 15.7348 11 16 11H21C21.3466 11 21.6684 11.1795 21.8507 11.4743C22.0329 11.7691 22.0494 12.1372 21.8944 12.4472L16.8944 22.4472C16.687 22.862 16.2216 23.0798 15.7702 22.9732C15.3189 22.8667 15 22.4638 15 22V12C15 11.7348 15.1054 11.4804 15.2929 11.2929ZM17 13V17.7639L19.382 13H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 8C7 7.44772 7.44772 7 8 7H12C12.5523 7 13 7.44772 13 8V11C13 11.2652 12.8946 11.5196 12.7071 11.7071L10.7071 13.7071C10.3166 14.0976 9.68342 14.0976 9.29289 13.7071L7.29289 11.7071C7.10536 11.5196 7 11.2652 7 11V8ZM9 9V10.5858L10 11.5858L11 10.5858V9H9Z"
  })),
  name: 'DivisionReadyToWearIcon',
  tags: ["division", "ready", "to", "wear", "pants", "jeans"],
  category: 'merchandising'
};
var DivisionSeasonalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 20V23H11V20H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.85929 18.0859L6.22163 11.543L8.0005 12.4571L4.63816 19H19.3617L15.9994 12.4571L17.7783 11.543L21.1406 18.0859C21.8246 19.4169 20.8582 21 19.3617 21H4.63816C3.14172 21 2.17532 19.4169 2.85929 18.0859Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3126 1.78892C11.0985 0.553921 12.9014 0.553921 13.6873 1.78892L18.8656 9.92629C19.7129 11.2577 18.7565 13 17.1783 13H6.82163C5.24344 13 4.28702 11.2577 5.1343 9.92629L10.3126 1.78892ZM12 2.86267L6.82163 11H17.1783L12 2.86267Z"
  })),
  name: 'DivisionSeasonalIcon',
  tags: ["division", "seasonal", "tree", "christmas", "holiday"],
  category: 'merchandising'
};
var DivisionShoesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.21216 2.67827C9.53189 2.11267 11 3.08073 11 4.51656V7.55765L15.9282 12.0379L19.8635 12.4314C20.7382 12.5189 21.4532 13.1672 21.6256 14.0292L21.9684 15.7429L22.8177 18.2908C22.9485 18.6831 23.0733 19.6037 22.2538 20.1281C21.8256 20.4021 21.2493 20.5765 20.6697 20.7022C20.0644 20.8334 19.3475 20.9329 18.5678 21.0092C17.0069 21.1618 15.1184 21.2279 13.2153 21.2452C9.40492 21.2798 5.45589 21.1194 3.78177 21.0405C2.80644 20.9946 2.01458 20.249 1.91243 19.2764C1.76638 17.8856 1.5 14.9485 1.5 12C1.5 9.07794 1.76138 7.18088 1.91726 6.30949C2.03604 5.64547 2.48966 5.13077 3.062 4.88548L8.21216 2.67827ZM3.87708 6.71209C3.7399 7.49592 3.5 9.25836 3.5 12C3.5 14.8299 3.75532 17.6709 3.89901 19.0438C5.57399 19.1225 9.46036 19.2792 13.1971 19.2453C15.0763 19.2282 16.8977 19.1629 18.3732 19.0187C19.1118 18.9465 19.7448 18.8562 20.246 18.7475C20.48 18.6968 20.6667 18.6459 20.812 18.5983L20.0316 16.2572L19.6645 14.4215L15.7292 14.0279C15.3023 13.9852 14.9004 13.8064 14.5829 13.5177L9.65465 9.03753C9.23771 8.65848 9 8.12114 9 7.55765L9 4.51656L3.87708 6.71209Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.8147 18.1862C13.6069 18.2715 11.1464 18.2604 8.97954 18.2161L9.02046 16.2165C11.169 16.2605 13.5856 16.2709 15.7374 16.1877C17.9252 16.1031 19.7272 15.9243 20.7133 15.6293L21.2867 17.5453C20.0269 17.9223 17.9866 18.1022 15.8147 18.1862Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.53877 16.5421C5.32454 16.0142 3.79037 16 2.5 16V14C2.52254 14 2.54535 14 2.56841 14C3.78279 13.9997 5.70641 13.9993 7.33623 14.7079C8.1942 15.081 9.005 15.6625 9.59413 16.5611C10.1828 17.4592 10.5 18.5974 10.5 20H8.5C8.5 18.9027 8.25466 18.1659 7.9215 17.6576C7.58875 17.1501 7.1183 16.7941 6.53877 16.5421Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 10.2929L9.29289 8.29291L10.7071 9.70713L8.70711 11.7071L7.29289 10.2929ZM9.29289 12.2929L11.2929 10.2929L12.7071 11.7071L10.7071 13.7071L9.29289 12.2929Z"
  })),
  name: 'DivisionShoesIcon',
  tags: ["division", "shoes", "footwear"],
  category: 'merchandising'
};
var DivisionSportingGoodsIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.6361 5.636C16.1213 9.15072 16.1213 14.8492 19.6361 18.3639L18.2218 19.7781C13.9261 15.4824 13.9261 8.51755 18.2218 4.22179L19.6361 5.636Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.36396 18.364C7.87868 14.8492 7.87868 9.15076 4.36396 5.63604L5.77817 4.22183C10.0739 8.51759 10.0739 15.4824 5.77817 19.7782L4.36396 18.364Z"
  })),
  name: 'DivisionSportingGoodsIcon',
  tags: ["division", "sporting", "goods", "sports", "ball"],
  category: 'merchandising'
};
var DivisionStationeryHolidayIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 13C3 11.8954 3.89543 11 5 11H19C20.1046 11 21 11.8954 21 13V20C21 21.1045 20.1046 22 19 22H5C3.89543 22 3 21.1045 3 20V13ZM19 13H5V20H19V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8.99997C2 7.8954 2.89543 6.99997 4 6.99997H20C21.1046 6.99997 22 7.8954 22 8.99997V11C22 12.1045 21.1046 13 20 13H4C2.89543 13 2 12.1045 2 11V8.99997ZM20 8.99997H4V11H20V8.99997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.11979 4.78862C7.50003 4.53513 8.01097 4.61446 8.29644 4.97131L11.2191 8.62466L12.7809 7.37527L9.85818 3.72192C8.92464 2.55498 7.25381 2.29558 6.01039 3.12452C4.68649 4.00713 4.32874 5.79586 5.21135 7.11976L6.16795 8.55467L7.83205 7.44527L6.87545 6.01036C6.60555 5.60551 6.71494 5.05852 7.11979 4.78862Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.8802 4.78862C16.5 4.53513 15.989 4.61446 15.7036 4.97131L12.7809 8.62466L11.2191 7.37527L14.1418 3.72192C15.0754 2.55498 16.7462 2.29558 17.9896 3.12452C19.3135 4.00713 19.6713 5.79586 18.7887 7.11976L17.8321 8.55467L16.1679 7.44527L17.1246 6.01036C17.3945 5.60551 17.2851 5.05852 16.8802 4.78862Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 21V7.99997H13V21H11Z"
  })),
  name: 'DivisionStationeryHolidayIcon',
  tags: ["division", "stationery", "holiday", "gift", "present", "wrapping", "box"],
  category: 'merchandising'
};
var DivisionStationeryIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4118 1.44234C16.6979 1.04662 18 2.00829 18 3.3539V4.99994H19C20.1046 4.99994 21 5.89537 21 6.99994V20.9999C21 22.1045 20.1046 22.9999 19 22.9999H5C3.89543 22.9999 3 22.1045 3 20.9999V5.26137L15.4118 1.44234ZM16 4.99994V3.3539L10.6504 4.99994H16ZM5 6.99994H19V20.9999H5V6.99994Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8.99994C12.3969 8.99994 12.7563 9.23471 12.9158 9.59821L13.8731 11.7804L15.9656 12.1225C16.3276 12.1817 16.6282 12.4344 16.7487 12.7809C16.8692 13.1274 16.7903 13.5121 16.5431 13.7832L14.9626 15.5164L15.3397 17.9898C15.3979 18.3717 15.231 18.753 14.9108 18.9692C14.5907 19.1855 14.1746 19.1979 13.8421 19.0012L12 17.9118L10.1579 19.0012C9.82541 19.1979 9.40934 19.1855 9.08919 18.9692C8.76903 18.753 8.60206 18.3717 8.66028 17.9898L9.03737 15.5164L7.45687 13.7832C7.20966 13.5121 7.13075 13.1274 7.25127 12.7809C7.37178 12.4344 7.67237 12.1817 8.03444 12.1225L10.1269 11.7804L11.0842 9.59821C11.2437 9.23471 11.6031 8.99994 12 8.99994ZM12 12.4891L11.7402 13.0814C11.6041 13.3917 11.3201 13.6119 10.9858 13.6666L10.1777 13.7987L10.8368 14.5214C11.0402 14.7445 11.132 15.0475 11.0865 15.3459L10.9553 16.206L11.4909 15.8892C11.8049 15.7035 12.1951 15.7035 12.5091 15.8892L13.0447 16.206L12.9135 15.3459C12.868 15.0475 12.9598 14.7445 13.1632 14.5214L13.8223 13.7987L13.0142 13.6666C12.6799 13.6119 12.3959 13.3917 12.2598 13.0814L12 12.4891Z"
  })),
  name: 'DivisionStationeryIcon',
  tags: ["division", "stationery", "card", "star", "holiday"],
  category: 'merchandising'
};
var DivisionStorageUtilityIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V3ZM19 3L5 3V21H19V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13H4V11H20V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 8H10V6H14V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 18H10V16H14V18Z"
  })),
  name: 'DivisionStorageUtilityIcon',
  tags: ["division", "storage", "utility", "file", "cabinet"],
  category: 'merchandising'
};
var DivisionToysIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.89543 2.89543 6 4 6H20C21.1046 6 22 6.89543 22 8V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V8ZM20 8L4 8V20H20V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 4C4 2.89543 4.89543 2 6 2H9C10.1046 2 11 2.89543 11 4V6C11 7.10457 10.1046 8 9 8H6C4.89543 8 4 7.10457 4 6V4ZM9 4H6V6H9V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C13 2.89543 13.8954 2 15 2H18C19.1046 2 20 2.89543 20 4V6C20 7.10457 19.1046 8 18 8H15C13.8954 8 13 7.10457 13 6V4ZM18 4H15V6H18V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 15H2V13H20V15Z"
  })),
  name: 'DivisionToysIcon',
  tags: ["division", "toys", "block", "lego"],
  category: 'merchandising'
};
var DivisionIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 2C11.3668 1.21895 12.6331 1.21895 13.4142 2L22 10.5858C22.781 11.3668 22.781 12.6332 22 13.4142L13.4142 22C12.6331 22.781 11.3668 22.7811 10.5858 22L1.99997 13.4142C1.21892 12.6332 1.21892 11.3668 1.99997 10.5858L10.5858 2ZM12 3.41422L3.41418 12L12 20.5858L20.5858 12L12 3.41422Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.2929 17.7071L6.29286 7.70711L7.70708 6.2929L17.7071 16.2929L16.2929 17.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29286 16.2929L16.2929 6.2929L17.7071 7.70711L7.70708 17.7071L6.29286 16.2929Z"
  })),
  name: 'DivisionIcon',
  tags: ["division", "square", "shape"],
  category: 'merchandising'
};
var DollarSignCircleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 6.65569V5H13V6.65605C13.9662 6.8537 14.8289 7.33679 15.3868 8.05118L13.8105 9.28215C13.5181 8.9078 12.8678 8.55556 12 8.55556C11.3641 8.55556 10.8279 8.74779 10.4739 9.00998C10.1198 9.2723 10 9.55484 10 9.77778C10 10.0993 10.121 10.3642 10.3767 10.5699C10.6505 10.7901 11.1566 11 12 11C13.1566 11 14.1505 11.2875 14.8767 11.8716C15.621 12.4702 16 13.3165 16 14.2222C16 15.2266 15.4482 16.0552 14.7166 16.5971C14.2298 16.9577 13.6405 17.2134 13 17.3443L13 19L11 19L11 17.3439C10.0338 17.1463 9.17111 16.6632 8.61322 15.9488L10.1895 14.7178C10.4818 15.0922 11.1322 15.4444 12 15.4444C12.6359 15.4444 13.1721 15.2522 13.5261 14.99C13.8802 14.7277 14 14.4452 14 14.2222C14 13.9007 13.879 13.6358 13.6233 13.4301C13.3495 13.2099 12.8434 13 12 13C10.8434 13 9.84953 12.7125 9.12327 12.1284C8.379 11.5298 8 10.6835 8 9.77778C8 8.77342 8.55178 7.94485 9.28345 7.40287C9.77018 7.04233 10.3595 6.78657 11 6.65569Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  })),
  name: 'DollarSignCircleIcon',
  tags: ["dollar", "sign", "circle", "money", "cash", "credit", "pay"],
  category: 'system'
};
var DollarSignIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 3.44695V1H13V3.44717C14.7052 3.67509 16.2155 4.47978 17.1275 5.68102L15.5346 6.89041C14.8925 6.04474 13.5977 5.38095 12 5.38095C10.8184 5.38095 9.78604 5.747 9.07051 6.29217C8.35579 6.83671 8 7.51708 8 8.19048C8 8.96093 8.29616 9.62457 8.88742 10.1137C9.49407 10.6156 10.4961 11 12 11C13.8294 11 15.3274 11.4684 16.3874 12.3453C17.4628 13.2349 18 14.476 18 15.8095C18 17.2401 17.2365 18.4645 16.1416 19.2987C15.2825 19.9532 14.1932 20.3939 13 20.5531L13 23L11 23L11 20.5528C9.29482 20.3249 7.7845 19.5202 6.87249 18.319L8.4654 17.1096C9.10746 17.9552 10.4024 18.619 12 18.619C13.1816 18.619 14.214 18.253 14.9295 17.7078C15.6442 17.1633 16 16.4829 16 15.8095C16 15.0391 15.7038 14.3754 15.1126 13.8863C14.5059 13.3844 13.5039 13 12 13C10.1706 13 8.67258 12.5316 7.61257 11.6547C6.53717 10.7651 6 9.52397 6 8.19048C6 6.75993 6.76349 5.53554 7.85842 4.70131C8.71749 4.04677 9.80683 3.60608 11 3.44695Z"
  })),
  name: 'DollarSignIcon',
  tags: ["dollar", "sign", "money", "cash", "credit", "pay"],
  category: 'system'
};
var DownloadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 11.7071L12 17.4142L6.29289 11.7071L7.70711 10.2929L12 14.5858L16.2929 10.2929L17.7071 11.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 15L11 2L13 2L13 15H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 20C22 21.1046 21.1046 22 20 22L4 22C2.89543 22 2 21.1046 2 20L2 16L4 16L4 20L20 20V16H22V20Z"
  })),
  name: 'DownloadIcon',
  tags: ["download", "arrow"],
  category: 'system'
};
var DragIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 8C10.1046 8 11 7.10457 11 6C11 4.89543 10.1046 4 9 4C7.89543 4 7 4.89543 7 6C7 7.10457 7.89543 8 9 8ZM15 8C16.1046 8 17 7.10457 17 6C17 4.89543 16.1046 4 15 4C13.8954 4 13 4.89543 13 6C13 7.10457 13.8954 8 15 8ZM17 12C17 13.1046 16.1046 14 15 14C13.8954 14 13 13.1046 13 12C13 10.8954 13.8954 10 15 10C16.1046 10 17 10.8954 17 12ZM9 14C10.1046 14 11 13.1046 11 12C11 10.8954 10.1046 10 9 10C7.89543 10 7 10.8954 7 12C7 13.1046 7.89543 14 9 14ZM11 18C11 19.1046 10.1046 20 9 20C7.89543 20 7 19.1046 7 18C7 16.8954 7.89543 16 9 16C10.1046 16 11 16.8954 11 18ZM15 20C16.1046 20 17 19.1046 17 18C17 16.8954 16.1046 16 15 16C13.8954 16 13 16.8954 13 18C13 19.1046 13.8954 20 15 20Z"
  })),
  name: 'DragIcon',
  tags: ["dots", "drag"],
  category: 'navigation'
};
var DuplicateIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.89543 2.89543 6 4 6H7V8L4 8V20H16V17H18V20C18 21.1046 17.1046 22 16 22H4C2.89543 22 2 21.1046 2 20V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 14V6H15V14H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 11H10V9H18V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 2.89543 6.89543 2 8 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18H8C6.89543 18 6 17.1046 6 16V4ZM20 4L8 4V16H20V4Z"
  })),
  name: 'DuplicateIcon',
  tags: ["duplicate", "clone", "add"],
  category: 'system'
};
var EmergencyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 2L11 5.5H13V2H11ZM12 7C8.68629 7 6 9.68629 6 13V19H5V21H19V19H18V13C18 9.68629 15.3137 7 12 7ZM16 13V19H8V13C8 10.7909 9.79086 9 12 9C14.2091 9 16 10.7909 16 13ZM1 12H4.5V14H1V12ZM19.5 12H23V14H19.5V12ZM20.9143 5.5L18.2072 8.20711L16.793 6.79289L19.5001 4.08579L20.9143 5.5ZM5.79282 8.20711L3.08571 5.5L4.49992 4.08579L7.20703 6.79289L5.79282 8.20711Z"
  })),
  name: 'EmergencyIcon',
  tags: ["emergency", "alert", "siren", "warning"],
  category: 'sasc'
};
var ErrorFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1ZM13 14V6H11V14H13ZM12 18C12.8284 18 13.5 17.3284 13.5 16.5C13.5 15.6716 12.8284 15 12 15C11.1716 15 10.5 15.6716 10.5 16.5C10.5 17.3284 11.1716 18 12 18Z"
  })),
  name: 'ErrorFilledIcon',
  tags: ["error", "filled", "no", "rejected", "alert", "attention"],
  category: 'status'
};
var ErrorIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 6V14H11V6H13Z"
  })),
  name: 'ErrorIcon',
  tags: ["error", "no", "alert", "rejected", "attention"],
  category: 'status'
};
var ExportIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29289 5.29292L12 0.585815L16.7071 5.29292L15.2929 6.70714L12 3.41424L8.70711 6.70714L7.29289 5.29292Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 3.00003V17H11V3.00003L13 3.00003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20C21 21.1046 20.1046 22 19 22H5C3.89543 22 3 21.1046 3 20L3 10C3 8.89546 3.89543 8.00003 5 8.00003H8V10L5 10L5 20L19 20V10L16 10V8.00003L19 8.00003C20.1046 8.00003 21 8.89546 21 10V20Z"
  })),
  name: 'ExportIcon',
  tags: ["export", "extract", "arrow"],
  category: 'system'
};
var ExternalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 3H13V5H17.5858L9.29295 13.2928L10.7072 14.707L19 6.41423L19 11H21L21 4.00089L21 3ZM10.7072 14.707L10 15.4142L8.58579 14L9.29295 13.2928L10.7072 14.707Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5C3 3.89543 3.89543 3 5 3H9V5H5V19H19V15H21V19C21 20.1046 20.1046 21 19 21H5C3.89543 21 3 20.1046 3 19V5Z"
  })),
  name: 'ExternalIcon',
  tags: ["external", "link", "arrow"],
  category: 'system'
};
var FileTextIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H13.4142L21 8.58579V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V3ZM12 3L5 3V21H19V10H14C12.8954 10 12 9.10457 12 8V3ZM14 4.41421L17.5858 8H14V4.41421Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 14H7V12H17V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 18H7V16H17V18Z"
  })),
  name: 'FileTextIcon',
  tags: ["file", "text", "word", "document", "page", "paper"],
  category: 'system'
};
var FileZipIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 4C3 2.89617 3.89412 2 4.99943 2H9.99947L9.99997 4L5 4V21H19V4H14V2H19C20.1046 2 21 2.89543 21 4V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 15H11V13H15V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19H11V17H15V19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 13H9V11H13V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 17H9V15H13V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 3C9 1.89543 9.89543 1 11 1H13C14.1046 1 15 1.89543 15 3V7C15 8.10457 14.1046 9 13 9H11C9.89543 9 9 8.10457 9 7V3ZM13 3H11V7H13V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 22V9H13V22H11Z"
  })),
  name: 'FileZipIcon',
  tags: ["file", "zip"],
  category: 'system'
};
var FileIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H13.4142L21 8.58579V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V3ZM12 3L5 3V21H19V10H14C12.8954 10 12 9.10457 12 8V3ZM14 4.41421L17.5858 8H14V4.41421Z"
  })),
  name: 'FileIcon',
  tags: ["file", "document", "paper", "sheet"],
  category: 'system'
};
var FilesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7C3 5.89543 3.89543 5 5 5H8V7H5V21H15V18H17V21C17 22.1046 16.1046 23 15 23H5C3.89543 23 3 22.1046 3 21V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H15.4684L21 7.63795V17C21 18.1046 20.1046 19 19 19H9C7.89543 19 7 18.1046 7 17V3ZM14 3H9V17H19V9H16C14.8954 9 14 8.10457 14 7V3ZM16 4.76205L17.865 7H16V4.76205Z"
  })),
  name: 'FilesIcon',
  tags: ["file", "document", "paper", "sheet", "group"],
  category: 'system'
};
var FillAndBackstockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00015 7.00001C6.79101 7.00001 5.00015 8.79088 5.00015 11H3.00015C3.00015 7.68631 5.68644 5.00001 9.00015 5.00001H20.0002V7.00001H9.00015Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0002 13C19.0002 15.2092 17.2093 17 15.0001 17L5.41437 17L7.70726 14.7071L6.29304 13.2929L1.58594 18L6.29304 22.7071L7.70726 21.2929L5.41436 19H15.0001C18.3139 19 21.0002 16.3137 21.0002 13H19.0002Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7073 1.29291L22.4144 6.00001L17.7073 10.7071L16.293 9.29291L19.5859 6.00001L16.293 2.70712L17.7073 1.29291Z"
  })),
  name: 'FillAndBackstockIcon',
  tags: ["fill", "backstock"],
  category: 'sasc'
};
var FillIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.0001 17C16.2092 17 18.0001 15.2091 18.0001 13H20.0001C20.0001 16.3137 17.3138 19 14.0001 19H8.00009C4.68639 19 2.00009 16.3137 2.00009 13V11C2.00009 7.68629 4.68639 5 8.00009 5L17.5859 5L15.293 2.70711L16.7072 1.29289L21.4143 6L16.7072 10.7071L15.293 9.29289L17.5859 7L8.00009 7C5.79095 7 4.00009 8.79086 4.00009 11V13C4.00009 15.2091 5.79096 17 8.00009 17H14.0001Z"
  })),
  name: 'FillIcon',
  tags: ["fill", "arrow"],
  category: 'sasc'
};
var FilterFunnelClearIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4.11936 7.56541C3.28076 6.23357 4.23794 4.49976 5.81181 4.49976H18.2292C19.7816 4.49976 20.7508 6.19628 19.9358 7.53274C19.0441 8.99495 17.6275 11.3024 16.2559 13.4715L14.5655 12.4025C15.9261 10.2509 17.3335 7.95868 18.2232 6.49976L5.81181 6.49976L10.3788 13.7529C10.591 14.09 10.6978 14.4828 10.6854 14.8809L10.6038 17.4998L12.21 17.4998V19.4998H10.6038C9.47479 19.4998 8.56958 18.5659 8.60475 17.4375L8.68636 14.8186L4.11936 7.56541Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5857 18L13.2928 15.7071L14.7071 14.2929L16.9999 16.5858L19.2928 14.2929L20.7071 15.7071L18.4142 18L20.7071 20.2929L19.2928 21.7071L16.9999 19.4142L14.7071 21.7071L13.2928 20.2929L15.5857 18Z"
  })),
  name: 'FilterFunnelClearIcon',
  tags: ["filter", "funnel", "clear", "remove"],
  category: 'system'
};
var FilterFunnelIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.11936 8.26219C3.28076 6.93034 4.23794 5.19653 5.81181 5.19653H18.1849C19.7559 5.19653 20.7212 6.9277 19.8767 8.26328L15.2809 15.5308V18.1965C15.2809 19.3011 14.3855 20.1965 13.2809 20.1965H10.6038C9.47479 20.1965 8.56958 19.2627 8.60475 18.1342L8.68636 15.5154L4.11936 8.26219ZM18.1849 7.19653L5.81181 7.19653L10.3788 14.4497C10.591 14.7868 10.6978 15.1795 10.6854 15.5777L10.6038 18.1965L13.2809 18.1965V15.5308C13.2809 15.1536 13.3869 14.7838 13.5898 14.4629L18.1849 7.19653Z"
  })),
  name: 'FilterFunnelIcon',
  tags: ["filter", "funnel"],
  category: 'system'
};
var FilterIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15C7.89543 15 7 15.8954 7 17C7 18.1046 7.89543 19 9 19C10.1046 19 11 18.1046 11 17C11 15.8954 10.1046 15 9 15ZM5 17C5 14.7909 6.79086 13 9 13C11.2091 13 13 14.7909 13 17C13 19.2091 11.2091 21 9 21C6.79086 21 5 19.2091 5 17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 5C13.8954 5 13 5.89543 13 7C13 8.10457 13.8954 9 15 9C16.1046 9 17 8.10457 17 7C17 5.89543 16.1046 5 15 5ZM11 7C11 4.79086 12.7909 3 15 3C17.2091 3 19 4.79086 19 7C19 9.20914 17.2091 11 15 11C12.7909 11 11 9.20914 11 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 16H22V18H12V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 6H22V8H18V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16H6V18H2V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 6H12V8H2V6Z"
  })),
  name: 'FilterIcon',
  tags: ["filter", "controls"],
  category: 'system'
};
var FixturesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 8.58821C6.5 5.50192 9.00192 3 12.0882 3C15.1745 3 17.6764 5.50192 17.6764 8.58821C17.6764 10.5985 16.6156 12.3618 15.0184 13.3476C14.4752 13.6829 14.0471 14.2768 14.0036 15H9.99997C9.99622 14.249 9.57675 13.6244 9.03092 13.2668C7.50466 12.2671 6.5 10.5447 6.5 8.58821ZM10 17H14V18H10V17ZM12.0882 1C7.89736 1 4.5 4.39736 4.5 8.58821C4.5 11.2473 5.86855 13.5862 7.93503 14.9399C7.96608 14.9602 7.98487 14.9828 7.99391 14.9983C7.998 15.0053 7.99951 15.0096 8 15.0115V18C8 19.1046 8.89543 20 10 20H14C15.1046 20 16 19.1046 16 18V15.1226C16.0005 15.1206 16.0021 15.1162 16.0065 15.1089C16.0162 15.0928 16.0363 15.0697 16.0689 15.0495C18.2315 13.7147 19.6764 11.3206 19.6764 8.58821C19.6764 4.39736 16.2791 1 12.0882 1ZM10 21C9.44772 21 9 21.4477 9 22C9 22.5523 9.44772 23 10 23H14C14.5523 23 15 22.5523 15 22C15 21.4477 14.5523 21 14 21H10Z"
  })),
  name: 'FixturesIcon',
  tags: ["fixtures", "light", "bulb"],
  category: 'sasc'
};
var FlagFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3V23H3V3H5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 12.382V4.61803C20 3.87465 19.203 3.36386 18.4925 3.58256C17.7789 3.80221 16.8895 4 16 4C14 4 10 2 8 2C6.64985 2 5.2997 2.45572 4.56485 2.75188C4.21354 2.89346 4 3.23926 4 3.61803V11.382C4 12.1253 4.79705 12.6361 5.50753 12.4174C6.22107 12.1978 7.11053 12 8 12C10 12 14 14 16 14C17.3501 14 18.7003 13.5443 19.4351 13.2481C19.7865 13.1065 20 12.7607 20 12.382Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.65489V11.382C5 11.3823 5 11.3817 5 11.382C4.99997 11.3838 4.99995 11.3852 5.00218 11.389C5.00626 11.3961 5.01839 11.4126 5.0445 11.4301C5.10338 11.4696 5.16979 11.4751 5.21332 11.4617C5.97869 11.2261 6.97371 11 8 11C8.63875 11 9.36964 11.1552 10.0756 11.3477C10.79 11.5426 11.5617 11.7998 12.3005 12.0461L12.3162 12.0513C13.0726 12.3035 13.795 12.5439 14.4506 12.7227C15.1196 12.9052 15.6388 13 16 13C17.1241 13 18.2957 12.6238 19 12.3451V4.61803C19 4.61774 19 4.61827 19 4.61803C19 4.61616 19 4.61484 18.9978 4.61098C18.9937 4.6039 18.9816 4.58743 18.9555 4.56992C18.8966 4.53041 18.8302 4.52491 18.7867 4.53831C18.0213 4.77391 17.0263 5 16 5C15.3612 5 14.6304 4.8448 13.9244 4.65226C13.21 4.45744 12.4382 4.20018 11.6994 3.9539L11.6838 3.94868C10.9274 3.69654 10.205 3.45607 9.54938 3.27726C8.88036 3.0948 8.36125 3 8 3C6.87594 3 5.70428 3.37621 5 3.65489ZM4.19106 1.82437C4.9646 1.51262 6.45706 1 8 1C8.63875 1 9.36964 1.1552 10.0756 1.34774C10.79 1.54256 11.5618 1.79982 12.3006 2.0461L12.3162 2.05132C13.0726 2.30346 13.795 2.54393 14.4506 2.72274C15.1196 2.9052 15.6388 3 16 3C16.7526 3 17.5365 2.83052 18.1983 2.62682C19.4535 2.24044 21 3.10224 21 4.61803V12.382C21 13.1312 20.5723 13.868 19.8089 14.1756C19.0354 14.4874 17.5429 15 16 15C15.3612 15 14.6304 14.8448 13.9244 14.6523C13.21 14.4574 12.4383 14.2002 11.6995 13.9539L11.6838 13.9487C10.9274 13.6965 10.205 13.4561 9.54938 13.2773C8.88036 13.0948 8.36125 13 8 13C7.24736 13 6.46345 13.1695 5.80173 13.3732C4.54654 13.7596 3 12.8978 3 11.382V3.61803C3 2.86882 3.42772 2.132 4.19106 1.82437Z"
  })),
  name: 'FlagFilledIcon',
  tags: ["flag", "filled", "favorite", "save"],
  category: 'toggle'
};
var FlagIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3.65489V11.5294C5.79461 11.2693 6.88019 11 8 11C8.63875 11 9.36964 11.1552 10.0756 11.3477C10.79 11.5426 11.5617 11.7998 12.3005 12.0461L12.3162 12.0513C13.0726 12.3035 13.795 12.5439 14.4506 12.7227C15.1196 12.9052 15.6388 13 16 13C17.1241 13 18.2957 12.6238 19 12.3451V4.61803C19 4.61774 19 4.61749 19 4.61725C19 4.61537 19 4.61484 18.9978 4.61098C18.9937 4.6039 18.9816 4.58743 18.9555 4.56992C18.8966 4.53041 18.8302 4.52491 18.7867 4.53831C18.0213 4.77391 17.0263 5 16 5C15.3612 5 14.6304 4.8448 13.9244 4.65226C13.21 4.45744 12.4382 4.20018 11.6994 3.9539L11.6838 3.94868C10.9274 3.69654 10.205 3.45607 9.54938 3.27726C8.88036 3.0948 8.36125 3 8 3C6.87594 3 5.70428 3.37621 5 3.65489ZM5 13.6549C5.16171 13.5909 5.35286 13.5198 5.56623 13.4487C6.26632 13.2153 7.15125 13 8 13C8.36125 13 8.88036 13.0948 9.54938 13.2773C10.205 13.4561 10.9274 13.6965 11.6838 13.9487L11.6995 13.9539C12.4383 14.2002 13.21 14.4574 13.9244 14.6523C14.6304 14.8448 15.3612 15 16 15C17.5429 15 19.0354 14.4874 19.8089 14.1756C20.5723 13.868 21 13.1312 21 12.382V4.61803C21 3.10224 19.4535 2.24044 18.1983 2.62682C17.5365 2.83052 16.7526 3 16 3C15.6388 3 15.1196 2.9052 14.4506 2.72274C13.795 2.54393 13.0726 2.30346 12.3162 2.05132L12.3006 2.0461C11.5618 1.79982 10.79 1.54256 10.0756 1.34774C9.36964 1.1552 8.63875 1 8 1C6.45706 1 4.9646 1.51262 4.19106 1.82437C3.42772 2.132 3 2.86882 3 3.61803V23H5V13.6549Z"
  })),
  name: 'FlagIcon',
  tags: ["flag", "favorite", "save"],
  category: 'toggle'
};
var FolderMoveIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.02289 4.99394C1.02289 3.88881 1.91877 2.99292 3.02391 2.99292H7.61203C8.14273 2.99292 8.6517 3.20374 9.02696 3.579L12.4429 6.99496H21.0358C22.1444 6.99496 23.0341 7.89435 23.0341 8.99597V19.0011C23.0341 20.1062 22.1382 21.0021 21.0331 21.0021H11.9261V19.0011H21.0331V8.99597H3.02391V12.9361H1.02289V4.99394ZM3.02391 6.99496H9.61305L7.61203 4.99394H3.02391V6.99496ZM21.033 8.99385C21.0329 8.9932 21.0329 8.99372 21.033 8.99385C21.033 8.99404 21.0333 8.99493 21.0334 8.99497C21.0334 8.99504 21.0336 8.99521 21.0334 8.99497C21.0333 8.99493 21.033 8.99404 21.033 8.99385ZM6.48326 13.2018L10.3924 17.1109L6.48326 21.02L5.06833 19.6051L6.56196 18.1115H1.02875V16.1104H6.562L5.06833 14.6168L6.48326 13.2018Z"
  })),
  name: 'FolderMoveIcon',
  tags: ["Folder move", "move-to-folder", "move", "migrate"],
  category: 'system'
};
var FolderOpenIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H6.58579C7.11622 3 7.62493 3.21071 8 3.58579L11.4142 7H17.0007C18.1063 7 19 7.89639 19 9V12H17V9H11.4145C10.8844 9 10.3753 8.7895 10 8.41421L6.58579 5H3V19H18V21H3C1.89543 21 1 20.1046 1 19V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82918 12.1056C5.16796 11.428 5.86049 11 6.61803 11H20.557C21.9534 11 22.92 12.3947 22.4297 13.7022L20.1797 19.7022C19.8869 20.4829 19.1407 21 18.307 21H3.61803C2.13127 21 1.16428 19.4354 1.82918 18.1056L4.82918 12.1056ZM20.557 13H6.61803L3.61803 19H18.307L20.557 13Z"
  })),
  name: 'FolderOpenIcon',
  tags: ["folder", "open"],
  category: 'system'
};
var FolderSharedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H7.58579C8.11622 3 8.62493 3.21071 9 3.58579L12.4142 7H21.0027C22.1108 7 23 7.89893 23 9V19C23 20.1046 22.1046 21 21 21H14V19H21V9H3V11H1V5ZM3 7H9.58579L7.58579 5H3V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 14C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16C7.55228 16 8 15.5523 8 15C8 14.4477 7.55228 14 7 14ZM4 15C4 13.3431 5.34315 12 7 12C8.65685 12 10 13.3431 10 15C10 16.6569 8.65685 18 7 18C5.34315 18 4 16.6569 4 15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 22C2 19.7909 3.79086 18 6 18H8C10.2091 18 12 19.7909 12 22H10C10 20.8954 9.10457 20 8 20H6C4.89543 20 4 20.8954 4 22H2Z"
  })),
  name: 'FolderSharedIcon',
  tags: ["folder", "shared", "person", "user", "permissions"],
  category: 'system'
};
var FolderIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H7.58579C8.11622 3 8.62493 3.21071 9 3.58579L12.4142 7H21.0027C22.1108 7 23 7.89893 23 9V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM9.58579 7L7.58579 5H3V7H9.58579ZM3 9V19H21V9H3Z"
  })),
  name: 'FolderIcon',
  tags: ["folder"],
  category: 'system'
};
var FoldersIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2H10.3989C10.9138 2 11.4087 2.19852 11.7809 2.55425L14.4011 5.05882H21.0021C22.1094 5.05882 23 5.95697 23 7.05882V15C23 16.1046 22.1046 17 21 17H7C5.89543 17 5 16.1046 5 15V4ZM11.5066 5.05882L10.3989 4L7 4V5.05882H11.5066ZM7 7.05882V15L21 15V7.05882H7ZM21 7.05772L21 7.05882L21 7.05772ZM21 7.05772L21 7.05882L21 7.05772Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 9C1 7.89543 1.89543 7 3 7H6V9H3V19H17V16H19V19C19 20.1046 18.1046 21 17 21H3C1.89543 21 1 20.1046 1 19V9Z"
  })),
  name: 'FoldersIcon',
  tags: ["folders", "group"],
  category: 'system'
};
var FulfillmentIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.28137 7H8V5H9.28137C11.2661 5 12.875 6.60892 12.875 8.59363C12.875 10.5783 11.2661 12.1873 9.28137 12.1873H8.31944C6.41713 12.1873 4.875 13.7294 4.875 15.6317V16.0935C4.875 18.2509 6.62389 19.9998 8.78125 19.9998H15V21.9998H8.78125C5.51932 21.9998 2.875 19.3554 2.875 16.0935V15.6317C2.875 12.6248 5.31256 10.1873 8.31944 10.1873H9.28137C10.1615 10.1873 10.875 9.47377 10.875 8.59363C10.875 7.71349 10.1615 7 9.28137 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.875 1.00024H0.875V7.00024H6.875V1.00024ZM2.875 5.00024V3.00024H4.875V5.00024H2.875Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3337 14.4369C19.3337 15.1733 18.7367 15.7702 18.0003 15.7702C17.2639 15.7702 16.667 15.1733 16.667 14.4369C16.667 13.7005 17.2639 13.1036 18.0003 13.1036C18.7367 13.1036 19.3337 13.7005 19.3337 14.4369Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.9995 14.2834C12.9995 11.5703 15.2754 9.43726 17.9995 9.43726C20.7236 9.43726 22.9995 11.5703 22.9995 14.2834C22.9995 15.3527 22.6412 16.3406 22.0399 17.1389L22.0346 17.146L21.9808 17.2159L17.9995 22.0007L14.0182 17.2159L13.9591 17.1389C13.3578 16.3407 12.9995 15.3527 12.9995 14.2834ZM17.9995 11.4373C16.3053 11.4373 14.9995 12.7481 14.9995 14.2834C14.9995 14.8963 15.2028 15.4645 15.5541 15.9323L15.5809 15.9671L17.9995 18.8738L20.4181 15.9671L20.4449 15.9323C20.7962 15.4645 20.9995 14.8963 20.9995 14.2834C20.9995 12.7481 19.6937 11.4373 17.9995 11.4373Z"
  })),
  name: 'FulfillmentIcon',
  tags: ["fulfillment"],
  category: 'sasc'
};
var FunctionIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.75001 5.99557C6.78351 5.99557 6.00001 6.77733 6.00001 7.74168V9.9867H8V11.9823H6.00001V16.9712C6.00001 18.6244 4.65688 19.9645 3.00002 19.9645H2V17.969H3.00002C3.5523 17.969 4.00001 17.5223 4.00001 16.9712V11.9823H2V9.9867H4.00001V7.74168C4.00001 5.67521 5.67894 4 7.75001 4C9.82107 4 11.5 5.67521 11.5 7.74168V7.99113H9.5V7.74168C9.5 6.77733 8.7165 5.99557 7.75001 5.99557Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9528 18.0195L12.421 20C10.3842 18.9891 9 17.0066 9 14.7263C9 12.4079 10.4307 10.3974 12.5233 9.40279L13.0525 11.3734C11.7826 12.1101 11 13.3924 11 14.7263C11 16.0248 11.7418 17.2746 12.9528 18.0195Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22 14.7263C22 16.9554 20.6772 18.9 18.7151 19.9305L18.1793 17.935C19.3119 17.1823 20 15.9769 20 14.7263C20 13.4397 19.2719 12.2011 18.0807 11.4538L18.6135 9.46974C20.6314 10.4858 22 12.4588 22 14.7263Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.5 16.1373L17.0429 17.6767L18.4571 16.2656L16.9142 14.7262L18.4571 13.1867L17.0429 11.7756L15.5 13.3151L13.9571 11.7756L12.5429 13.1867L14.0858 14.7262L12.5429 16.2656L13.9571 17.6767L15.5 16.1373Z"
  })),
  name: 'FunctionIcon',
  tags: ["function", "math"],
  category: 'data'
};
var GearIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 10C10.8955 10 10 10.8954 10 12C10 13.1046 10.8955 14 12 14C13.1046 14 14 13.1046 14 12C14 10.8954 13.1046 10 12 10ZM8.00002 12C8.00002 9.79086 9.79089 8 12 8C14.2092 8 16 9.79086 16 12C16 14.2091 14.2092 16 12 16C9.79089 16 8.00002 14.2091 8.00002 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00003 3C8.00003 1.89543 8.89546 1 10 1H14C15.1046 1 16 1.89543 16 3V4.42277L16.5627 4.74773L17.7946 4.03647C18.7512 3.48418 19.9744 3.81193 20.5267 4.76852L22.526 8.23142C23.0782 9.188 22.7505 10.4112 21.7939 10.9635L20.562 11.6747L20.5623 12.324L21.7945 13.0354C22.7511 13.5877 23.0788 14.8109 22.5266 15.7675L20.526 19.2325C19.9738 20.1891 18.7506 20.5168 17.794 19.9645L16.5619 19.2532L16 19.5774V21C16 22.1046 15.1046 23 14 23H10C8.89546 23 8.00003 22.1046 8.00003 21V19.5774L7.43787 19.2528L6.20581 19.9642C5.24923 20.5164 4.02604 20.1887 3.47376 19.2321L1.47373 15.7679C0.921443 14.8114 1.24919 13.5882 2.20578 13.0359L3.43788 12.3245L3.43795 11.6751L2.20595 10.9639C1.24936 10.4116 0.921615 9.18839 1.4739 8.2318L3.47358 4.76825C4.02587 3.81166 5.24905 3.48391 6.20563 4.0362L7.43763 4.74749L8.00003 4.42272V3ZM14 3H10V4.42272C10 5.13718 9.6189 5.79738 9.0002 6.15467L8.4378 6.47944C7.81897 6.8368 7.05649 6.83684 6.43763 6.47954L5.20564 5.76825L3.20595 9.2318L4.43795 9.94309C5.05681 10.3004 5.43801 10.9607 5.43795 11.6753L5.43788 12.3247C5.43782 13.0392 5.05663 13.6994 4.43788 14.0566L3.20578 14.7679L5.20581 18.2321L6.43787 17.5208C7.05666 17.1635 7.81904 17.1635 8.43784 17.5208L8.99999 17.8453C9.61881 18.2026 10 18.8628 10 19.5774V21H14V19.5774C14 18.8628 14.3813 18.2025 15.0002 17.8453L15.5621 17.521C16.1809 17.1638 16.9431 17.1639 17.5619 17.5211L18.794 18.2325L20.7945 14.7675L19.5623 14.056C18.9437 13.6989 18.5625 13.0389 18.5623 12.3246L18.562 11.6754C18.5618 10.9606 18.943 10.3 19.562 9.94263L20.7939 9.23142L18.7946 5.76852L17.5627 6.47979C16.9437 6.83711 16.1812 6.83705 15.5623 6.47961L14.9997 6.15464C14.3811 5.79733 14 5.13717 14 4.42277V3Z"
  })),
  name: 'GearIcon',
  tags: ["gear", "controls", "preference", "system"],
  category: 'system'
};
var GithubIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M8.35847 18.7145C8.35847 18.8055 8.25645 18.8783 8.12782 18.8783C7.98145 18.8919 7.87944 18.8191 7.87944 18.7145C7.87944 18.6235 7.98145 18.5507 8.11008 18.5507C8.24315 18.5371 8.35847 18.6099 8.35847 18.7145ZM6.97903 18.5098C6.94798 18.6008 7.03669 18.7054 7.16976 18.7327C7.28508 18.7782 7.41815 18.7327 7.44476 18.6417C7.47137 18.5507 7.3871 18.4461 7.25403 18.4051C7.13871 18.3733 7.01008 18.4188 6.97903 18.5098ZM8.93952 18.4324C8.81089 18.4643 8.72218 18.5507 8.73548 18.6554C8.74879 18.7463 8.86411 18.8055 8.99718 18.7736C9.12581 18.7418 9.21452 18.6554 9.20121 18.5644C9.1879 18.4779 9.06814 18.4188 8.93952 18.4324ZM11.8581 1.00012C5.70605 1.00012 1 5.79037 1 12.1C1 17.145 4.09597 21.4622 8.51814 22.9816C9.08589 23.0862 9.28548 22.7268 9.28548 22.4311C9.28548 22.1491 9.27218 20.5933 9.27218 19.638C9.27218 19.638 6.16734 20.3203 5.51532 18.2823C5.51532 18.2823 5.00968 16.9585 4.28226 16.6173C4.28226 16.6173 3.26653 15.9031 4.35323 15.9168C4.35323 15.9168 5.45766 16.0077 6.06532 17.0904C7.03669 18.8464 8.66452 18.3415 9.29879 18.0412C9.40081 17.3134 9.68911 16.8084 10.0085 16.5082C7.52903 16.2261 5.02742 15.8576 5.02742 11.4814C5.02742 10.2303 5.36452 9.60255 6.07419 8.8019C5.95887 8.50621 5.58185 7.28704 6.18952 5.71304C7.11653 5.41734 9.25 6.9413 9.25 6.9413C10.1371 6.68655 11.0907 6.55463 12.0355 6.55463C12.9802 6.55463 13.9339 6.68655 14.821 6.9413C14.821 6.9413 16.9544 5.41279 17.8815 5.71304C18.4891 7.29159 18.1121 8.50621 17.9968 8.8019C18.7065 9.6071 19.1411 10.2349 19.1411 11.4814C19.1411 15.8713 16.5286 16.2216 14.0492 16.5082C14.4573 16.8675 14.8032 17.5499 14.8032 18.619C14.8032 20.152 14.7899 22.049 14.7899 22.422C14.7899 22.7177 14.994 23.0771 15.5573 22.9725C19.9927 21.4622 23 17.145 23 12.1C23 5.79037 18.0101 1.00012 11.8581 1.00012ZM5.31129 16.6901C5.25363 16.7356 5.26694 16.8402 5.34234 16.9267C5.41331 16.9995 5.51532 17.0313 5.57298 16.9722C5.63064 16.9267 5.61734 16.822 5.54194 16.7356C5.47097 16.6628 5.36895 16.631 5.31129 16.6901ZM4.83226 16.3216C4.80121 16.3808 4.84556 16.4536 4.93427 16.4991C5.00524 16.5445 5.09395 16.5309 5.125 16.4672C5.15605 16.4081 5.11169 16.3353 5.02298 16.2898C4.93427 16.2625 4.86331 16.2761 4.83226 16.3216ZM6.26935 17.9411C6.19839 18.0003 6.225 18.1367 6.32702 18.2232C6.42903 18.3278 6.55766 18.3415 6.61532 18.2687C6.67298 18.2095 6.64637 18.0731 6.55766 17.9866C6.46008 17.882 6.32702 17.8683 6.26935 17.9411ZM5.76371 17.2724C5.69274 17.3179 5.69274 17.4362 5.76371 17.5408C5.83468 17.6454 5.95444 17.6909 6.0121 17.6454C6.08306 17.5863 6.08306 17.468 6.0121 17.3634C5.95 17.2588 5.83468 17.2133 5.76371 17.2724Z"
  })),
  name: 'GithubIcon',
  tags: ["github"],
  category: 'system'
};
var GlobeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 23C18.0751 23 23 18.0751 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 18.0751 5.92487 23 12 23ZM12 3C11.8113 3 11.5303 3.0915 11.1696 3.47296C10.8068 3.85653 10.4341 4.46523 10.1 5.30032C9.78951 6.07667 9.52936 7.00607 9.34014 8.04741C10.0646 8.0261 10.6743 8.01437 11.1262 8.00791C11.4024 8.00397 11.6198 8.00199 11.7686 8.001C11.843 8.0005 11.9003 8.00025 11.9393 8.00013L11.9838 8.00002L11.9997 8L12.016 8.00002L12.0605 8.00013C12.0994 8.00025 12.1567 8.0005 12.2312 8.001C12.38 8.00199 12.5974 8.00397 12.8735 8.00791C13.3255 8.01437 13.9353 8.0261 14.6599 8.04741C14.4706 7.00607 14.2105 6.07667 13.9 5.30032C13.5659 4.46523 13.1932 3.85653 12.8304 3.47296C12.4697 3.0915 12.1887 3 12 3ZM8.2431 4.55754C7.83329 5.58205 7.51157 6.79256 7.29818 8.1239C6.21663 8.17321 5.01647 8.24223 3.77586 8.33887C4.7269 6.20573 6.48349 4.51076 8.65909 3.64049C8.50959 3.93083 8.371 4.23779 8.2431 4.55754ZM7.06658 10.137C5.85487 10.1955 4.51112 10.2789 3.1422 10.3978C3.04877 10.9177 3 11.4532 3 12C3 12.4174 3.02841 12.8282 3.08341 13.2304C4.18407 13.4656 5.53535 13.6593 7.06165 13.7935C7.02101 13.2088 7 12.6095 7 12C7 11.3663 7.02271 10.7436 7.06658 10.137ZM7.2892 15.8196C5.96071 15.7135 4.73455 15.5634 3.65482 15.3765C4.57285 17.6432 6.38759 19.4509 8.65909 20.3595C8.50959 20.0692 8.371 19.7622 8.2431 19.4425C7.82751 18.4035 7.5025 17.1732 7.2892 15.8196ZM9.3386 15.9441C10.1994 15.9808 11.0898 16 12 16C12.9102 16 13.8006 15.9808 14.6614 15.9441C14.4721 16.9889 14.2113 17.9212 13.9 18.6997C13.5659 19.5348 13.1932 20.1435 12.8304 20.527C12.4697 20.9085 12.1887 21 12 21C11.8113 21 11.5303 20.9085 11.1696 20.527C10.8068 20.1435 10.4341 19.5348 10.1 18.6997C9.78867 17.9212 9.52795 16.9889 9.3386 15.9441ZM14.9224 13.9301C13.989 13.9756 13.0104 14 12 14C10.9896 14 10.011 13.9756 9.07762 13.9301C9.02691 13.3094 9 12.664 9 12C9 11.3312 9.02731 10.6812 9.07873 10.0564C9.93323 10.0291 10.6467 10.015 11.1548 10.0077C11.4255 10.0038 11.6378 10.0019 11.7819 10.001C11.854 10.0005 11.909 10.0002 11.9457 10.0001L11.987 10H12.0128L12.054 10.0001C12.0908 10.0002 12.1458 10.0005 12.2178 10.001C12.362 10.0019 12.5743 10.0038 12.845 10.0077C13.3531 10.015 14.0667 10.029 14.9213 10.0564C14.9727 10.6812 15 11.3312 15 12C15 12.664 14.9731 13.3094 14.9224 13.9301ZM16.7108 15.8196C16.4975 17.1732 16.1725 18.4035 15.7569 19.4425C15.629 19.7622 15.4904 20.0692 15.3409 20.3595C17.6124 19.4509 19.4272 17.6432 20.3452 15.3765C19.2655 15.5634 18.0393 15.7135 16.7108 15.8196ZM20.9166 13.2304C19.8159 13.4656 18.4647 13.6593 16.9383 13.7935C16.979 13.2088 17 12.6095 17 12C17 11.3663 16.9773 10.7436 16.9334 10.137C18.1451 10.1955 19.4889 10.2789 20.8578 10.3978C20.9512 10.9177 21 11.4532 21 12C21 12.4174 20.9716 12.8282 20.9166 13.2304ZM15.3409 3.64049C17.5165 4.51076 19.2731 6.20574 20.2241 8.33888C18.9835 8.24224 17.7834 8.17322 16.7018 8.1239C16.4884 6.79256 16.1667 5.58205 15.7569 4.55754C15.629 4.23779 15.4904 3.93083 15.3409 3.64049Z"
  })),
  name: 'GlobeIcon',
  tags: ["globe", "world", "map"],
  category: 'system'
};
var GoCartIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.39723 18.5902C8.11321 19.3078 7.87271 19.916 7.86163 19.9439C7.83488 20.0131 7.81353 20.101 7.81353 20.101C7.72354 20.7327 8.2813 20.9307 8.2813 20.9307C9.07416 21.183 9.32061 20.4723 9.32061 20.4723C9.32061 20.4723 9.57463 19.8299 9.85054 19.1322C10.1424 19.4369 10.3207 19.8442 10.3207 20.2917C10.3207 21.2352 9.52869 22.0003 8.55153 22.0003C7.57437 22.0003 6.78232 21.2352 6.78232 20.2917C6.78232 19.3986 7.49222 18.6659 8.39723 18.5902ZM20.8942 14.9798C21.5408 15.2186 22.0002 15.8229 22.0002 16.5313C22.0002 17.4484 21.2301 18.1918 20.2802 18.1918C19.3303 18.1918 18.5602 17.4484 18.5602 16.5313C18.5602 15.945 18.875 15.4302 19.3498 15.1348L19.5198 16.567C19.6662 17.3613 20.4258 17.2274 20.4258 17.2274C21.1417 17.0589 21.0693 16.424 21.0693 16.424L20.8942 14.9798Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5299 1.99121L20.2612 9.20246C20.3575 10.1525 19.7688 11.0381 18.8555 11.317L12.1766 13.3567L12.1745 13.3573C11.3888 13.6005 10.3478 13.8697 9.31327 13.8583L10.255 15.5119L21.4222 12.0741C21.95 11.9116 22.5096 12.2077 22.6721 12.7356C22.8346 13.2634 22.5385 13.823 22.0106 13.9855L21.0466 14.2823L21.3091 16.5906C21.3715 17.1393 20.9773 17.6348 20.4285 17.6972C19.8798 17.7596 19.3843 17.3653 19.3219 16.8166L19.1018 14.881L10.5745 17.5062L9.64491 20.3835C9.47512 20.909 8.91145 21.1974 8.38591 21.0276C7.86037 20.8579 7.57198 20.2942 7.74177 19.7686L8.69586 16.8155L6.1327 12.3151L3.30185 7.6786L2.21895 7.92134C1.68004 8.04215 1.14524 7.70321 1.02443 7.1643C0.903627 6.62539 1.24257 6.09058 1.78148 5.96978L19.5299 1.99121ZM5.36306 7.21655L7.82059 11.2416C8.14443 11.6538 8.62421 11.8446 9.30343 11.858C10.0225 11.8721 10.8331 11.679 11.5849 11.4462L11.5887 11.445L18.2714 9.40425L17.7675 4.4359L5.36306 7.21655Z"
  })),
  name: 'GoCartIcon',
  tags: ["go", "cart"],
  category: 'system'
};
var GridIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H9C10.1046 2 11 2.89543 11 4V9C11 10.1046 10.1046 11 9 11H4C2.89543 11 2 10.1046 2 9V4ZM9 4H4V9H9V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15C2 13.8954 2.89543 13 4 13H9C10.1046 13 11 13.8954 11 15V20C11 21.1046 10.1046 22 9 22H4C2.89543 22 2 21.1046 2 20V15ZM9 15H4V20H9V15Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4C13 2.89543 13.8954 2 15 2H20C21.1046 2 22 2.89543 22 4V9C22 10.1046 21.1046 11 20 11H15C13.8954 11 13 10.1046 13 9V4ZM20 4H15V9H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 15C13 13.8954 13.8954 13 15 13H20C21.1046 13 22 13.8954 22 15V20C22 21.1046 21.1046 22 20 22H15C13.8954 22 13 21.1046 13 20V15ZM20 15H15V20H20V15Z"
  })),
  name: 'GridIcon',
  tags: ["grid", "square", "shape"],
  category: 'system'
};
var GroupIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 4C14.1041 4 13.3009 4.39144 12.7497 5.01591L11.2503 3.69244C12.165 2.65607 13.5065 2 15 2C17.7614 2 20 4.23858 20 7C20 9.76142 17.7614 12 15 12C13.5925 12 12.3194 11.4171 11.4119 10.4822L12.847 9.08919C13.3934 9.65213 14.1552 10 15 10C16.6569 10 18 8.65685 18 7C18 5.34315 16.6569 4 15 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 4C7.34315 4 6 5.34315 6 7C6 8.65685 7.34315 10 9 10C10.6569 10 12 8.65685 12 7C12 5.34315 10.6569 4 9 4ZM4 7C4 4.23858 6.23858 2 9 2C11.7614 2 14 4.23858 14 7C14 9.76142 11.7614 12 9 12C6.23858 12 4 9.76142 4 7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 15C5.34315 15 4 16.3431 4 18V20H14V18C14 16.3431 12.6569 15 11 15H7ZM2 18C2 15.2386 4.23858 13 7 13H11C13.7614 13 16 15.2386 16 18V20C16 21.1046 15.1046 22 14 22H4C2.89543 22 2 21.1046 2 20V18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5 13H17C19.7614 13 22 15.2386 22 18V20C22 21.1046 21.1046 22 20 22H13V20H20V18C20 16.3431 18.6569 15 17 15H10.5V13Z"
  })),
  name: 'GroupIcon',
  tags: ["group", "person", "people", "users"],
  category: 'system'
};
var GroupingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 7H14V14H7V7ZM9 9V12H12V9H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 12H14V10H17V17H10V14H12V15H15V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H6V4H4V6H2V4ZM14 4H10V2H14V4ZM18 2H20C21.1046 2 22 2.89543 22 4V6H20V4H18V2ZM22 10V14H20V10H22ZM4 10V14H2L2 10H4ZM2 20V18H4V20H6V22H4C2.89543 22 2 21.1046 2 20ZM20 20V18H22V20C22 21.1046 21.1046 22 20 22H18V20H20ZM14 22H10V20H14V22Z"
  })),
  name: 'GroupingIcon',
  tags: ["grouping", "connect"],
  category: 'sasc'
};
var GuestPriceChallengeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 6C5.46243 6 3 8.46243 3 11.5C3 14.5376 5.46243 17 8.5 17C11.5376 17 14 14.5376 14 11.5C14 8.46243 11.5376 6 8.5 6ZM1 11.5C1 7.35786 4.35786 4 8.5 4C10.0821 4 11.5498 4.48986 12.7596 5.32618L13.5 4.58579C13.8751 4.21071 14.3838 4 14.9142 4H21C22.1046 4 23 4.89543 23 6V12.6462C23 13.1674 22.7966 13.668 22.433 14.0414L14.7125 21.9714C13.9347 22.7703 12.6537 22.7789 11.8652 21.9904L8.86609 18.9912C8.74479 18.9971 8.62274 19 8.5 19C4.35786 19 1 15.6421 1 11.5ZM11.2019 18.4986L13.2795 20.5762L21 12.6462V6L14.9142 6L14.2408 6.67343C15.3386 7.97782 16 9.66167 16 11.5C16 14.6896 14.0089 17.4142 11.2019 18.4986ZM19 9C19 9.55228 18.5523 10 18 10C17.4477 10 17 9.55228 17 9C17 8.44772 17.4477 8 18 8C18.5523 8 19 8.44772 19 9ZM9.36982 12.75H7.61834V7.25H9.36982V12.75ZM9.5 14.8003C9.5 15.3092 9.03846 15.7944 8.51775 15.7944C7.97337 15.7944 7.5 15.3565 7.5 14.8003C7.5 14.2322 7.97337 13.7944 8.50592 13.7944C9.0503 13.7944 9.5 14.2559 9.5 14.8003Z"
  })),
  name: 'GuestPriceChallengeIcon',
  tags: ["guest", "price", "challenge", "alert", "warning"],
  category: 'sasc'
};
var HashtagIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.66976 3L7.85617 7H4.53681L4.13001 9H7.44937L6.22897 15H2.90968L2.50288 17H5.82218L5.00858 21H7.05626L7.86986 17H14.1607L13.3471 21H15.3948L16.2084 17H19.4689L19.8757 15H16.6152L17.8356 9H21.0961L21.5029 7H18.2424L19.056 3H17.0083L16.1947 7H9.90385L10.7175 3H8.66976ZM14.5675 15L15.7879 9H9.49705L8.27666 15H14.5675Z"
  })),
  name: 'HashtagIcon',
  tags: ["hashtag", "pound", "number"],
  category: 'data'
};
var HeartFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.42857 4.22416C5.33333 2.36818 8.19048 2.83214 10.0952 4.22412L12 5.78354L13.9048 4.22412C15.8095 2.83213 18.6667 2.3682 20.5714 4.22416C22.4762 6.08011 22.4762 9.79211 20.5714 12.576C19.0278 14.8321 14.3568 18.9639 12.6411 20.4496C12.2719 20.7693 11.7281 20.7693 11.3589 20.4497C9.64315 18.964 4.97216 14.8321 3.42856 12.576C1.52381 9.79211 1.52382 6.08015 3.42857 4.22416Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73069 3.50795C5.12334 1.17656 8.56616 1.86811 10.6853 3.41674L10.7075 3.43295L12 4.49116L13.2926 3.43295L13.3147 3.41674C15.4339 1.8681 18.8767 1.17659 21.2693 3.50794C22.4629 4.671 23 6.34989 23 8.0521C23 9.76221 22.4626 11.5829 21.3967 13.1407C20.5575 14.3674 18.9293 16.0312 17.3606 17.5258C15.7691 19.042 14.1591 20.458 13.2957 21.2056C12.5508 21.8507 11.4492 21.8507 10.7043 21.2056C9.84093 20.458 8.2309 19.042 6.63939 17.5258C5.07069 16.0312 3.44252 14.3674 2.60324 13.1407C1.5374 11.5829 0.999997 9.76222 1 8.05212C1 6.34991 1.53706 4.67102 2.73069 3.50795ZM9.48388 5.01599C7.79573 3.7942 5.53736 3.56559 4.12645 4.94038C3.41533 5.63329 3 6.73838 3 8.05213C3 9.35799 3.41496 10.7852 4.25387 12.0114C4.95819 13.0408 6.43732 14.5709 8.01895 16.0777C9.56958 17.555 11.1445 18.9409 12 19.682C12.8555 18.9409 14.4304 17.555 15.981 16.0777C17.5627 14.5709 19.0418 13.0408 19.7461 12.0114C20.585 10.7852 21 9.35798 21 8.05211C21 6.73836 20.5847 5.63327 19.8736 4.94037C18.4627 3.56561 16.2043 3.79421 14.5161 5.01599L12 7.07593L9.48388 5.01599Z"
  })),
  name: 'HeartFilledIcon',
  tags: ["heart", "filled", "favorite", "love"],
  category: 'toggle'
};
var HeartIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.73069 3.50795C5.12334 1.17656 8.56616 1.86811 10.6853 3.41674L10.7075 3.43295L12 4.49116L13.2926 3.43295L13.3147 3.41674C15.4339 1.8681 18.8767 1.17659 21.2693 3.50794C22.4629 4.671 23 6.34989 23 8.0521C23 9.76221 22.4626 11.5829 21.3967 13.1407C20.5575 14.3674 18.9293 16.0312 17.3606 17.5258C15.7691 19.042 14.1591 20.458 13.2957 21.2056C12.5508 21.8507 11.4492 21.8507 10.7043 21.2056C9.84093 20.458 8.2309 19.042 6.63939 17.5258C5.07069 16.0312 3.44252 14.3674 2.60324 13.1407C1.5374 11.5829 0.999997 9.76222 1 8.05212C1 6.34991 1.53706 4.67102 2.73069 3.50795ZM9.48388 5.01599C7.79573 3.7942 5.53736 3.56559 4.12645 4.94038C3.41533 5.63329 3 6.73838 3 8.05213C3 9.35799 3.41496 10.7852 4.25387 12.0114C4.95819 13.0408 6.43732 14.5709 8.01895 16.0777C9.56958 17.555 11.1445 18.9409 12 19.682C12.8555 18.9409 14.4304 17.555 15.981 16.0777C17.5627 14.5709 19.0418 13.0408 19.7461 12.0114C20.585 10.7852 21 9.35798 21 8.05211C21 6.73836 20.5847 5.63327 19.8736 4.94037C18.4627 3.56561 16.2043 3.79421 14.5161 5.01599L12 7.07593L9.48388 5.01599Z"
  })),
  name: 'HeartIcon',
  tags: ["heart", "favorite", "love"],
  category: 'toggle'
};
var HelpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.42508 7.99977C9.56645 4.38542 14.6374 4.26596 15.9477 7.82254C16.3932 9.03178 15.975 10.3896 14.9263 11.1387L13.8079 11.9376C13.3009 12.2997 13 12.8844 13 13.5074V14H11V13.5074C11 12.2385 11.6128 11.0477 12.6454 10.3101L13.7639 9.51119C14.0792 9.28594 14.205 8.8776 14.071 8.51395C13.4198 6.74632 10.8995 6.8057 10.3322 8.60204L9.95358 9.80113L8.04642 9.19887L8.42508 7.99977Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 16.5C13.5 17.3284 12.8284 18 12 18C11.1716 18 10.5 17.3284 10.5 16.5C10.5 15.6716 11.1716 15 12 15C12.8284 15 13.5 15.6716 13.5 16.5Z"
  })),
  name: 'HelpIcon',
  tags: ["help", "question", "?", "circle"],
  category: 'system'
};
var HistoryIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.29291 11.2929L6.02258 12.5632C5.91401 11.2183 6.19613 9.86328 6.84528 8.66519C7.64523 7.1888 8.94924 6.04916 10.5195 5.45413C12.0897 4.85909 13.8215 4.84832 15.399 5.42378C16.9765 5.99924 18.2945 7.12257 19.1128 8.5889C19.931 10.0552 20.1949 11.7668 19.8563 13.4115C19.5178 15.0562 18.5992 16.5244 17.2683 17.5483C15.9374 18.5721 14.2828 19.0835 12.6063 18.989C10.9298 18.8946 9.34305 18.2006 8.13555 17.0338L6.74581 18.4719C8.29827 19.9721 10.3383 20.8643 12.4938 20.9858C14.6493 21.1072 16.7766 20.4497 18.4877 19.1334C20.1989 17.817 21.3798 15.9293 21.8151 13.8148C22.2505 11.7002 21.9112 9.49962 20.8592 7.61437C19.8071 5.72913 18.1125 4.28486 16.0843 3.545C14.0561 2.80514 11.8296 2.81899 9.81078 3.58402C7.79196 4.34905 6.11541 5.81428 5.08692 7.71246C4.27128 9.21782 3.90632 10.9159 4.02043 12.6062L2.70712 11.2929L1.29291 12.7071L4.29291 15.7071L5.00001 16.4142L5.70712 15.7071L8.70712 12.7071L7.29291 11.2929ZM11.5 7V12.5V13.0542L11.97 13.348L15.97 15.848L17.03 14.152L13.5 11.9458V7H11.5Z"
  })),
  name: 'HistoryIcon',
  tags: ["clock", "history", "time"],
  category: 'system'
};
var HouseIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.00001 9.99997V21H19V9.99997H21V21C21 22.1045 20.1046 23 19 23H5.00001C3.89544 23 3.00001 22.1045 3.00001 21V9.99997H5.00001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 1.99997C11.3669 1.21892 12.6332 1.21892 13.4142 1.99997L22.7071 11.2929L21.2929 12.7071L12 3.41418L2.70712 12.7071L1.29291 11.2929L10.5858 1.99997Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 17C9.00001 15.8954 9.89544 15 11 15H13C14.1046 15 15 15.8954 15 17V21C15 22.1045 14.1046 23 13 23H11C9.89544 23 9.00001 22.1045 9.00001 21V17ZM13 17H11V21H13V17Z"
  })),
  name: 'HouseIcon',
  tags: ["house", "home"],
  category: 'system'
};
var HuddleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.19246 6.81505C8.3153 3.22941 11.782 0.746968 15.6941 1.02053C20.2681 1.34037 23.7168 5.30761 23.397 9.88161C23.325 10.9109 23.0677 11.8852 22.6593 12.7727L23.1372 17.2531L19.2295 16.5143C18.5677 16.8925 17.85 17.182 17.0938 17.3674C16.0815 20.4633 13.2769 22.7938 9.82548 23.0351C8.14134 23.1529 6.53769 22.7557 5.17191 21.9777L1.22194 22.789L1.75035 18.2472C1.34632 17.3671 1.09175 16.4013 1.02041 15.381C0.738193 11.3452 3.40848 7.7848 7.19246 6.81505ZM9.43985 6.55755C9.66018 6.5624 9.87878 6.576 10.0953 6.59806C14.0144 6.99757 17.1954 10.1659 17.4796 14.2301C17.501 14.5363 17.5054 14.8401 17.4935 15.1403C17.846 14.9964 18.1833 14.8212 18.5017 14.6179L18.836 14.4045L20.8629 14.7877L20.609 12.4077L20.7423 12.1441C21.1093 11.4182 21.3413 10.6079 21.4018 9.7421C21.6446 6.26997 19.0267 3.25844 15.5546 3.01565C12.9087 2.83064 10.529 4.30747 9.43985 6.55755ZM9.89244 8.58775C9.54062 8.55189 9.18031 8.54545 8.81404 8.57107C5.37084 8.81184 2.77476 11.7983 3.01553 15.2415C3.07557 16.1001 3.30561 16.9037 3.66958 17.6235L3.8052 17.8918L3.52809 20.2735L5.54954 19.8583L5.89147 20.0767C6.98166 20.7727 8.29521 21.1373 9.68597 21.04C12.4923 20.8438 14.7382 18.8228 15.3406 16.2152C15.4767 15.6264 15.529 15.0067 15.4845 14.3696C15.2693 11.2925 12.8602 8.89028 9.89244 8.58775Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.25001 14.8C7.25001 15.3523 6.8023 15.8 6.25001 15.8C5.69773 15.8 5.25001 15.3523 5.25001 14.8C5.25001 14.2477 5.69773 13.8 6.25001 13.8C6.8023 13.8 7.25001 14.2477 7.25001 14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.25 14.8C10.25 15.3523 9.8023 15.8 9.25001 15.8C8.69773 15.8 8.25001 15.3523 8.25001 14.8C8.25001 14.2477 8.69773 13.8 9.25001 13.8C9.8023 13.8 10.25 14.2477 10.25 14.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.25 14.8C13.25 15.3523 12.8023 15.8 12.25 15.8C11.6977 15.8 11.25 15.3523 11.25 14.8C11.25 14.2477 11.6977 13.8 12.25 13.8C12.8023 13.8 13.25 14.2477 13.25 14.8Z"
  })),
  name: 'HuddleIcon',
  tags: ["huddle", "talk", "communicate", "message"],
  category: 'sasc'
};
var ImageIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V20C22 21.1046 21.1046 22 20 22H4C2.89543 22 2 21.1046 2 20V4ZM20 4L4 4V20H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 8C18 9.10457 17.1046 10 16 10C14.8954 10 14 9.10457 14 8C14 6.89543 14.8954 6 16 6C17.1046 6 18 6.89543 18 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.88286 10.4644C6.45348 8.94272 8.50448 8.70083 9.41343 10.048L13.0957 15.5055L15.62 13.9725C16.5689 13.3962 17.8057 13.7031 18.3751 14.6562L20.9547 18.9743C21.7511 20.3074 20.7906 22 19.2377 22H4.443C3.04659 22 2.08003 20.6053 2.57034 19.2978L5.88286 10.4644ZM11.4378 16.6241L7.75552 11.1666L4.443 20H19.2377L16.6581 15.6819L14.1339 17.2149C13.2216 17.769 12.0349 17.509 11.4378 16.6241Z"
  })),
  name: 'ImageIcon',
  tags: ["image", "photo", "picture", "art"],
  category: 'system'
};
var ImagesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 8C2 6.89543 2.89543 6 4 6H7V8L4 8V20H16V17H18V20C18 21.1046 17.1046 22 16 22H4C2.89543 22 2 21.1046 2 20V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 4C6 2.89543 6.89543 2 8 2H20C21.1046 2 22 2.89543 22 4V16C22 17.1046 21.1046 18 20 18H8C6.89543 18 6 17.1046 6 16V4ZM20 4L8 4V16H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 6C19 6.55228 18.5523 7 18 7C17.4477 7 17 6.55228 17 6C17 5.44772 17.4477 5 18 5C18.5523 5 19 5.44772 19 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.38474 7.51578C9.94499 5.97511 12.0191 5.72583 12.9284 7.08987L15.2774 10.6132L16.445 9.8348C17.4855 9.14117 18.9001 9.56172 19.3927 10.7111L21.3218 15.2122C21.8874 16.5319 20.9193 18 19.4835 18H8.4277C7.03977 18 6.0738 16.6209 6.54811 15.3165L9.38474 7.51578ZM13.6132 11.7227L11.2643 8.19927L8.4277 16H19.4835L17.5544 11.4989L16.3868 12.2773C15.4677 12.8901 14.226 12.6417 13.6132 11.7227Z"
  })),
  name: 'ImagesIcon',
  tags: ["images", "photos", "pictures", "art", "group"],
  category: 'system'
};
var ImportIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 15.5858L8.70711 12.2929L7.2929 13.7071L12 18.4142L16.7071 13.7071L15.2929 12.2929L12 15.5858Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 2L13 17H11L11 2L13 2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21 20C21 21.1046 20.1046 22 19 22L5 22C3.89543 22 3 21.1046 3 20L3 10C3 8.89543 3.89543 8 5 8L8 8V10L5 10L5 20L19 20V10L16 10V8L19 8C20.1046 8 21 8.89543 21 10V20Z"
  })),
  name: 'ImportIcon',
  tags: ["import", "inside"],
  category: 'system'
};
var InProgressFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13.272 5.58051C12.8424 5.49537 12.415 5.45443 11.9942 5.45429L11.9947 4C12.5097 4.00017 13.0316 4.0503 13.5547 4.15396C14.0778 4.25762 14.5794 4.41033 15.0556 4.60657C16.0466 5.01501 16.9254 5.61137 17.6566 6.34393C17.7378 6.42525 17.8172 6.50827 17.8947 6.5929C17.9928 6.70004 18.088 6.80976 18.18 6.92192C18.6779 7.52851 19.0856 8.20637 19.3879 8.93296C19.9756 10.3451 20.1657 11.9413 19.8459 13.5549C19.58 14.8969 18.9917 16.0954 18.1771 17.0837C17.6781 17.689 17.0945 18.2151 16.4485 18.6474C16.0141 18.9382 15.5513 19.1865 15.0669 19.388L14.5082 18.0454C15.3015 17.7153 16.0242 17.2316 16.6318 16.6242C16.7799 16.4762 16.9212 16.3209 17.0549 16.1587C17.4607 15.6664 17.798 15.1102 18.0488 14.5015C18.2091 14.1125 18.3342 13.7018 18.4193 13.2721C18.4821 12.9557 18.5208 12.6405 18.5369 12.3282C18.588 11.3359 18.4109 10.3704 18.0453 9.49163C17.7152 8.69836 17.2315 7.97573 16.6241 7.36806C15.7396 6.48331 14.5928 5.84225 13.272 5.58051ZM9.49162 5.95464C8.69835 6.28473 7.97569 6.76835 7.36803 7.3758L6.33989 6.34727C7.08199 5.60543 7.96413 5.01508 8.93291 4.61195L9.49162 5.95464ZM5.5805 10.7279C5.66564 10.2982 5.79079 9.88748 5.95112 9.49848L4.60657 8.94431C4.41033 9.42045 4.25761 9.9221 4.15396 10.4452C4.0503 10.9683 4.00017 11.4903 4 12.0052L5.45428 12.0057C5.45441 11.585 5.49536 11.1575 5.5805 10.7279ZM5.95462 14.5083C6.28471 15.3016 6.76833 16.0243 7.37577 16.6319L6.34725 17.6601C5.60541 16.918 5.01507 16.0358 4.61195 15.067L5.95462 14.5083ZM10.7278 18.4195C10.2982 18.3343 9.88743 18.2092 9.49842 18.0489L8.94426 19.3934C9.42039 19.5897 9.92204 19.7424 10.4451 19.846C10.9682 19.9497 11.4902 19.9998 12.0052 20L12.0056 18.5457C11.5849 18.5456 11.1575 18.5046 10.7278 18.4195Z"
  })),
  name: 'InProgressFilledIcon',
  tags: ["progress", "in progress", "status"],
  category: 'status'
};
var InProgressIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,3c0.6,0,1.2,0.1,1.8,0.2c0.6,0.1,1.2,0.3,1.7,0.5c1.1,0.5,2.1,1.1,2.9,1.9c0.8,0.8,1.5,1.8,2,2.9 c0.5,1.2,0.7,2.5,0.7,3.9c0,0.1,0,0.2,0,0.2c0,0.4-0.1,0.7-0.1,1.1c-0.1,0.6-0.3,1.2-0.5,1.7C20,16.3,19.5,17,19,17.7 c-0.2,0.2-0.4,0.4-0.6,0.6c-0.8,0.8-1.8,1.5-2.9,2l0.8,1.8c0.7-0.3,1.3-0.6,1.9-1c0.9-0.6,1.7-1.3,2.4-2.2c1.1-1.4,1.9-3,2.3-4.9 c0.4-2.3,0.2-4.5-0.7-6.5c-0.6-1.3-1.3-2.5-2.3-3.5c-1.5-1.5-3.4-2.6-5.6-3c0,0,0,0,0,0C13.4,1.1,12.7,1,12,1L12,3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,5.6c0.8-0.8,1.8-1.5,2.9-2L7.8,1.8C6.4,2.4,5.2,3.2,4.2,4.2L5.6,5.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.2,10.3c0.1-0.6,0.3-1.2,0.5-1.7L1.8,7.8C1.6,8.5,1.4,9.1,1.2,9.9C1.1,10.6,1,11.3,1,12l2,0C3,11.4,3.1,10.8,3.2,10.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.6,18.4c-0.8-0.8-1.5-1.8-2-2.9l-1.8,0.8c0.6,1.3,1.4,2.5,2.4,3.6L5.6,18.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3,20.8c-0.6-0.1-1.2-0.3-1.7-0.5l-0.8,1.8c0.7,0.3,1.3,0.5,2.1,0.6c0.7,0.1,1.4,0.2,2.1,0.2l0-2 C11.4,21,10.8,20.9,10.3,20.8z"
  })),
  name: 'InProgressIcon',
  tags: ["progress", "in progress", "status"],
  category: 'status'
};
var InboxIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.82918 4.10557C5.16796 3.428 5.86049 3 6.61803 3H17.382C18.1395 3 18.832 3.428 19.1708 4.10557L22.7889 11.3416C22.9277 11.6194 23 11.9256 23 12.2361V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V12.2361C1 11.9256 1.07229 11.6194 1.21115 11.3416L4.82918 4.10557ZM17.382 5H6.61803L3 12.2361V19H21V12.2361L17.382 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 11H8C9.15251 11 9.85628 11.9238 10.1093 12.6547C10.3809 13.4391 11.1262 14 12 14C12.8738 14 13.6191 13.4391 13.8907 12.6547C14.1437 11.9238 14.8475 11 16 11H22V13H16.0027C15.9952 13.0026 15.9774 13.0114 15.9489 13.0372C15.8901 13.0903 15.8232 13.186 15.7806 13.3091C15.2388 14.874 13.7522 16 12 16C10.2478 16 8.76121 14.874 8.2194 13.3091C8.1768 13.186 8.10987 13.0903 8.05111 13.0372C8.02257 13.0114 8.00484 13.0026 7.99732 13H2V11Z"
  })),
  name: 'InboxIcon',
  tags: ["inbox", "mail", "message", "notifications", "alerts"],
  category: 'system'
};
var InfoFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12ZM13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5ZM11 12H9.5V10H13V16H15V18H9V16H11V12Z"
  })),
  name: 'InfoFilledIcon',
  tags: ["info", "information", "help", "filled"],
  category: 'status'
};
var InfoIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.5C13.5 8.32843 12.8284 9 12 9C11.1716 9 10.5 8.32843 10.5 7.5C10.5 6.67157 11.1716 6 12 6C12.8284 6 13.5 6.67157 13.5 7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 12H9.5V10H13V16H15V18H9V16H11V12Z"
  })),
  name: 'InfoIcon',
  tags: ["info", "help", "information", "customer", "service"],
  category: 'system'
};
var InventoryAuditIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9996 2.9375C11.9996 1.83293 12.895 0.9375 13.9996 0.9375H17.9996C19.1041 0.9375 19.9996 1.83293 19.9996 2.9375V5.17046C21.1648 5.5823 21.9996 6.69354 21.9996 7.99976V22.9998H9.99957V20.4569C9.79303 20.4775 9.58352 20.4881 9.37155 20.4881C7.95655 20.4881 6.65149 20.0174 5.60439 19.2241L2.7072 22.1214L1.29297 20.7072L4.22267 17.7774C3.53185 16.7726 3.1275 15.5555 3.1275 14.244C3.1275 10.7956 5.92306 8 9.37155 8C9.58352 8 9.79303 8.01056 9.99957 8.03119V7.99976C9.99957 6.69354 10.8344 5.5823 11.9996 5.17046V2.9375ZM11.9996 20.9998V19.9097C14.135 18.9176 15.6156 16.7537 15.6156 14.244C15.6156 11.7344 14.135 9.57051 11.9996 8.57834V7.99976C11.9996 7.44747 12.4473 6.99976 12.9996 6.99976H18.9996C19.5519 6.99976 19.9996 7.44747 19.9996 7.99976V20.9998H11.9996ZM17.9996 4.9375H13.9996V2.9375H17.9996V4.9375ZM9.37155 10C7.02763 10 5.1275 11.9001 5.1275 14.244C5.1275 16.588 7.02763 18.4881 9.37155 18.4881C11.7155 18.4881 13.6156 16.588 13.6156 14.244C13.6156 11.9001 11.7155 10 9.37155 10Z"
  })),
  name: 'InventoryAuditIcon',
  tags: ["inventory", "audit"],
  category: 'sasc'
};
var JiraIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22.0515 11.3855C18.919 8.26172 14.7726 4.08516 11.6745 1C4.56318 8.08555 1.25459 11.3855 1.25459 11.3855C0.915137 11.725 0.915137 12.275 1.25459 12.6187C6.96084 18.3035 3.91006 15.2613 11.6745 23C27.9769 6.75781 12.3491 22.2824 22.0515 12.6145C22.3952 12.275 22.3952 11.725 22.0515 11.3855V11.3855ZM11.6745 15.2527L8.40889 12L11.6745 8.74727L14.9401 12L11.6745 15.2527Z"
  })),
  name: 'JiraIcon',
  tags: ["jira"],
  category: 'system'
};
var LightDarkModeFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M20.8323 14.4172C21.5971 14.1068 22.4765 14.682 22.2402 15.4728C21.0078 19.5985 17.1837 22.606 12.6572 22.606C7.13438 22.606 2.65723 18.1289 2.65723 12.606C2.65723 8.0796 5.66457 4.2556 9.79017 3.02308C10.581 2.78682 11.1562 3.66618 10.8458 4.43097C9.54517 7.63568 9.89117 11.0475 12.0534 13.2097C14.2157 15.372 17.6276 15.7179 20.8323 14.4172Z"
  })),
  name: 'LightDarkModeFilledIcon',
  tags: ["light", "dark", "mode", "moon", "filled"],
  category: 'toggle'
};
var LightDarkModeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.3845 16.6351C16.2493 17.277 12.971 16.6527 10.6392 14.3209C8.30746 11.9892 7.68308 8.71099 8.3249 5.57584C6.11733 7.00076 4.65723 9.48295 4.65723 12.303C4.65723 16.7213 8.23895 20.303 12.6572 20.303C15.4774 20.303 17.9596 18.8428 19.3845 16.6351ZM20.8323 14.1142C21.5971 13.8038 22.4765 14.3789 22.2402 15.1698C21.0078 19.2955 17.1837 22.303 12.6572 22.303C7.13438 22.303 2.65723 17.8258 2.65723 12.303C2.65723 7.77659 5.66457 3.95259 9.79017 2.72007C10.581 2.48381 11.1562 3.36317 10.8458 4.12796C9.54517 7.33267 9.89117 10.7444 12.0534 12.9067C14.2157 15.0689 17.6276 15.4149 20.8323 14.1142Z"
  })),
  name: 'LightDarkModeIcon',
  tags: ["light", "dark", "mode", "moon"],
  category: 'toggle'
};
var LinkIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7782 4.22182C18.6066 3.05025 16.7071 3.05025 15.5355 4.22182L11.2929 8.46446C10.1213 9.63603 10.1213 11.5355 11.2929 12.7071C11.6834 13.0976 11.6834 13.7308 11.2929 14.1213C10.9024 14.5118 10.2692 14.5118 9.87867 14.1213C7.92605 12.1687 7.92605 9.00287 9.87867 7.05025L14.1213 2.80761C16.0739 0.854984 19.2398 0.854984 21.1924 2.80761C23.145 4.76023 23.145 7.92605 21.1924 9.87867L18.364 12.7071C17.9734 13.0976 17.3403 13.0976 16.9497 12.7071C16.5592 12.3166 16.5592 11.6834 16.9497 11.2929L19.7782 8.46446C20.9497 7.29289 20.9497 5.39339 19.7782 4.22182Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 9.87867C13.0976 9.48815 13.7308 9.48815 14.1213 9.87867C16.0739 11.8313 16.0739 14.9971 14.1213 16.9497L9.87867 21.1924C7.92605 23.145 4.76023 23.145 2.80761 21.1924C0.854984 19.2398 0.854984 16.0739 2.80761 14.1213L5.63603 11.2929C6.02656 10.9024 6.65972 10.9024 7.05025 11.2929C7.44077 11.6834 7.44077 12.3166 7.05025 12.7071L4.22182 15.5355C3.05025 16.7071 3.05025 18.6066 4.22182 19.7782C5.39339 20.9497 7.29289 20.9497 8.46446 19.7782L12.7071 15.5355C13.8787 14.364 13.8787 12.4645 12.7071 11.2929C12.3166 10.9024 12.3166 10.2692 12.7071 9.87867Z"
  })),
  name: 'LinkIcon',
  tags: ["link", "chain"],
  category: 'system'
};
var ListCheckIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73826 4.60973L7.3177 1.26892L8.68233 2.73103L3.69034 7.39023L1.29291 4.9928L2.70712 3.57858L3.73826 4.60973Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73826 11.6097L7.3177 8.26892L8.68233 9.73103L3.69034 14.3902L1.29291 11.9928L2.70712 10.5786L3.73826 11.6097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.73826 18.6097L7.3177 15.2689L8.68233 16.731L3.69034 21.3902L1.29291 18.9928L2.70712 17.5786L3.73826 18.6097Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 5.99998H10V3.99998H23V5.99998Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13H10V11H23V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 20H10V18H23V20Z"
  })),
  name: 'ListCheckIcon',
  tags: ["list", "check", "complete", "approved"],
  category: 'system'
};
var ListOrderedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6H10V4H23V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13H10V11H23V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 20H10V18H23V20Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 5H1V3H3C4.10457 3 5 3.89543 5 5V9H7V11H1V9H3V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 15H1V13H5C6.10457 13 7 13.8954 7 15V16C7 17.1046 6.10457 18 5 18H3V19H7V21H3C1.89543 21 1 20.1046 1 19V18C1 16.8954 1.89543 16 3 16H5V15Z"
  })),
  name: 'ListOrderedIcon',
  tags: ["list", "ordered", "number", "priority"],
  category: 'system'
};
var ListUnorderedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3C4.10457 3 5 3.89543 5 5C5 6.10457 4.10457 7 3 7C1.89543 7 1 6.10457 1 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 12C1 10.8954 1.89543 10 3 10C4.10457 10 5 10.8954 5 12C5 13.1046 4.10457 14 3 14C1.89543 14 1 13.1046 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 19C1 17.8954 1.89543 17 3 17C4.10457 17 5 17.8954 5 19C5 20.1046 4.10457 21 3 21C1.89543 21 1 20.1046 1 19Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 6H10V4H23V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 13H10V11H23V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23 20H10V18H23V20Z"
  })),
  name: 'ListUnorderedIcon',
  tags: ["list", "unordered", "bullet"],
  category: 'system'
};
var LockLockedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 9V6.66667C6 3.47319 8.75239 1 12 1C15.2476 1 18 3.47319 18 6.66667V9H19C20.1046 9 21 9.89543 21 11V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V11C3 9.89543 3.89543 9 5 9H6ZM8 6.66667C8 4.70549 9.72476 3 12 3C14.2752 3 16 4.70549 16 6.66667V9H8V6.66667ZM11 14V18H13V14H11Z"
  })),
  name: 'LockLockedIcon',
  tags: ["lock", "locked", "security"],
  category: 'toggle'
};
var LockUnlockedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.89543 3.89543 9 5 9H19C20.1046 9 21 9.89543 21 11V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V11ZM19 11H5V21H19V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C9.72476 3 8 4.70549 8 6.66667V10H6V6.66667C6 3.47319 8.75239 1 12 1C15.2476 1 18 3.47319 18 6.66667H16C16 4.70549 14.2752 3 12 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18V14H13V18H11Z"
  })),
  name: 'LockUnlockedIcon',
  tags: ["lock", "unlocked", "security"],
  category: 'toggle'
};
var LockIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.89543 3.89543 9 5 9H19C20.1046 9 21 9.89543 21 11V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V11ZM19 11H5V21H19V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C9.72476 3 8 4.70549 8 6.66667V10H6V6.66667C6 3.47319 8.75239 1 12 1C15.2476 1 18 3.47319 18 6.66667V10H16V6.66667C16 4.70549 14.2752 3 12 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18V14H13V18H11Z"
  })),
  name: 'LockIcon',
  tags: ["lock", "security"],
  category: 'system'
};
var LoginIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.7071 7.29289L17.4142 12L12.7071 16.7071L11.2929 15.2929L14.5858 12L11.2929 8.70711L12.7071 7.29289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 13H3V11H15V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H19C20.1046 1 21 1.89543 21 3V21C21 22.1046 20.1046 23 19 23H9C7.89543 23 7 22.1046 7 21V20H9V21H19V3H9V4H7V3Z"
  })),
  name: 'LoginIcon',
  tags: ["login", "arrow"],
  category: 'system'
};
var LogoutIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 7.29289L22.4142 12L17.7071 16.7071L16.2929 15.2929L19.5858 12L16.2929 8.70711L17.7071 7.29289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13H8V11H20V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H15C16.1046 1 17 1.89543 17 3V4H15V3H5V21H15V20H17V21C17 22.1046 16.1046 23 15 23H5C3.89543 23 3 22.1046 3 21V3Z"
  })),
  name: 'LogoutIcon',
  tags: ["logout", "arrow"],
  category: 'system'
};
var LoyaltyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.80575 8.21646C10.9004 8.77643 11.4289 10.419 10.5796 12.1549C10.1981 12.933 9.62847 13.5919 8.78975 14.395L8.3476 14.8098C8.27004 14.8814 8.19053 14.9542 8.109 15.0285L7.0313 16L5.94167 15.0496L5.4703 14.6287C4.49959 13.7481 3.85254 13.0538 3.42639 12.2109C2.57707 10.475 3.08666 8.85109 4.16247 8.25379C5.18166 7.71249 6.5217 8.1418 6.99355 9.29907C7.4654 8.1418 8.78657 7.69383 9.80575 8.21646ZM16.972 8.00015C19.1724 7.9815 20.9812 9.753 20.9999 11.972C21.0185 14.1911 19.2284 15.9812 17.028 15.9999C14.8089 16.0185 13.0001 14.247 13.0001 12.028C12.9815 9.80894 14.753 8.01879 16.972 8.00015ZM16.9534 9.34275C15.4802 9.3614 14.3055 10.5548 14.3055 12.028C14.3428 13.4825 15.5548 14.6759 17.0093 14.6572C18.4825 14.6386 19.6572 13.4452 19.6386 11.972C19.62 10.4989 18.4265 9.32411 16.9534 9.34275ZM16.972 10.5921C17.7366 10.5735 18.3706 11.1888 18.3706 11.9534C18.3892 12.7179 17.7739 13.3519 17.0093 13.3519C16.2448 13.3519 15.6294 12.7552 15.5921 11.9907C15.5921 11.2261 16.2075 10.5921 16.972 10.5921Z"
  })),
  name: 'LoyaltyIcon',
  tags: ["loyalty", "target", "heart"],
  category: 'sasc'
};
var MailIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM21 5H3V19H21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8531 13.4178L1.42654 6.81923L2.57346 5.18077L12 11.7793L21.4265 5.18077L22.5735 6.81923L13.1469 13.4178C12.4583 13.8999 11.5417 13.8999 10.8531 13.4178Z"
  })),
  name: 'MailIcon',
  tags: ["mail", "message", "post", "letter"],
  category: 'system'
};
var ManufacturingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.17578 15.8348C2.17578 14.0477 3.59305 12.599 5.34134 12.599H14.6102C16.3585 12.599 17.7758 14.0477 17.7758 15.8348C17.7758 17.6219 16.3585 19.0706 14.6102 19.0706H5.34134C3.59305 19.0706 2.17578 17.6219 2.17578 15.8348ZM5.34134 14.3531C4.5408 14.3531 3.89183 15.0165 3.89183 15.8348C3.89183 16.6531 4.5408 17.3165 5.34134 17.3165H14.6102C15.4108 17.3165 16.0597 16.6531 16.0597 15.8348C16.0597 15.0165 15.4108 14.3531 14.6102 14.3531H5.34134Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.416 15.8519C14.416 16.3363 14.0279 16.729 13.5492 16.729C13.0705 16.729 12.6824 16.3363 12.6824 15.8519C12.6824 15.3675 13.0705 14.9748 13.5492 14.9748C14.0279 14.9748 14.416 15.3675 14.416 15.8519Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7834 15.8519C10.7834 16.3363 10.3954 16.729 9.91666 16.729C9.43796 16.729 9.0499 16.3363 9.0499 15.8519C9.0499 15.3675 9.43796 14.9748 9.91666 14.9748C10.3954 14.9748 10.7834 15.3675 10.7834 15.8519Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.15087 15.8518C7.15087 16.3362 6.76281 16.7289 6.28412 16.7289C5.80542 16.7289 5.41736 16.3362 5.41736 15.8518C5.41736 15.3674 5.80542 14.9747 6.28412 14.9747C6.76281 14.9747 7.15087 15.3674 7.15087 15.8518Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.35634 4.64521L9.44044 3.15648L10.4402 4.58951L8.92749 5.67006L9.36967 6.72288L7.77426 7.40897L7.05851 5.70477C6.89887 5.32468 7.02291 4.88339 7.35634 4.64521Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4585 4.64521L10.3744 3.15648L9.37467 4.58951L10.8873 5.67006L10.4452 6.72288L12.0406 7.40897L12.7563 5.70477C12.916 5.32468 12.7919 4.88339 12.4585 4.64521Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8425 2.50054L10.8425 4.12243L9.10898 4.12243V2.50054L10.8425 2.50054Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.78645 3.49256C4.09125 4.00053 3.9222 4.63494 3.92975 4.98643L3.92996 5.00569C3.92996 5.32889 3.96914 14.7967 3.97263 15.1011L2.20637 15.5677C2.2028 15.2557 2.2148 5.47617 2.21421 5.01478C2.19793 4.10252 2.62255 2.91762 3.78879 2.06546C4.94735 1.21891 6.74256 0.765426 9.37723 1.061C9.87198 1.07496 10.2846 1.2806 10.5512 1.64145C10.7932 1.96901 10.8406 2.32487 10.8454 2.52152L9.13015 2.5649C9.13051 2.57982 9.13208 2.59286 9.13644 2.6086C9.141 2.62505 9.15279 2.65902 9.18211 2.69871C9.19713 2.71904 9.21451 2.73774 9.23336 2.75412C9.25527 2.77317 9.27916 2.78906 9.3036 2.8007C9.31096 2.80421 9.31749 2.80691 9.32306 2.80898C9.337 2.81416 9.34497 2.81542 9.34497 2.81542C9.34497 2.81542 9.33819 2.81437 9.32306 2.81437C9.29108 2.81437 9.25913 2.81254 9.22734 2.80889C6.81868 2.5324 5.48759 2.98025 4.78645 3.49256Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.13206 8.8802C6.13206 8.39582 6.52011 8.00314 6.99881 8.00314H12.9529C13.4316 8.00314 13.8196 8.39582 13.8196 8.8802V13.2032C13.8196 13.6876 13.4316 14.0803 12.9529 14.0803H6.99881C6.52011 14.0803 6.13206 13.6876 6.13206 13.2032V8.8802ZM7.86557 9.75727V12.3262H12.0861V9.75727H7.86557Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8552 8.63629L10.8296 10.6301L9.09628 10.6074L9.1218 8.61357L10.8552 8.63629Z"
  })),
  name: 'ManufacturingIcon',
  tags: ["factory", "machine", "supply", "chain"],
  category: 'sasc'
};
var MarketplaceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14319 8.01984H5.87152L5.87032 8.08117C5.85088 9.07155 5.14034 9.69861 4.47263 9.69861C3.96782 9.69861 3.44157 9.36354 3.19596 8.71587C3.11916 8.51327 3.09766 8.26712 3.14319 8.01984ZM6.25858 6.01984L6.74143 3.55368H4.86579C4.86277 3.55867 4.85936 3.5653 4.856 3.57387L3.89817 6.01984H6.25858ZM8.19396 8.08158L8.20604 8.01984H10.9897V8.04215C10.9897 9.05333 10.2678 9.69861 9.59167 9.69861C8.92433 9.69861 8.21244 9.07003 8.19396 8.08158ZM8.59763 6.01984H10.9897V3.55368H9.08049L8.59763 6.01984ZM12.9928 8.04215V8.01984H15.7765L15.7886 8.08157C15.7701 9.07003 15.0582 9.69861 14.3908 9.69861C13.7147 9.69861 12.9928 9.05328 12.9928 8.04215ZM12.9928 6.01984H15.3849L14.902 3.55368H12.9928V6.01984ZM18.1297 8.08117L18.1285 8.01984H20.8568C20.9023 8.26712 20.8808 8.51327 20.804 8.71587C20.5584 9.36354 20.0322 9.69861 19.5274 9.69861C18.8596 9.69861 18.1491 9.07155 18.1297 8.08117ZM17.7414 6.01984H20.1018L19.144 3.57387C19.1406 3.5653 19.1372 3.55867 19.1342 3.55368H17.2586L17.7414 6.01984ZM8.00308 1.69929C7.81355 1.60647 7.60069 1.55368 7.37487 1.55368H4.82687C3.97658 1.55368 3.28195 2.10856 2.99371 2.84457L1.35606 7.02658C1.05708 7.7902 1.03545 8.65885 1.32585 9.42485C1.60733 10.1672 2.10843 10.789 2.74521 11.1936V19.4429C2.74521 20.6286 3.67187 21.6825 4.92153 21.6825H19.2468C20.4964 21.6825 21.4231 20.6286 21.4231 19.4429V11.0794C21.9798 10.6763 22.4179 10.1005 22.6741 9.42485C22.9645 8.65885 22.9429 7.7902 22.6439 7.02658L21.0063 2.84457C20.718 2.10856 20.0234 1.55368 19.1731 1.55368H16.6251C16.3958 1.55368 16.1799 1.60811 15.9881 1.70363C15.7993 1.60875 15.5837 1.55368 15.3472 1.55368H12.4615C12.2924 1.55368 12.1351 1.58091 11.9912 1.63001C11.8473 1.58091 11.6901 1.55368 11.5209 1.55368H8.6353C8.40247 1.55368 8.18983 1.60707 8.00308 1.69929ZM4.74521 11.6873C5.67999 11.6096 6.47693 11.1351 7.0321 10.4455C7.64037 11.2015 8.53899 11.6986 9.59167 11.6986C10.5556 11.6986 11.3903 11.2818 11.9912 10.6311C12.5922 11.2818 13.4269 11.6986 14.3908 11.6986C15.4486 11.6986 16.3508 11.1967 16.9591 10.4346C17.5476 11.1713 18.4107 11.6651 19.4231 11.697V19.4429C19.4231 19.5246 19.3921 19.5892 19.3528 19.6307C19.3142 19.6713 19.2766 19.6825 19.2468 19.6825H16.0498V14.2786C16.0498 13.7263 15.6021 13.2786 15.0498 13.2786H9.1185C8.56622 13.2786 8.1185 13.7263 8.1185 14.2786V19.6825H4.92153C4.89171 19.6825 4.85407 19.6713 4.81552 19.6307C4.77618 19.5892 4.74521 19.5246 4.74521 19.4429V11.6873ZM10.1185 19.0162V15.2786H14.0498V19.0162H10.1185Z"
  })),
  name: 'MarketplaceIcon',
  tags: ["market", "marketplace", "store", "shop"],
  category: 'merchandising'
};
var MaximizeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 2H22V9H20V4H15V2Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.7071 4.70711L13.7071 11.7071L12.2929 10.2929L19.2929 3.29289L20.7071 4.70711Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.29289 19.2929L10.2929 12.2929L11.7071 13.7071L4.70711 20.7071L3.29289 19.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 15H4V20H9V22H2V15Z"
  })),
  name: 'MaximizeIcon',
  tags: ["maximize", "full", "screen", "larger", "arrow"],
  category: 'system'
};
var MenuIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 7H2V5H22V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 13H2V11H22V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 19H2V17H22V19Z"
  })),
  name: 'MenuIcon',
  tags: ["menu", "hamburger", "lines"],
  category: 'navigation'
};
var MicIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8 3.79086 9.79086 2 12 2C14.2091 2 16 3.79086 16 6V11C16 13.2091 14.2091 15 12 15C9.79086 15 8 13.2091 8 11V6ZM12 4C10.8954 4 10 4.89543 10 6V11C10 12.1046 10.8954 13 12 13C13.1046 13 14 12.1046 14 11V6C14 4.89543 13.1046 4 12 4ZM7 11C7 13.7614 9.23858 16 12 16C14.7614 16 17 13.7614 17 11H19C19 14.5265 16.3923 17.4439 13 17.9291V22H11V17.9291C7.60771 17.4439 5 14.5265 5 11H7Z"
  })),
  name: 'MicIcon',
  tags: ["mic", "microphone", "sound", "volume", "mute", "controls"],
  category: 'system'
};
var MinimizeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.7071 2.70718L15.7071 9.70718L14.2929 8.29297L21.2929 1.29297L22.7071 2.70718Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.29291 21.293L8.29291 14.293L9.70712 15.7072L2.70712 22.7072L1.29291 21.293Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 4.00008H15V9.00008H20V11.0001H13V4.00008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00001 15.0001H4.00001V13.0001H11V20.0001H9.00001V15.0001Z"
  })),
  name: 'MinimizeIcon',
  tags: ["minimize", "screen", "smaller", "arrow"],
  category: 'system'
};
var MinusCircleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13H6V11H18V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  })),
  name: 'MinusCircleIcon',
  tags: ["minus", "circle", "remove", "delete"],
  category: 'system'
};
var MinusIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13H4V11H20V13Z"
  })),
  name: 'MinusIcon',
  tags: ["minus", "remove", "delete", "dash"],
  category: 'system'
};
var MydayIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 13.4589 20.6536 14.8345 20.039 16.0513C20.4951 16.6667 20.8823 17.3363 21.189 18.0487C21.3071 17.8696 21.4201 17.6869 21.5278 17.5007C22.4643 15.8818 23 14.0019 23 12C23 5.92487 18.0751 1 12 1C5.92487 1 1 5.92487 1 12C1 14.0019 1.53569 15.8818 2.47222 17.5007C2.5799 17.6869 2.69289 17.8696 2.81099 18.0487C3.11772 17.3363 3.50486 16.6667 3.96098 16.0513C3.3464 14.8345 3 13.4589 3 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7C10.8954 7 10 7.89543 10 9C10 10.1046 10.8954 11 12 11C13.1046 11 14 10.1046 14 9C14 7.89543 13.1046 7 12 7ZM8 9C8 6.79086 9.79086 5 12 5C14.2091 5 16 6.79086 16 9C16 11.2091 14.2091 13 12 13C9.79086 13 8 11.2091 8 9ZM6.5362 19.1522C8.05147 20.3118 9.94452 21 12.0002 21C14.103 21 16.0357 20.2799 17.568 19.071C16.6878 17.3193 14.6114 16 12.0717 16C9.49174 16 7.39231 17.3603 6.5362 19.1522ZM4.38806 19.1705C5.32431 16.1129 8.48081 14 12.0717 14C15.6164 14 18.7348 16.0576 19.7175 19.0496L19.9185 19.6615L19.4445 20.0976C17.4862 21.8993 14.8706 23 12.0002 23C9.18923 23 6.62243 21.9443 4.67839 20.2093L4.20053 19.7829L4.38806 19.1705Z"
  })),
  name: 'MydayIcon',
  tags: ["myday", "home", "today", "person", "user"],
  category: 'sasc'
};
var NetworkIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 3C15 1.89543 15.8954 1 17 1H19C20.1046 1 21 1.89543 21 3V5C21 6.10457 20.1046 7 19 7H17C15.8954 7 15 6.10457 15 5V3ZM19 3H17V5H19V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 11C15 9.89543 15.8954 9 17 9H19C20.1046 9 21 9.89543 21 11V13C21 14.1046 20.1046 15 19 15H17C15.8954 15 15 14.1046 15 13V11ZM19 11H17V13H19V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 11C3 9.89543 3.89543 9 5 9H7C8.10457 9 9 9.89543 9 11V13C9 14.1046 8.10457 15 7 15H5C3.89543 15 3 14.1046 3 13V11ZM7 11H5V13H7V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 13H8V11H16V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 5C11 3.89543 11.8954 3 13 3H16V5H13V19H16V21H13C11.8954 21 11 20.1046 11 19V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 19C15 17.8954 15.8954 17 17 17H19C20.1046 17 21 17.8954 21 19V21C21 22.1046 20.1046 23 19 23H17C15.8954 23 15 22.1046 15 21V19ZM19 19H17V21H19V19Z"
  })),
  name: 'NetworkIcon',
  tags: ["network", "relation"],
  category: 'data'
};
var NewIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0001 1C12.3021 1 12.5879 1.13648 12.7778 1.37135L14.6864 3.73244L17.6183 2.94413C17.9099 2.86571 18.2214 2.9233 18.4657 3.10081C18.71 3.27833 18.8611 3.55675 18.8766 3.85835L19.0329 6.89037L21.8682 7.97594C22.1502 8.08393 22.3684 8.31359 22.4617 8.60081C22.555 8.88804 22.5135 9.20205 22.3488 9.45519L20.6931 12L22.3488 14.5448C22.5135 14.7979 22.555 15.112 22.4617 15.3992C22.3684 15.6864 22.1502 15.9161 21.8682 16.0241L19.0329 17.1096L18.8766 20.1416C18.8611 20.4433 18.71 20.7217 18.4657 20.8992C18.2214 21.0767 17.9099 21.1343 17.6183 21.0559L14.6864 20.2676L12.7778 22.6287C12.5879 22.8635 12.3021 23 12.0001 23C11.6981 23 11.4122 22.8635 11.2224 22.6287L9.31378 20.2676L6.38187 21.0559C6.09022 21.1343 5.77876 21.0767 5.53443 20.8992C5.29011 20.7217 5.13909 20.4433 5.12354 20.1416L4.96726 17.1096L2.13194 16.0241C1.8499 15.9161 1.63177 15.6864 1.53845 15.3992C1.44513 15.112 1.4866 14.7979 1.65131 14.5448L3.30704 12L1.65131 9.45519C1.4866 9.20205 1.44513 8.88804 1.53845 8.60081C1.63177 8.31359 1.8499 8.08393 2.13194 7.97594L4.96726 6.89036L5.12354 3.85835C5.13909 3.55675 5.29011 3.27833 5.53443 3.10081C5.77876 2.9233 6.09022 2.86571 6.38187 2.94413L9.31378 3.73244L11.2224 1.37135C11.4122 1.13648 11.6981 1 12.0001 1ZM12.0001 3.59071L10.4601 5.49573C10.2115 5.80336 9.8048 5.93549 9.42279 5.83278L7.05721 5.19674L6.93112 7.64309C6.91076 8.03814 6.65943 8.38406 6.29001 8.5255L4.00236 9.40139L5.33827 11.4546C5.554 11.7862 5.554 12.2138 5.33827 12.5454L4.00236 14.5986L6.29001 15.4745C6.65943 15.6159 6.91076 15.9619 6.93112 16.3569L7.05721 18.8033L9.42279 18.1672C9.8048 18.0645 10.2115 18.1966 10.4601 18.5043L12.0001 20.4093L13.54 18.5043C13.7887 18.1966 14.1953 18.0645 14.5773 18.1672L16.9429 18.8033L17.069 16.3569C17.0894 15.9619 17.3407 15.6159 17.7101 15.4745L19.9978 14.5986L18.6619 12.5454C18.4461 12.2138 18.4461 11.7862 18.6619 11.4546L19.9978 9.40139L17.7101 8.5255C17.3407 8.38406 17.0894 8.03814 17.069 7.64309L16.9429 5.19674L14.5773 5.83278C14.1953 5.93549 13.7887 5.80336 13.54 5.49573L12.0001 3.59071Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.0001 14H11.0001V8H13.0001V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0178 17C12.5385 17 13.0001 16.5148 13.0001 16.0059C13.0001 15.4615 12.5504 15 12.006 15C11.4734 15 11.0001 15.4379 11.0001 16.0059C11.0001 16.5621 11.4734 17 12.0178 17Z"
  })),
  name: 'NewIcon',
  tags: ["new", "alert"],
  category: 'system'
};
var NotebookIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM21 5H3V19H21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20V4H13V20H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 9H15V7H19V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 13H15V11H19V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 17H15V15H19V17Z"
  })),
  name: 'NotebookIcon',
  tags: ["note", "book"],
  category: 'system'
};
var OrderPickupIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9639 0.999756H10.0606L7.96527 2.77821L7.96515 4.50001L4.50027 4.50007L4.5 21.9998L19.5 21.9997L19.5003 4.50001L16.0591 4.5L16.0593 2.77827L13.9639 0.999756ZM6.50003 19.9998L6.50024 6.50004L17.5002 6.50001L17.5 19.9997L16.0751 19.9997V12.2006L15.6218 11.9046L15.0751 12.7419C15.6218 11.9046 15.6208 11.9039 15.6204 11.9037L15.6189 11.9027L15.6156 11.9006L15.6076 11.8955L15.5866 11.8824C15.5704 11.8724 15.5498 11.86 15.5247 11.8455C15.4746 11.8165 15.4067 11.7792 15.3215 11.7365C15.1511 11.6511 14.9111 11.5439 14.6046 11.439C13.9906 11.2289 13.112 11.0283 11.9985 11.0283C10.8824 11.0283 10.0025 11.2327 9.38764 11.447C9.08073 11.5539 8.84043 11.6632 8.66995 11.7502C8.58468 11.7938 8.51676 11.8318 8.46656 11.8614C8.44146 11.8762 8.42078 11.8888 8.40455 11.899L8.38356 11.9124L8.37558 11.9176L8.37222 11.9198L8.37069 11.9208L8.36928 11.9218L8.92276 12.7534C8.37316 11.9276 8.36897 11.922 8.36928 11.9218L7.92334 12.2185V19.9997L6.50003 19.9998ZM14.0591 4.5H9.96515L9.9652 3.70402L10.795 2.99976H13.2295L14.0592 3.70396L14.0591 4.5ZM9.92334 14.4516V13.3803C9.96181 13.3656 10.0026 13.3506 10.0458 13.3356C10.4725 13.1869 11.1301 13.0283 11.9985 13.0283C12.8687 13.0283 13.5285 13.1846 13.9568 13.3312C13.9984 13.3455 14.0378 13.3596 14.0751 13.3735V14.4516H9.92334ZM12.9992 16.4516H14.0751V19.9712H12.9992V16.4516ZM10.9992 16.4516V19.9712H9.92334V16.4516H10.9992Z"
  })),
  name: 'OrderPickupIcon',
  tags: ["order", "pickup"],
  category: 'sasc'
};
var OverflowMenuHorizontalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M22 12C22 13.1046 21.1046 14 20 14C18.8954 14 18 13.1046 18 12C18 10.8954 18.8954 10 20 10C21.1046 10 22 10.8954 22 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6 12C6 13.1046 5.10457 14 4 14C2.89543 14 2 13.1046 2 12C2 10.8954 2.89543 10 4 10C5.10457 10 6 10.8954 6 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
  })),
  name: 'OverflowMenuHorizontalIcon',
  tags: ["overflow", "menu", "horizontal", "dots"],
  category: 'navigation'
};
var OverflowMenuVerticalIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M14 4C14 5.10457 13.1046 6 12 6C10.8954 6 10 5.10457 10 4C10 2.89543 10.8954 2 12 2C13.1046 2 14 2.89543 14 4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 20C14 21.1046 13.1046 22 12 22C10.8954 22 10 21.1046 10 20C10 18.8954 10.8954 18 12 18C13.1046 18 14 18.8954 14 20Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12Z"
  })),
  name: 'OverflowMenuVerticalIcon',
  tags: ["overflow", "menu", "vertical", "dots"],
  category: 'navigation'
};
var PageFirstIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2929 3.29289L20.7071 4.70711L13.4142 12L20.7066 19.2924L19.2928 20.7071L19.2921 20.7063L10.5858 12L19.2929 3.29289Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V3H6V21H4Z"
  })),
  name: 'PageFirstIcon',
  tags: ["page", "first", "arrow"],
  category: 'navigation'
};
var PageLastIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.5858 12L3.29291 4.70711L4.70712 3.29289L13.4142 12L4.70712 20.7071L3.29291 19.2929L10.5858 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19 21V3H21V21H19Z"
  })),
  name: 'PageLastIcon',
  tags: ["page", "last", "arrow"],
  category: 'navigation'
};
var PaperAirplaneIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.7071 2.29292C21.975 2.56075 22.0685 2.95692 21.9487 3.31625L15.9487 21.3163C15.8298 21.6731 15.5207 21.933 15.1487 21.9889C14.7768 22.0448 14.4049 21.8873 14.1863 21.5813L9.28316 14.7169L2.41879 9.81376C2.11272 9.59514 1.95521 9.22327 2.01114 8.85133C2.06707 8.47939 2.32697 8.17029 2.6838 8.05134L20.6838 2.05134C21.0431 1.93157 21.4393 2.02509 21.7071 2.29292ZM11.3061 14.1081L14.6723 18.8208L19.4189 4.58117L5.17925 9.32771L9.89193 12.6939L13.2929 9.29292C13.6834 8.9024 14.3166 8.9024 14.7071 9.29292C15.0977 9.68344 15.0977 10.3166 14.7071 10.7071L11.3061 14.1081Z"
  })),
  name: 'PaperAirplaneIcon',
  tags: ["paper", "airplane", "send"],
  category: 'system'
};
var PaperclipIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0711 4.9289C17.509 3.3668 14.9763 3.3668 13.4142 4.9289L4.92896 13.4142C3.36686 14.9763 3.36686 17.5089 4.92896 19.071C6.49106 20.6331 9.02372 20.6331 10.5858 19.071L12 20.4852C9.65688 22.8284 5.85789 22.8284 3.51474 20.4852C1.1716 18.1421 1.1716 14.3431 3.51474 12L12 3.51468C14.3432 1.17154 18.1422 1.17154 20.4853 3.51468C22.8285 5.85783 22.8285 9.65682 20.4853 12L15.5356 16.9497C14.2287 18.2566 11.8921 18.4917 10.468 17.0676C9.04378 15.6434 9.27891 13.3069 10.5858 12L15.5356 7.05022L16.9498 8.46443L12 13.4142C11.3543 14.0599 11.3537 15.1249 11.8822 15.6533C12.4106 16.1818 13.4756 16.1812 14.1213 15.5355L19.0711 10.5858C20.6332 9.02365 20.6332 6.49099 19.0711 4.9289Z"
  })),
  name: 'PaperclipIcon',
  tags: ["paper", "clip", "attach"],
  category: 'system'
};
var PauseIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 6C8.55228 6 9 6.44772 9 7L9 17C9 17.5523 8.55229 18 8 18C7.44772 18 7 17.5523 7 17L7 7C7 6.44772 7.44772 6 8 6ZM16 6C16.5523 6 17 6.44772 17 7V17C17 17.5523 16.5523 18 16 18C15.4477 18 15 17.5523 15 17V7C15 6.44772 15.4477 6 16 6Z"
  })),
  name: 'PauseIcon',
  tags: ["pause", "play", "controls", "video", "audio"],
  category: 'system'
};
var PencilIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5858 2.00009C18.3668 1.21905 19.6332 1.21904 20.4142 2.00009L22 3.58588C22.7811 4.36693 22.7811 5.63326 22 6.41431L7.90297 20.5113C7.64666 20.7677 7.3255 20.9495 6.97383 21.0374L4.85945 21.566C3.39469 21.9322 2.0679 20.6054 2.43409 19.1407L2.96269 17.0263C3.05061 16.6746 3.23244 16.3534 3.48876 16.0971L17.5858 2.00009ZM19 3.41431L4.90297 17.5113L4.37438 19.6257L6.48876 19.0971L20.5858 5.00009L19 3.41431Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.2929 8.7072L15.7929 6.2072L17.2071 4.79299L19.7071 7.29299L18.2929 8.7072Z"
  })),
  name: 'PencilIcon',
  tags: ["pencil", "write", "draw", "draft"],
  category: 'system'
};
var PersonHappyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 14C9 15.6569 10.3431 17 12 17C13.6569 17 15 15.6569 15 14H17C17 16.7614 14.7614 19 12 19C9.23858 19 7 16.7614 7 14H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
  })),
  name: 'PersonHappyIcon',
  tags: ["person", "happy", "user", "emotion"],
  category: 'system'
};
var PersonNeutralIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 17H7V15H17V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
  })),
  name: 'PersonNeutralIcon',
  tags: ["person", "neutral", "user", "emotion"],
  category: 'system'
};
var PersonSadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 18C9 16.3431 10.3431 15 12 15C13.6569 15 15 16.3431 15 18H17C17 15.2386 14.7614 13 12 13C9.23858 13 7 15.2386 7 18H9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 10C18 11.1046 17.1046 12 16 12C14.8954 12 14 11.1046 14 10C14 8.89543 14.8954 8 16 8C17.1046 8 18 8.89543 18 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 10C10 11.1046 9.10457 12 8 12C6.89543 12 6 11.1046 6 10C6 8.89543 6.89543 8 8 8C9.10457 8 10 8.89543 10 10Z"
  })),
  name: 'PersonSadIcon',
  tags: ["person", "sad", "user", "emotion"],
  category: 'system'
};
var PersonVeryHappyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 15C8.99784 15 8.9979 15.0004 9 15V15ZM9.1704 15H14.8296C14.4178 16.1656 13.3052 17 12 17C10.6948 17 9.58221 16.1656 9.1704 15ZM15 15C15.0021 15.0004 15.0022 15 15 15V15ZM7.15434 15.2366C6.81262 13.8943 7.98831 13 9 13H15C16.0117 13 17.1874 13.8943 16.8457 15.2366C16.2951 17.3994 14.3357 19 12 19C9.66429 19 7.70493 17.3994 7.15434 15.2366Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9C7.44772 9 7 9.44771 7 10H5C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10H9C9 9.44771 8.55228 9 8 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9C15.4477 9 15 9.44771 15 10H13C13 8.34315 14.3431 7 16 7C17.6569 7 19 8.34315 19 10H17C17 9.44771 16.5523 9 16 9Z"
  })),
  name: 'PersonVeryHappyIcon',
  tags: ["person", "very", "happy", "user", "emotion", "smile"],
  category: 'system'
};
var PersonVerySadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 17C8.99784 17 8.9979 16.9996 9 17V17ZM9.1704 17H14.8296C14.4178 15.8344 13.3052 15 12 15C10.6948 15 9.58221 15.8344 9.1704 17ZM15 17C15.0021 16.9996 15.0022 17 15 17V17ZM7.15434 16.7634C6.81262 18.1057 7.98831 19 9 19H15C16.0117 19 17.1874 18.1057 16.8457 16.7634C16.2951 14.6006 14.3357 13 12 13C9.66429 13 7.70493 14.6006 7.15434 16.7634Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 9C7.44772 9 7 9.44771 7 10H5C5 8.34315 6.34315 7 8 7C9.65685 7 11 8.34315 11 10H9C9 9.44771 8.55228 9 8 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9C15.4477 9 15 9.44771 15 10H13C13 8.34315 14.3431 7 16 7C17.6569 7 19 8.34315 19 10H17C17 9.44771 16.5523 9 16 9Z"
  })),
  name: 'PersonVerySadIcon',
  tags: ["person", "very", "sad", "user", "emotion", "frown"],
  category: 'system'
};
var PersonIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C10.3431 3 9 4.34315 9 6C9 7.65685 10.3431 9 12 9C13.6569 9 15 7.65685 15 6C15 4.34315 13.6569 3 12 3ZM7 6C7 3.23858 9.23858 1 12 1C14.7614 1 17 3.23858 17 6C17 8.76142 14.7614 11 12 11C9.23858 11 7 8.76142 7 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 17C3 14.2386 5.23858 12 8 12H16C18.7614 12 21 14.2386 21 17V21C21 22.1046 20.1046 23 19 23H5C3.89543 23 3 22.1046 3 21V17ZM8 14C6.34315 14 5 15.3431 5 17V21H19V17C19 15.3431 17.6569 14 16 14H8Z"
  })),
  name: 'PersonIcon',
  tags: ["person", "user"],
  category: 'system'
};
var PickIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M18.5 8L20.5 8V4.41421L21.2926 5.20683L22.7071 3.79287L19.5 0.585785L16.2932 3.79261L17.7071 5.20709L18.5 4.41421V8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.98828 16.8575C5.99888 18.278 7.15342 19.424 8.57399 19.424C9.89575 19.424 11.0048 18.4273 11.1452 17.113L11.3039 15.6287C11.3982 14.746 12.1209 14.0887 12.9719 14.0417L12.2984 17.4091C12.0401 18.7005 12.7838 19.982 14.0331 20.3985C15.1698 20.7774 16.371 20.3309 17.0101 19.403L17.4573 20.2378C18.0693 21.3802 19.4153 21.9157 20.6448 21.5058C22.0975 21.0216 22.8429 19.4144 22.2742 17.9927L19.4973 11.0505C19.0549 9.94446 18.3045 8.98853 17.3351 8.29612L15.4805 6.9714C15.1705 6.74999 14.843 6.55426 14.5012 6.38614L10.6038 4.46929C10.7371 3.82855 10.5522 3.13863 10.0602 2.64644L8.00017 0.585846L6.58576 1.99986L8.64576 4.06045L8.50462 4.22935L4.2992 8.28662L4.00005 8.58577L2.00006 6.58578L0.585846 7.99999L2.58584 9.99999C3.22274 10.6369 4.18232 10.7544 4.93832 10.3526L5.28784 10.7021C5.98679 11.4011 6.28426 12.4065 6.07815 13.3732C6.00375 13.7222 5.96755 14.0783 5.97021 14.4352L5.98828 16.8575ZM14.2595 17.8014L14.7741 15.2287L15.7204 16.9953L15.4519 18.0695C15.3655 18.4149 15.0034 18.6137 14.6656 18.5011C14.3732 18.4036 14.1991 18.1036 14.2595 17.8014ZM6.42698 9.01285L6.70205 9.28793C7.8802 10.4661 8.3816 12.1607 8.0342 13.7902C7.99005 13.9973 7.96858 14.2085 7.97016 14.4202L7.98822 16.8426C7.99062 17.1644 8.25219 17.424 8.57402 17.424C8.87347 17.424 9.12472 17.1982 9.15654 16.9005L9.31518 15.4161C9.54418 13.2735 11.5159 11.7559 13.6458 12.0831C14.8203 12.2635 15.8416 12.986 16.4027 14.0335L19.2203 19.2934C19.3724 19.5773 19.7068 19.7103 20.0124 19.6085C20.3733 19.4881 20.5585 19.0888 20.4172 18.7355L17.6403 11.7933C17.34 11.0425 16.8306 10.3936 16.1726 9.92359L14.318 8.59887C14.0966 8.44072 13.8627 8.30091 13.6185 8.18083L9.42644 6.11906L6.42698 9.01285Z"
  })),
  name: 'PickIcon',
  tags: ["pick", "hand", "arrow"],
  category: 'sasc'
};
var PinFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70712 15.7071L3.70712 21.7071L2.29291 20.2929L8.29291 14.2929L9.70712 15.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.00001 11L13 20C13 20 16 18 16 14L22 7.99997L16 1.99997L10 7.99997C6.00001 7.99997 4.00001 11 4.00001 11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 1.29286C15.6834 0.902338 16.3166 0.902338 16.7071 1.29286L22.7071 7.29286C23.0976 7.68339 23.0976 8.31655 22.7071 8.70708L16.9899 14.4243C16.8918 16.4795 16.0932 18.0424 15.3 19.1C14.8777 19.6631 14.4546 20.0866 14.1331 20.3724C13.972 20.5156 13.8352 20.6253 13.735 20.7017C13.6848 20.7399 13.6437 20.7698 13.6132 20.7915C13.598 20.8024 13.5853 20.8112 13.5755 20.8179L13.5629 20.8265L13.5583 20.8297L13.5555 20.8315C13.5551 20.8318 13.5547 20.832 13 20L13.5555 20.8315C13.1589 21.0959 12.63 21.0442 12.2929 20.7071L3.29291 11.7071C2.95584 11.37 2.90355 10.8419 3.16796 10.4453L4.00001 11C3.16796 10.4453 3.1677 10.4457 3.16796 10.4453L3.16906 10.4437L3.17034 10.4417L3.17349 10.4371L3.18209 10.4245C3.18884 10.4147 3.19764 10.4021 3.20849 10.3868C3.23019 10.3563 3.26013 10.3152 3.29833 10.2651C3.37466 10.1649 3.48436 10.028 3.6276 9.86689C3.91339 9.54537 4.33693 9.1223 4.90001 8.69999C5.95757 7.90681 7.52052 7.10816 9.57573 7.01005L15.2929 1.29286ZM4.82947 11.5586C4.82894 11.5593 4.82907 11.5592 4.82947 11.5586V11.5586ZM5.35869 10.9445C5.55367 10.7482 5.80098 10.5243 6.10002 10.3C6.97085 9.64685 8.26552 8.99997 10 8.99997C10.2652 8.99997 10.5196 8.89461 10.7071 8.70708L16 3.41418L20.5858 7.99997L15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14C15 15.7345 14.3531 17.0292 13.7 17.9C13.4757 18.199 13.2518 18.4463 13.0555 18.6413L5.35869 10.9445Z"
  })),
  name: 'PinFilledIcon',
  tags: ["pin", "filled"],
  category: 'toggle'
};
var PinIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.70712 15.7071L3.70712 21.7071L2.29291 20.2929L8.29291 14.2929L9.70712 15.7071Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.2929 1.29286C15.6834 0.902338 16.3166 0.902338 16.7071 1.29286L22.7071 7.29286C23.0976 7.68339 23.0976 8.31655 22.7071 8.70708L16.9899 14.4243C16.8918 16.4795 16.0932 18.0424 15.3 19.1C14.8777 19.6631 14.4546 20.0866 14.1331 20.3724C13.972 20.5156 13.8352 20.6253 13.735 20.7017C13.6848 20.7399 13.6437 20.7698 13.6132 20.7915C13.598 20.8024 13.5853 20.8112 13.5755 20.8179L13.5629 20.8265L13.5583 20.8297L13.5555 20.8315C13.5555 20.8315 13.5547 20.832 13 20L13.5555 20.8315C13.1589 21.0959 12.63 21.0442 12.2929 20.7071L3.29291 11.7071C2.95584 11.37 2.90355 10.8419 3.16796 10.4453L4.00001 11C3.16796 10.4453 3.16796 10.4453 3.16796 10.4453L3.16906 10.4437L3.17034 10.4417L3.17349 10.4371L3.18209 10.4245C3.18884 10.4147 3.19764 10.4021 3.20849 10.3868C3.23019 10.3563 3.26013 10.3152 3.29833 10.2651C3.37466 10.1649 3.48436 10.028 3.6276 9.86689C3.91339 9.54537 4.33693 9.1223 4.90001 8.69999C5.95757 7.90681 7.52052 7.10816 9.57573 7.01005L15.2929 1.29286ZM5.35869 10.9445C5.55367 10.7482 5.80098 10.5243 6.10002 10.3C6.97085 9.64685 8.26552 8.99997 10 8.99997C10.2652 8.99997 10.5196 8.89461 10.7071 8.70708L16 3.41418L20.5858 7.99997L15.2929 13.2929C15.1054 13.4804 15 13.7348 15 14C15 15.7345 14.3531 17.0292 13.7 17.9C13.4757 18.199 13.2518 18.4463 13.0555 18.6413L5.35869 10.9445Z"
  })),
  name: 'PinIcon',
  tags: ["pin"],
  category: 'toggle'
};
var PlayIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 6.67422C6 5.16087 7.61574 4.1958 8.9482 4.91328L18.8389 10.2391C20.2413 10.9942 20.2413 13.0058 18.8389 13.7609L8.9482 19.0867C7.61574 19.8042 6 18.8391 6 17.3258V6.67422ZM17.8907 12L8 6.67422V17.3258L17.8907 12Z"
  })),
  name: 'PlayIcon',
  tags: ["play", "controls", "video", "audio", "pause"],
  category: 'system'
};
var PluginIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.75 5C9.05964 5 8.5 5.55964 8.5 6.25V8.02703L5 8.02703V19H6.50947C6.63713 17.3219 8.03919 16 9.75 16C11.4608 16 12.8629 17.3219 12.9905 19H15.8889V14H17.75C18.4404 14 19 13.4404 19 12.75C19 12.0596 18.4404 11.5 17.75 11.5H15.8889L15.8889 8.02703H11V6.25C11 5.55964 10.4404 5 9.75 5ZM6.50753 6.02703C6.6221 4.3361 8.03002 3 9.75 3C11.47 3 12.8779 4.3361 12.9925 6.02703H15.8889C16.9935 6.02703 17.8889 6.92246 17.8889 8.02703V9.50291C19.6194 9.57567 21 11.0016 21 12.75C21 14.4984 19.6194 15.9243 17.8889 15.9971V19C17.8889 20.1046 16.9935 21 15.8889 21H11V19.25C11 18.5596 10.4404 18 9.75 18C9.05964 18 8.5 18.5596 8.5 19.25V21H5C3.89543 21 3 20.1046 3 19V8.02703C3 6.92246 3.89543 6.02703 5 6.02703H6.50753Z"
  })),
  name: 'PluginIcon',
  tags: ["plugin", "puzzle"],
  category: 'system'
};
var PlusCircleIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 18L11 6H13L13 18H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 13H6V11H18V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  })),
  name: 'PlusCircleIcon',
  tags: ["plus", "circle", "add", "new"],
  category: 'system'
};
var PlusIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 20L11 4L13 4L13 20H11Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 13H4V11H20V13Z"
  })),
  name: 'PlusIcon',
  tags: ["plus", "add", "new"],
  category: 'system'
};
var PowerEquipmentCertificationIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 19.6687C5.67153 19.6687 5 18.9972 5 18.1687C5 17.3402 5.67153 16.6687 6.5 16.6687C7.32847 16.6687 8 17.3402 8 18.1687C8 18.9972 7.32847 19.6687 6.5 19.6687Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.501 19.6687C12.6725 19.6687 12.001 18.9972 12.001 18.1687C12.001 17.3402 12.6725 16.6687 13.501 16.6687C14.3294 16.6687 15.001 17.3402 15.001 18.1687C15.001 18.9972 14.3294 19.6687 13.501 19.6687Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.69092 6.7959C4.69092 5.69133 5.58635 4.7959 6.69092 4.7959H10.7744C11.6907 4.7959 12.4899 5.41862 12.7138 6.30717L13.9355 11.1552H15C15.4744 11.1552 15.8835 11.4885 15.9794 11.9531L16.4018 13.9996H16.7502V5.99963H18.7502V15.9996H21.0002V17.9996H16.7502V17.6608C16.5608 17.8757 16.2877 17.9996 16 17.9996H4C3.44772 17.9996 3 17.5519 3 16.9996V12.1552C3 11.6029 3.44772 11.1552 4 11.1552H4.69092V6.7959ZM11.873 11.1552H6.69092V6.7959H10.7744L11.873 11.1552ZM5 13.1552V15.9996H14.7725L14.1853 13.1552H13.1654C13.1624 13.1553 13.1593 13.1553 13.1562 13.1553L5.69092 13.1553C5.68783 13.1553 5.68474 13.1553 5.68165 13.1552H5Z"
  })),
  name: 'PowerEquipmentCertificationIcon',
  tags: ["power", "equipment", "certification"],
  category: 'sasc'
};
var PriceAuditIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19.0001 9C19.0001 9.55228 18.5523 10 18.0001 10C17.4478 10 17.0001 9.55228 17.0001 9C17.0001 8.44772 17.4478 8 18.0001 8C18.5523 8 19.0001 8.44772 19.0001 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.5001 4.58579C13.8751 4.21071 14.3838 4 14.9143 4H21C22.1046 4 23 4.89543 23 6V12.6462C23 13.1674 22.7966 13.668 22.4331 14.0414L14.7125 21.9714C13.9347 22.7703 12.6537 22.7789 11.8653 21.9904L8.29298 18.418L8.31241 18.3986C7.30742 18.2269 6.38437 17.815 5.60444 17.224L2.7072 20.1214L1.29297 18.7072L4.22274 15.7773C3.53194 14.7726 3.12762 13.5555 3.12762 12.244C3.12762 8.79555 5.92317 6 9.37166 6C10.1776 6 10.9479 6.15269 11.6551 6.43072L13.5001 4.58579ZM13.4223 7.49199C14.7646 8.63726 15.6157 10.3413 15.6157 12.244C15.6157 15.1358 13.65 17.5684 10.9818 18.2785L13.2795 20.5762L21 12.6462L21 6L14.9143 6L13.4223 7.49199ZM9.37166 8C7.02774 8 5.12762 9.90012 5.12762 12.244C5.12762 14.588 7.02774 16.4881 9.37166 16.4881C11.7156 16.4881 13.6157 14.588 13.6157 12.244C13.6157 9.90012 11.7156 8 9.37166 8Z"
  })),
  name: 'PriceAuditIcon',
  tags: ["price", "audit", "tag", "search", "lookup"],
  category: 'sasc'
};
var PriceChangeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.79999 7.80725V7.00005H9.79999V7.8012C10.3483 7.981 10.8334 8.31003 11.1673 8.76817L9.55106 9.9462C9.45611 9.81593 9.19747 9.6429 8.79999 9.6429C8.51208 9.6429 8.2852 9.7364 8.14887 9.84461C8.01425 9.95145 8 10.0385 8 10.0715C8 10.1992 8.04097 10.2708 8.10279 10.3241C8.17596 10.3871 8.37213 10.5 8.79999 10.5C9.57213 10.5 10.276 10.7069 10.8028 11.1609C11.341 11.6247 11.6 12.2674 11.6 12.9286C11.6 14.0844 10.7702 14.8705 9.8 15.1928L9.79999 16.0001L7.79999 16L7.8 15.1989C7.25174 15.0191 6.76662 14.6901 6.4327 14.2319L8.04894 13.0539C8.14389 13.1842 8.40253 13.3572 8.80001 13.3572C9.08792 13.3572 9.3148 13.2637 9.45113 13.1555C9.58575 13.0486 9.6 12.9616 9.6 12.9286C9.6 12.8009 9.55903 12.7293 9.4972 12.676C9.42403 12.6129 9.22785 12.5 8.79999 12.5C8.02786 12.5 7.32403 12.2931 6.7972 11.8392C6.25903 11.3754 6 10.7327 6 10.0715C6 8.91564 6.82976 8.12962 7.79999 7.80725Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19 9C19 9.55228 18.5523 10 18 10C17.4477 10 17 9.55228 17 9C17 8.44772 17.4477 8 18 8C18.5523 8 19 8.44772 19 9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.5 4C4.35786 4 1 7.35786 1 11.5C1 15.6421 4.35786 19 8.5 19C8.62274 19 8.74479 18.9971 8.86609 18.9912L11.8652 21.9904C12.6537 22.7789 13.9347 22.7703 14.7125 21.9714L22.433 14.0414C22.7966 13.668 23 13.1674 23 12.6462V6C23 4.89543 22.1046 4 21 4H14.9142C14.3838 4 13.8751 4.21071 13.5 4.58579L12.7596 5.32618C11.5498 4.48986 10.0821 4 8.5 4ZM3 11.5C3 8.46243 5.46243 6 8.5 6C11.5376 6 14 8.46243 14 11.5C14 14.5376 11.5376 17 8.5 17C5.46243 17 3 14.5376 3 11.5ZM13.2795 20.5762L11.2019 18.4986C14.0089 17.4142 16 14.6896 16 11.5C16 9.66167 15.3386 7.97782 14.2408 6.67343L14.9142 6L21 6V12.6462L13.2795 20.5762Z"
  })),
  name: 'PriceChangeIcon',
  tags: ["price", "change", "tag", "dollar"],
  category: 'sasc'
};
var PrinterConnectedIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.55556 3C4.51235 3 3.66667 3.84568 3.66667 4.88889V8.33333H2.88889C1.84568 8.33333 1 9.17902 1 10.2222V16.4444C1 17.4877 1.84569 18.3333 2.88889 18.3333H4.61111V19.1111C4.61111 20.1543 5.4568 21 6.5 21H12.5278C13.6264 22.2275 15.223 23 17 23C20.3137 23 23 20.3137 23 17C23 14.3876 21.3304 12.1651 19 11.3414V10.2222C19 9.17902 18.1543 8.33333 17.1111 8.33333H16.3333V4.88889C16.3333 3.84569 15.4876 3 14.4444 3H5.55556ZM17 11V10.3333H3V16.3333H4.61111V14.6667C4.61111 13.6235 5.4568 12.7778 6.5 12.7778H12.737C13.8244 11.68 15.3328 11 17 11ZM11.425 14.7778H6.61111V19H11.3414C11.1203 18.3744 11 17.7013 11 17C11 16.2149 11.1508 15.465 11.425 14.7778ZM14.3333 8.33333H5.66667V5H14.3333V8.33333ZM13 17C13 14.7909 14.7909 13 17 13C19.2091 13 21 14.7909 21 17C21 19.2091 19.2091 21 17 21C14.7909 21 13 19.2091 13 17ZM18.654 14.6262L16.5833 16.6969L15.6238 15.7373L14.2096 17.1516L16.5833 19.5253L20.0682 16.0404L18.654 14.6262Z"
  })),
  name: 'PrinterConnectedIcon',
  tags: ["printer", "connected", "check", "success"],
  category: 'sasc'
};
var PrinterIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V8C19 9.10457 18.1046 10 17 10H7C5.89543 10 5 9.10457 5 8V4ZM17 4H7V8H17V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 10C2 8.89543 2.89543 8 4 8H20C21.1046 8 22 8.89543 22 10V17C22 18.1046 21.1046 19 20 19H17V17H20V10H4V17H7V19H4C2.89543 19 2 18.1046 2 17V10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 15C6 13.8954 6.89543 13 8 13H16C17.1046 13 18 13.8954 18 15V20C18 21.1046 17.1046 22 16 22H8C6.89543 22 6 21.1046 6 20V15ZM16 15H8V20H16V15Z"
  })),
  name: 'PrinterIcon',
  tags: ["printer", "copy", "print"],
  category: 'system'
};
var ProcessingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0003 3.34961V9.39951H15.9504V7.39951H20.0003V3.34961H22.0003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99976 14.5996H8.04966V16.5996H3.99976V20.6495H1.99976V14.5996Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9998 4C7.58148 4 3.99976 7.58172 3.99976 12H1.99976C1.99976 6.47715 6.47691 2 11.9998 2C16.0957 2 19.6143 4.46242 21.1602 7.98352L19.3289 8.7875C18.0905 5.96683 15.2737 4 11.9998 4ZM11.9998 20C16.418 20 19.9998 16.4183 19.9998 12H21.9998C21.9998 17.5228 17.5226 22 11.9998 22C7.90602 22 4.38901 19.5403 2.84186 16.0222L4.67264 15.2171C5.91203 18.0353 8.72756 20 11.9998 20Z"
  })),
  name: 'ProcessingIcon',
  tags: ["processing, loading, in-progress"],
  category: 'system'
};
var ProfileIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C7.02944 3 3 7.02944 3 12C3 16.9706 7.02944 21 12 21C16.9706 21 21 16.9706 21 12C21 7.02944 16.9706 3 12 3ZM1 12C1 5.92487 5.92487 1 12 1C18.0751 1 23 5.92487 23 12C23 18.0751 18.0751 23 12 23C5.92487 23 1 18.0751 1 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 8C10.8954 8 10 8.89543 10 10C10 11.1046 10.8954 12 12 12C13.1046 12 14 11.1046 14 10C14 8.89543 13.1046 8 12 8ZM8 10C8 7.79086 9.79086 6 12 6C14.2091 6 16 7.79086 16 10C16 12.2091 14.2091 14 12 14C9.79086 14 8 12.2091 8 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 20C6 17.2386 8.23858 15 11 15H13C15.7614 15 18 17.2386 18 20V20.5H16V20C16 18.3431 14.6569 17 13 17H11C9.34315 17 8 18.3431 8 20V20.5H6V20Z"
  })),
  name: 'ProfileIcon',
  tags: ["profile", "user", "person", "circle"],
  category: 'system'
};
var PutToHoldIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13.265 13.1771C13.265 13.8828 12.6798 14.4508 11.974 14.4336C11.2683 14.4336 10.7003 13.8484 10.7003 13.1427C10.7347 12.4369 11.3027 11.8861 12.0085 11.8861C12.7142 11.8861 13.2822 12.4714 13.265 13.1771Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.692 13.1599C15.6748 15.2082 14.0051 16.8434 11.974 16.8262C9.92574 16.8089 8.29054 15.1565 8.30775 13.1082C8.30775 11.0599 9.97738 9.42474 12.0257 9.44195C14.0568 9.45916 15.7092 11.1116 15.692 13.1599ZM9.51264 13.1082C9.51264 14.468 10.597 15.5696 11.9568 15.5869C13.3166 15.6041 14.4182 14.5197 14.4354 13.1599C14.4527 11.8001 13.3683 10.6985 12.0085 10.6813C10.6659 10.664 9.54706 11.7657 9.51264 13.1082Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.8409 1H10.1814L8.19861 2.68294L8.19851 4H5.0002L4.99998 20H2.99219L2.86713 3.99228L0.867188 4.0079L1.00775 22L23 22L23 4.00006L21 4.00006L21 20H18.9998L19 4H15.8236L15.8238 2.68301L13.8409 1ZM13.8236 4H10.1985L10.1985 3.60876L10.9158 3H13.1065L13.8237 3.60869L13.8236 4ZM6.99998 20L16.9998 20L17 6H7.00017L6.99998 20Z"
  })),
  name: 'PutToHoldIcon',
  tags: ["put", "hold"],
  category: 'sasc'
};
var PyramidApparelAccessoriesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1174 2.42353C14.429 2.2146 14.9005 1.98307 15.4716 2.01706C16.0309 2.05035 17.0696 2.15184 18.0975 2.47476C19.0844 2.78481 20.3054 3.3748 20.8944 4.55278C21.3554 5.47489 21.6044 6.80988 21.7515 7.99697C21.9031 9.22071 21.9619 10.4323 21.9849 11.1903C22.0136 12.1347 21.371 12.938 20.485 13.1595L18 13.7808V20C18 21.1046 17.1045 22 16 22H7.99996C6.89539 22 5.99996 21.1046 5.99996 20V13.7808L3.51489 13.1595C2.63018 12.9383 1.98109 12.1329 2.02104 11.1792C2.07491 9.89296 2.27364 7.12324 3.07148 5.12861C3.61848 3.7611 4.79696 3.0134 5.83684 2.6051C6.88538 2.19339 7.94405 2.06422 8.51372 2.02186C9.09429 1.97868 9.57251 2.21567 9.88249 2.42353C10.1937 2.63219 10.8946 3 12 3C13.1053 3 13.8062 2.63219 14.1174 2.42353ZM5.99996 11.7192V8H7.99996V20H16V8H18V11.7192L19.985 11.223C19.9623 10.4942 19.9058 9.36574 19.7667 8.24287C19.6212 7.06881 19.4001 6.03627 19.1055 5.44721C18.8915 5.01923 18.3423 4.64805 17.4981 4.38282C16.702 4.13275 15.8565 4.04419 15.3662 4.01434C15.3638 4.01503 15.3604 4.01606 15.356 4.01758C15.3313 4.0262 15.2894 4.04567 15.2313 4.08464C14.6588 4.46851 13.5768 5 12 5C10.4231 5 9.34108 4.46851 8.76862 4.08464C8.71025 4.0455 8.66947 4.02685 8.64701 4.0191C8.64555 4.01859 8.64423 4.01816 8.64306 4.01778C8.16254 4.05472 7.34036 4.16339 6.5678 4.46673C5.7763 4.77751 5.18446 5.23131 4.92844 5.87139C4.27744 7.49889 4.07728 9.92379 4.02092 11.2245L5.99996 11.7192Z"
  })),
  name: 'PyramidApparelAccessoriesIcon',
  tags: ["pyramid", "apparel", "accessories", "shirt"],
  category: 'merchandising'
};
var PyramidFoodBeverageIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.14819 5.24807C0.998972 4.05436 1.92975 3 3.13274 3H12.8672C14.0702 3 15.0009 4.05436 14.8517 5.24807L14.3672 9.12403L12.3827 8.87597L12.8672 5L3.13274 5L4.88274 19H12V21H4.88274C3.87409 21 3.02329 20.2489 2.89819 19.2481L1.14819 5.24807Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2071 6.20711L16.7071 8.70711L15.2929 7.29289L17.7929 4.79289L19.2071 6.20711Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.80384 9.01942C7.9333 8.99353 8.06661 8.99353 8.19607 9.01942L10.6961 9.51942L10.3038 11.4806L7.99996 11.0198L5.69607 11.4806C5.56661 11.5065 5.4333 11.5065 5.30384 11.4806L2.80384 10.9806L3.19607 9.01942L5.49996 9.4802L7.80384 9.01942Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5 9C12.4624 9 9.99996 11.4624 9.99996 14.5C9.99996 17.5376 12.4624 20 15.5 20C18.5375 20 21 17.5376 21 14.5C21 11.4624 18.5375 9 15.5 9ZM7.99996 14.5C7.99996 10.3579 11.3578 7 15.5 7C19.6421 7 23 10.3579 23 14.5C23 18.6421 19.6421 22 15.5 22C11.3578 22 7.99996 18.6421 7.99996 14.5Z"
  })),
  name: 'PyramidFoodBeverageIcon',
  tags: ["pyramid", "food", "beverage", "fruit", "drink"],
  category: 'merchandising'
};
var PyramidHardlinesIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V15C23 16.1046 22.1046 17 21 17H3C1.89543 17 1 16.1046 1 15V5ZM21 5H3V15H21V5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 21V19H20V21H4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 20V15H10V20H8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 20V15H16V20H14Z"
  })),
  name: 'PyramidHardlinesIcon',
  tags: ["pyramid", "hardlines", "tv", "television"],
  category: 'merchandising'
};
var PyramidHealthBeautyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 12C3 10.8954 3.89543 10 5 10H9C10.1046 10 11 10.8954 11 12V21C11 22.1046 10.1046 23 9 23H5C3.89543 23 3 22.1046 3 21V12ZM9 12H5V21H9V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5.61803C4 4.13127 5.56462 3.16428 6.89443 3.82918L8.89443 4.82918C9.572 5.16796 10 5.86049 10 6.61803V10C10 11.1046 9.10457 12 8 12H6C4.89543 12 4 11.1046 4 10V5.61803ZM8 6.61803L6 5.61803V10H8L8 6.61803Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4742 3.51328L14.5662 7H17.4338L19.5258 3.51328C18.7203 3.26839 17.4954 3 16 3C14.5046 3 13.2797 3.26839 12.4742 3.51328ZM17 9H15V20.6657C15.1458 20.8035 15.4461 21 16 21C16.5539 21 16.8542 20.8035 17 20.6657V9ZM15.0001 20.7664L15 20.7644L15.0001 20.7664ZM13 8.27698L10.6981 4.44048C10.1116 3.46306 10.452 2.06156 11.6995 1.66011C12.6482 1.35481 14.1479 1 16 1C17.8521 1 19.3518 1.35481 20.3005 1.66011C21.548 2.06156 21.8884 3.46306 21.3019 4.44048L19 8.27698V20.7639C19 21.0552 18.9357 21.4602 18.6504 21.8184C18.2754 22.2892 17.4471 23 16 23C14.5529 23 13.7246 22.2892 13.3496 21.8184C13.0643 21.4602 13 21.0552 13 20.7639V8.27698Z"
  })),
  name: 'PyramidHealthBeautyIcon',
  tags: ["pyramid", "health", "beauty", "makeup", "lipstick"],
  category: 'merchandising'
};
var PyramidHomeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.82012 2.25722C7.12384 1.4979 7.85926 1 8.67707 1H15.323C16.1408 1 16.8762 1.4979 17.18 2.25722L20.38 10.2572C20.9054 11.5709 19.9379 13 18.523 13H13V21H17V23H7.00004V21H11V13H5.47707C4.06214 13 3.09463 11.5709 3.62012 10.2572L6.82012 2.25722ZM15.323 3L8.67707 3L5.47707 11H18.523L15.323 3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.00004 17V12H9.00004V17H7.00004Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 9H6.00004V7H18V9Z"
  })),
  name: 'PyramidHomeIcon',
  tags: ["pyramid", "home", "iron"],
  category: 'merchandising'
};
var PyramidSpecialProjectIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.91894 3.75061C5.29849 3.27618 5.87311 3 6.48068 3H17.5194C18.127 3 18.7016 3.27618 19.0812 3.75061L22.2908 7.76271C22.8663 8.48203 22.876 9.50137 22.3144 10.2315L13.5853 21.5793C12.7847 22.6201 11.2154 22.6201 10.4148 21.5793L1.68575 10.2315C1.12409 9.50137 1.1338 8.48203 1.70926 7.76271L4.91894 3.75061ZM6.48068 5L3.271 9.0121L12.0001 20.3599L20.7291 9.0121L17.5194 5L6.48068 5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4383 4.35139C11.239 3.35058 12.7611 3.35058 13.5618 4.35139L16.4504 7.96218C16.8639 8.47907 16.9949 9.16708 16.8002 9.79974L13.9116 19.1878C13.3324 21.0702 10.6677 21.0702 10.0885 19.1878L7.19986 9.79974C7.0052 9.16708 7.13617 8.47907 7.54968 7.96218L10.4383 4.35139ZM12.0001 5.60078L9.11142 9.21157L12.0001 18.5996L14.8887 9.21157L12.0001 5.60078Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00005 10V8H22.0001V10H2.00005Z"
  })),
  name: 'PyramidSpecialProjectIcon',
  tags: ["pyramid", "special", "project", "gem", "dimond", "crystal"],
  category: 'merchandising'
};
var PyramidIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2325 4.20149C10.9837 2.78253 13.0164 2.78252 13.7676 4.20149L21.1067 18.0642C21.8119 19.3962 20.8463 21 19.3391 21H4.66095C3.1538 21 2.18819 19.3962 2.89337 18.0642L10.2325 4.20149ZM19.3391 19L12 5.13727L4.66094 19L19.3391 19Z"
  })),
  name: 'PyramidIcon',
  tags: ["pyramid", "triangle", "shape"],
  category: 'merchandising'
};
var ReadyForReviewFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12,1C5.9,1,1,5.9,1,12c0,6.1,4.9,11,11,11c6.1,0,11-4.9,11-11C23,5.9,18.1,1,12,1z M8.9,4.6L9.5,6C8.7,6.3,8,6.8,7.4,7.4 l-1-1C7.1,5.6,8,5,8.9,4.6z M4,12c0-0.5,0.1-1,0.2-1.6c0.1-0.5,0.3-1,0.5-1.5L6,9.5c-0.2,0.4-0.3,0.8-0.4,1.2 c-0.1,0.4-0.1,0.9-0.1,1.3L4,12z M6.3,17.7C5.6,16.9,5,16,4.6,15.1L6,14.5c0.3,0.8,0.8,1.5,1.4,2.1L6.3,17.7z M8.7,11.7l1.9,1.9 l4.8-4.8l1,1l-5.8,5.8l-2.9-2.9L8.7,11.7z M12,20c-0.5,0-1-0.1-1.6-0.2c-0.5-0.1-1-0.3-1.5-0.5L9.5,18c0.4,0.2,0.8,0.3,1.2,0.4 c0.4,0.1,0.9,0.1,1.3,0.1L12,20z M18.2,17.1c-0.5,0.6-1.1,1.1-1.7,1.6c-0.4,0.3-0.9,0.5-1.4,0.7L14.5,18c0.8-0.3,1.5-0.8,2.1-1.4 c0.1-0.1,0.3-0.3,0.4-0.5c0.4-0.5,0.7-1,1-1.7c0.2-0.4,0.3-0.8,0.4-1.2c0.1-0.3,0.1-0.6,0.1-0.9c0.1-1-0.1-2-0.5-2.8 c-0.3-0.8-0.8-1.5-1.4-2.1c-0.9-0.9-2-1.5-3.4-1.8c-0.4-0.1-0.9-0.1-1.3-0.1L12,4c0.5,0,1,0.1,1.6,0.2c0.5,0.1,1,0.3,1.5,0.5 c1,0.4,1.9,1,2.6,1.7c0.1,0.1,0.2,0.2,0.2,0.2c0.1,0.1,0.2,0.2,0.3,0.3c0.5,0.6,0.9,1.3,1.2,2c0.6,1.4,0.8,3,0.5,4.6 C19.6,14.9,19,16.1,18.2,17.1z"
  })),
  name: 'ReadyForReviewFilledIcon',
  tags: ["review", "ready", "status"],
  category: 'status'
};
var ReadyForReviewIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M13.8,3.3c-0.6-0.1-1.2-0.2-1.8-0.2l0-2c0.7,0,1.4,0.1,2.1,0.2c0.7,0.1,1.4,0.4,2.1,0.6c1.4,0.6,2.6,1.4,3.6,2.4 c0.1,0.1,0.2,0.2,0.3,0.3c0.1,0.1,0.3,0.3,0.4,0.5c0.7,0.8,1.2,1.8,1.7,2.8c0.8,1.9,1.1,4.1,0.6,6.4c-0.4,1.8-1.2,3.5-2.3,4.9 c-0.7,0.8-1.5,1.6-2.4,2.2c-0.6,0.4-1.2,0.7-1.9,1l-0.8-1.8c1.1-0.5,2.1-1.1,2.9-2c0.2-0.2,0.4-0.4,0.6-0.6c0.6-0.7,1-1.4,1.4-2.3 c0.2-0.5,0.4-1.1,0.5-1.7c0.1-0.4,0.1-0.9,0.2-1.3c0.1-1.4-0.2-2.7-0.7-3.9c-0.5-1.1-1.1-2.1-2-2.9C17.2,4.5,15.6,3.7,13.8,3.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,3.8c-1.1,0.5-2.1,1.1-2.9,2L4.2,4.3c1-1,2.2-1.8,3.6-2.4L8.6,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,8.7c-0.2,0.5-0.4,1.1-0.5,1.7C3.1,11,3,11.5,3,12.1l-2,0c0-0.7,0.1-1.4,0.2-2.1c0.1-0.7,0.4-1.4,0.6-2.1L3.7,8.7z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.7,15.6c0.5,1.1,1.1,2.1,2,2.9l-1.4,1.4c-1-1-1.8-2.2-2.4-3.6L3.7,15.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.6,20.4c0.5,0.2,1.1,0.4,1.7,0.5c0.6,0.1,1.2,0.2,1.8,0.2l0,2c-0.7,0-1.4-0.1-2.1-0.2c-0.7-0.1-1.4-0.4-2.1-0.6L8.6,20.4 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6,7.8L10,14.3l-2.6-2.6L6,13.2l4,4l8-8L16.6,7.8z"
  })),
  name: 'ReadyForReviewIcon',
  tags: ["review", "ready", "status"],
  category: 'status'
};
var ReceiptIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 3C3 1.89543 3.89543 1 5 1H19C20.1046 1 21 1.89543 21 3V21C21 22.1046 20.1046 23 19 23H18.4142C17.8838 23 17.3751 22.7893 17 22.4142L16.1554 21.5696L15.6641 22.3066C14.8725 23.4941 13.1275 23.4941 12.3359 22.3066L12 21.8028L11.6641 22.3066C10.8725 23.4941 9.12754 23.4941 8.3359 22.3066L7.84457 21.5696L7 22.4142C6.62493 22.7893 6.11622 23 5.58579 23H5C3.89543 23 3 22.1046 3 21V3ZM19 3L5 3V21H5.58579L6.43036 20.1554C7.32279 19.263 8.80859 19.4101 9.50868 20.4602L10 21.1972L10.3359 20.6934C11.1275 19.5059 12.8725 19.5059 13.6641 20.6934L14 21.1972L14.4913 20.4602C15.1914 19.4101 16.6772 19.263 17.5696 20.1554L18.4142 21H19V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 8H8V6H16V8ZM16 12H8V10H16V12Z"
  })),
  name: 'ReceiptIcon',
  tags: ["receipt"],
  category: 'system'
};
var RedoIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.00008C8.13401 7.00008 5 10.1341 5 14.0001C5 17.8661 8.13401 21.0001 12 21.0001C15.866 21.0001 19 17.8661 19 14.0001H21C21 18.9706 16.9706 23.0001 12 23.0001C7.02944 23.0001 3 18.9706 3 14.0001C3 9.02951 7.02944 5.00008 12 5.00008H19.8182V7.00008H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 1.29297L22.4142 6.00008L17.7071 10.7072L16.2929 9.29297L19.5858 6.00008L16.2929 2.70718L17.7071 1.29297Z"
  })),
  name: 'RedoIcon',
  tags: ["redo", "arrow"],
  category: 'system'
};
var RefreshIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.00003 7.00008C6.79089 7.00008 5.00003 8.79094 5.00003 11.0001H3.00003C3.00003 7.68637 5.68632 5.00008 9.00003 5.00008H20V7.00008H9.00003Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15 17.0001C17.2092 17.0001 19 15.2092 19 13.0001H21C21 16.3138 18.3137 19.0001 15 19.0001H4.00003V17.0001L15 17.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41424 18.0001L7.70714 14.7072L6.29292 13.293L1.58582 18.0001L6.29292 22.7072L7.70714 21.293L4.41424 18.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7071 1.29297L22.4142 6.00008L17.7071 10.7072L16.2929 9.29297L19.5858 6.00008L16.2929 2.70718L17.7071 1.29297Z"
  })),
  name: 'RefreshIcon',
  tags: ["refresh", "recycle", "arrow"],
  category: 'system'
};
var ReplyIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3668 3.56972C10.7489 3.72035 11.0001 4.08932 11.0001 4.50006V8.15857C17.1879 9.42066 20.0807 14.3039 20.9807 18.8039C21.0731 19.2661 20.8302 19.7302 20.3976 19.9176C19.965 20.105 19.4603 19.9648 19.1863 19.5812C17.3189 16.9668 14.6139 15.2941 11.0001 15.0353V18.5001C11.0001 18.8978 10.7644 19.2577 10.3998 19.4167C10.0352 19.5757 9.61108 19.5035 9.31962 19.2329L1.58496 12.0506L9.26902 3.81774C9.54928 3.51746 9.98465 3.4191 10.3668 3.56972ZM4.41519 11.9494L9.00008 16.2068V13.0001H10.0001C12.9753 13.0001 15.5091 13.7964 17.5791 15.2139C16.1292 12.6266 13.6762 10.5354 9.85866 9.99001L9.00008 9.86736V7.03707L4.41519 11.9494Z"
  })),
  name: 'ReplyIcon',
  tags: ["reply", "arrow"],
  category: 'sasc'
};
var RewrapIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.4681 3.34213C12.1867 3.20105 11.8553 3.20068 11.5737 3.34113L6.17421 6.0333L8.00858 7.01929L13.8091 4.0145L12.4681 3.34213ZM16.0186 5.12234L10.1425 8.16629L11.9999 9.16466L17.8305 6.0308L16.0186 5.12234ZM10.6812 1.55127C11.5263 1.12993 12.5204 1.13104 13.3645 1.55427L20.4483 5.10603C20.7819 5.27333 20.9947 5.61253 21 5.98574C21.0053 6.35896 20.8023 6.70407 20.4735 6.88078L12.9468 10.9263C12.3555 11.2441 11.6443 11.2441 11.053 10.9263L3.52655 6.88078C3.19743 6.70387 2.99439 6.35823 3.00012 5.98462C3.00585 5.61101 3.21939 5.27176 3.55379 5.10503L10.6812 1.55127ZM1.4869 8.14166C1.78889 7.96113 2.16354 7.95259 2.47345 8.11917L10.4734 12.4192C10.7976 12.5935 10.9999 12.9318 10.9999 13.3L11.0001 21C11.0001 21.3466 10.8206 21.6685 10.5258 21.8507C10.231 22.0329 9.86284 22.0494 9.55285 21.8944L1.55279 17.8944C1.214 17.7251 1 17.3788 1 17V8.99999C1 8.64815 1.1849 8.32219 1.4869 8.14166ZM22.5132 8.14166C22.8152 8.32219 23.0001 8.64815 23.0001 8.99999V17C23.0001 17.3788 22.7861 17.7251 22.4473 17.8944L14.4473 21.8944C14.1373 22.0494 13.7691 22.0329 13.4743 21.8507C13.1795 21.6685 13.0001 21.3466 13.0001 21L13.0002 13.3C13.0002 12.9318 13.2025 12.5935 13.5268 12.4192L21.5267 8.11917C21.8366 7.95259 22.2112 7.96113 22.5132 8.14166ZM3 10.6728V16.382L9.00003 19.382L8.99993 13.8978L3 10.6728ZM15.0002 13.8978L15.0001 19.382L21.0001 16.382V10.6728L15.0002 13.8978Z"
  })),
  name: 'RewrapIcon',
  tags: ["rewrap", "box", "shipping", "wrap"],
  category: 'sasc'
};
var RupeeIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6 5V3H18V5H15.0004C15.4371 5.58141 15.75 6.26112 15.9 7H18V9H15.9C15.4368 11.2822 13.419 13 11.0001 13H9.41426L17.2072 20.7929L15.7929 22.2071L6.79111 13.2053C5.97731 12.3915 6.55368 11 7.70457 11H11.0001C12.3063 11 13.4175 10.1652 13.8293 9H6V7H13.8293C13.4175 5.83481 12.3063 5 11.0001 5H6Z"
  })),
  name: 'RupeeIcon',
  tags: ["cash", "money", "bills", "rupee"],
  category: 'system'
};
var SaveIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.92773 6.16565C3.92773 5.06108 4.82317 4.16565 5.92773 4.16565H14.5996C15.1034 4.16565 15.5887 4.35581 15.9584 4.69812L19.3857 7.87156C19.7945 8.25008 20.0269 8.78196 20.0269 9.33909V18.6633C20.0269 19.7679 19.1315 20.6633 18.0269 20.6633H5.92773C4.82317 20.6633 3.92773 19.7679 3.92773 18.6633V6.16565ZM8.5498 6.16565H12.8113V7.80403H8.5498V6.16565ZM5.92773 6.16565H6.5498V7.80403C6.5498 8.9086 7.44524 9.80403 8.5498 9.80403H12.8113C13.9158 9.80403 14.8113 8.9086 14.8113 7.80403V6.36166L18.0269 9.33909V18.6633H16.9746V15.1505C16.9746 14.0459 16.0792 13.1505 14.9746 13.1505H9.02539C7.92082 13.1505 7.02539 14.0459 7.02539 15.1505V18.6633H5.92773V6.16565ZM9.02539 18.6633L14.9746 18.6633V15.1505H9.02539V18.6633Z"
  })),
  name: 'SaveIcon',
  tags: ["save", "disk"],
  category: 'system'
};
var ScanIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.91667 11.0656V17H6.36111V11.0656H7.91667ZM17.6389 11.0656V17H16.8611V11.0656H17.6389ZM9.86111 11.0656V17H9.08333V11.0656H9.86111ZM13.3611 11.0656V17H11.0278V11.0656H13.3611ZM15.6944 11.0656V17H14.5278V11.0656H15.6944ZM19 9.58333V10.4098H5V9.58333H19ZM7.91667 7V8.93443H6.36111V7H7.91667ZM17.6389 7V8.93443H16.8611V7H17.6389ZM9.86111 7V8.93443H9.08333V7H9.86111ZM13.3611 7V8.93443H11.0278V7H13.3611ZM15.6944 7V8.93443H14.5278V7H15.6944Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H21C22.1046 3 23 3.89543 23 5V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V5ZM21 5H3V19H21V5Z"
  })),
  name: 'ScanIcon',
  tags: ["scan", "barcode"],
  category: 'sasc'
};
var SearchIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 4C6.68629 4 4 6.68629 4 10C4 13.3137 6.68629 16 10 16C13.3137 16 16 13.3137 16 10C16 6.68629 13.3137 4 10 4ZM2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7071 14.2929L21.7071 20.2929L20.2929 21.7071L14.2929 15.7071L15.7071 14.2929Z"
  })),
  name: 'SearchIcon',
  tags: ["search", "find", "magnify"],
  category: 'system'
};
var ShelfIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H4V6H20V2H22V22H20V18H4V22H2V2ZM4 16H20V13H4V16ZM4 11H20V8H4V11Z"
  })),
  name: 'ShelfIcon',
  tags: ["shelf"],
  category: 'sasc'
};
var ShipIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.66661 2.00003H22.9999L23 18.5L18.3333 22H1L0.999939 5.50004L5.66661 2.00003ZM6.33328 4.00003L4.99993 5.00004H17.6666L18.9999 4.00003H6.33328ZM20.9999 5.00003L18.9999 6.50004L19 19L21 17.5L20.9999 5.00003ZM17 20L16.9999 7.00004H2.99994L3 20H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.96853 17.9998C12.444 18.0208 14.4789 16.0279 14.4998 13.5315C14.5208 11.0351 12.5069 9.02114 10.0315 9.00016C7.53505 8.97918 5.50016 10.9721 5.50016 13.4685C5.47919 15.9649 7.47212 17.9789 9.96853 17.9998ZM9.94755 16.4894C8.29027 16.4684 6.96864 15.1258 6.96864 13.4685C7.0106 11.8322 8.37419 10.4896 10.0105 10.5106C11.6678 10.5316 12.9894 11.8742 12.9684 13.5315C12.9474 15.1887 11.6048 16.5104 9.94755 16.4894ZM9.96853 15.0839C10.8286 15.1048 11.5419 14.4126 11.5419 13.5524C11.5629 12.6923 10.8706 11.9791 10.0105 11.9791C9.15038 11.9791 8.4581 12.6504 8.41614 13.5105C8.41614 14.3706 9.10842 15.0839 9.96853 15.0839Z"
  })),
  name: 'ShipIcon',
  tags: ["ship", "shipping", "target", "box", "package"],
  category: 'sasc'
};
var SignIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.4908 6.0004L4 6.00924L4 17.9908L15.4908 17.9996C16.3212 16.8557 18.6294 13.6688 19.7879 12C18.6294 10.3312 16.3212 7.14433 15.4908 6.0004ZM15.4897 4.0004C16.1263 3.99991 16.7281 4.30046 17.1069 4.82215C18.0285 6.09177 20.8767 10.0238 21.83 11.4422L22.2049 12L21.83 12.5578C20.8767 13.9762 18.0285 17.9082 17.1069 19.1779C16.7281 19.6996 16.1263 20.0001 15.4897 19.9996L3.99846 19.9908C2.89449 19.9899 2 19.0947 2 17.9908V6.00924C2 4.90527 2.89449 4.01009 3.99846 4.00924L15.4897 4.0004Z"
  })),
  name: 'SignIcon',
  tags: ["sign", "direction", "store", "wayfinding"],
  category: 'system'
};
var SlackIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M6.20179 14.6384C6.20179 15.7946 5.25714 16.7393 4.10089 16.7393C2.94464 16.7393 2 15.7946 2 14.6384C2 13.4821 2.94464 12.5375 4.10089 12.5375H6.20179V14.6384ZM7.26071 14.6384C7.26071 13.4821 8.20536 12.5375 9.36161 12.5375C10.5179 12.5375 11.4625 13.4821 11.4625 14.6384V19.8991C11.4625 21.0554 10.5179 22 9.36161 22C8.20536 22 7.26071 21.0554 7.26071 19.8991V14.6384ZM9.36161 6.20179C8.20536 6.20179 7.26071 5.25714 7.26071 4.10089C7.26071 2.94464 8.20536 2 9.36161 2C10.5179 2 11.4625 2.94464 11.4625 4.10089V6.20179H9.36161V6.20179ZM9.36161 7.26071C10.5179 7.26071 11.4625 8.20536 11.4625 9.36161C11.4625 10.5179 10.5179 11.4625 9.36161 11.4625H4.10089C2.94464 11.4625 2 10.5179 2 9.36161C2 8.20536 2.94464 7.26071 4.10089 7.26071H9.36161V7.26071ZM17.7982 9.36161C17.7982 8.20536 18.7429 7.26071 19.8991 7.26071C21.0554 7.26071 22 8.20536 22 9.36161C22 10.5179 21.0554 11.4625 19.8991 11.4625H17.7982V9.36161V9.36161ZM16.7393 9.36161C16.7393 10.5179 15.7946 11.4625 14.6384 11.4625C13.4821 11.4625 12.5375 10.5179 12.5375 9.36161V4.10089C12.5375 2.94464 13.4821 2 14.6384 2C15.7946 2 16.7393 2.94464 16.7393 4.10089V9.36161V9.36161ZM14.6384 17.7982C15.7946 17.7982 16.7393 18.7429 16.7393 19.8991C16.7393 21.0554 15.7946 22 14.6384 22C13.4821 22 12.5375 21.0554 12.5375 19.8991V17.7982H14.6384ZM14.6384 16.7393C13.4821 16.7393 12.5375 15.7946 12.5375 14.6384C12.5375 13.4821 13.4821 12.5375 14.6384 12.5375H19.8991C21.0554 12.5375 22 13.4821 22 14.6384C22 15.7946 21.0554 16.7393 19.8991 16.7393H14.6384Z"
  })),
  name: 'SlackIcon',
  tags: ["slack"],
  category: 'system'
};
var SqlFullOuterJoinIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.8732 18.1415C13.0005 18.9062 14.3073 19.3773 15.6677 19.4472C17.0282 19.5172 18.3818 19.2131 19.5816 18.5681C20.7815 17.9231 21.7817 16.9617 22.4737 15.7883C23.1658 14.615 23.5232 13.2745 23.5072 11.9124C23.4912 10.5502 23.1023 9.21848 22.3829 8.06172C21.6635 6.90496 20.6409 5.96737 19.4263 5.35072C18.2116 4.73407 16.8512 4.46193 15.4928 4.56384C14.1344 4.66574 13.0032 5.10834 11.8941 5.89931C15.7761 8.99833 15.8229 14.8841 11.9908 18.0445L11.8732 18.1415Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.75 18.161C10.6362 18.9489 9.83377 19.3429 8.47284 19.4387C7.11192 19.5344 5.7508 19.255 4.53767 18.6308C3.32453 18.0067 2.30588 17.0616 1.59262 15.8986C0.879347 14.7357 0.498796 13.3993 0.492392 12.035C0.485988 10.6707 0.853977 9.33084 1.5563 8.1612C2.25862 6.99157 3.26835 6.03703 4.47557 5.40148C5.68279 4.76594 7.04122 4.47376 8.40299 4.55675C9.76475 4.63974 10.6289 5.09659 11.75 5.87403C8.04669 9.09405 7.90657 14.8965 11.6469 18.0734L11.75 18.161Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8632 7.0567C14.2568 8.95797 15.0547 13.9013 11.8632 16.9433C8.67168 13.9013 9.46954 8.95797 11.8632 7.0567Z"
  })),
  name: 'SqlFullOuterJoinIcon',
  tags: ["sql"],
  category: 'data'
};
var SqlInnerJoinIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.94736 4.30261C9.43441 4.30261 10.823 4.7243 12 5.45461C13.177 4.7243 14.5656 4.30261 16.0526 4.30261C20.3038 4.30261 23.75 7.74884 23.75 12C23.75 16.2511 20.3038 19.6973 16.0526 19.6973C14.5656 19.6973 13.177 19.2757 12 18.5453C10.823 19.2757 9.43441 19.6973 7.94736 19.6973C3.69622 19.6973 0.249992 16.2511 0.249992 12C0.249992 7.74884 3.69622 4.30261 7.94736 4.30261ZM1.74999 12C1.74999 8.57727 4.52465 5.80261 7.94736 5.80261C8.94216 5.80261 9.88222 6.03701 10.7153 6.45358C10.0118 7.13071 9.43685 7.94042 9.0306 8.84251C8.49398 10.0043 8.24995 11.3145 8.3818 12.6436C8.54082 14.5645 9.40521 16.2853 10.7153 17.5464C9.88222 17.9629 8.94216 18.1973 7.94736 18.1973C4.52465 18.1973 1.74999 15.4227 1.74999 12ZM15.6447 12C15.6447 14.1787 14.7395 16.146 13.2847 17.5464C14.1178 17.9629 15.0578 18.1973 16.0526 18.1973C19.4753 18.1973 22.25 15.4227 22.25 12C22.25 8.57727 19.4753 5.80261 16.0526 5.80261C15.0578 5.80261 14.1178 6.03701 13.2847 6.45358C14.7395 7.85391 15.6447 9.82123 15.6447 12Z"
  })),
  name: 'SqlInnerJoinIcon',
  tags: ["sql"],
  category: 'data'
};
var SqlLeftOuterJoinIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M12.9466 6.83805C15.5888 8.82342 16.4695 13.9854 12.9466 17.1619C9.42366 13.9854 10.3044 8.82342 12.9466 6.83805Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.1448 18.1672C11.0452 18.9584 9.6385 19.3585 8.29309 19.4561C6.94767 19.5536 5.60164 19.275 4.40193 18.6506C3.20221 18.0261 2.19491 17.0799 1.48999 15.9152C0.785061 14.7504 0.409602 13.4119 0.404592 12.0457C0.399582 10.6796 0.765213 9.33829 1.46157 8.16826C2.15794 6.99823 3.15827 6.04444 4.35337 5.411C5.54848 4.77756 6.89242 4.48881 8.23852 4.57627C9.58461 4.66374 10.8811 5.12405 11.9865 5.90697C8.09825 9.05402 8.13227 14.9949 12.0563 18.0972L12.1448 18.1672Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.7113 18.7265C18.5376 19.3638 17.2185 19.6463 15.8996 19.54C14.5913 19.4346 13.4798 19.0386 12.4043 18.2162L13.1333 17.263C14.0134 17.9361 14.9017 18.2557 15.996 18.3439C17.0797 18.4312 18.1668 18.1997 19.1386 17.6719C20.1109 17.144 20.9324 16.3386 21.5088 15.3401C22.0854 14.3413 22.3931 13.19 22.3954 12.0132C22.3977 10.8363 22.0944 9.68362 21.5217 8.68227C20.9491 7.68115 20.1307 6.87216 19.1604 6.33991C18.1905 5.80789 17.1042 5.57164 16.0202 5.65422C14.9149 5.73842 13.8205 6.10397 12.9455 6.76728L12.2205 5.81101C13.307 4.9874 14.6311 4.55657 15.9291 4.45769C17.2484 4.35719 18.5664 4.64542 19.7375 5.28781C20.9082 5.92997 21.8846 6.89983 22.5633 8.08648C23.2419 9.27291 23.5981 10.6323 23.5954 12.0155C23.5927 13.3987 23.2313 14.7565 22.5481 15.94C21.8647 17.1238 20.8845 18.0894 19.7113 18.7265Z"
  })),
  name: 'SqlLeftOuterJoinIcon',
  tags: ["sql"],
  category: 'data'
};
var SqlRightOuterJoinIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.0534 17.1619C8.41117 15.1766 7.53043 10.0146 11.0534 6.83805C14.5763 10.0146 13.6956 15.1766 11.0534 17.1619Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.8551 5.83277C12.9548 5.04155 14.3615 4.64154 15.7069 4.54395C17.0523 4.44636 18.3983 4.72499 19.598 5.34942C20.7978 5.97385 21.8051 6.92009 22.51 8.08484C23.2149 9.2496 23.5904 10.5881 23.5954 11.9543C23.6004 13.3204 23.2348 14.6617 22.5384 15.8317C21.842 17.0018 20.8417 17.9556 19.6466 18.589C18.4515 19.2224 17.1075 19.5112 15.7615 19.4237C14.4154 19.3363 13.1189 18.8759 12.0135 18.093C15.9017 14.946 15.8677 9.00507 11.9437 5.90275L11.8551 5.83277Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.28869 5.2735C5.46233 4.6362 6.78151 4.35374 8.10038 4.46C9.4087 4.56542 10.5202 4.96135 11.5957 5.78377L10.8667 6.737C9.98655 6.06393 9.09825 5.74429 8.004 5.65612C6.92031 5.56881 5.83321 5.80031 4.86133 6.32806C3.88905 6.85602 3.06759 7.66137 2.49115 8.65991C1.91457 9.65868 1.60684 10.81 1.60456 11.9868C1.60228 13.1637 1.90556 14.3164 2.4783 15.3177C3.05091 16.3188 3.8693 17.1278 4.8396 17.6601C5.8095 18.1921 6.89573 18.4284 7.97974 18.3458C9.08502 18.2616 10.1795 17.896 11.0545 17.2327L11.7794 18.189C10.693 19.0126 9.3689 19.4434 8.07089 19.5423C6.75161 19.6428 5.43357 19.3546 4.26248 18.7122C3.0918 18.07 2.11538 17.1002 1.43665 15.9135C0.758044 14.7271 0.401885 13.3677 0.404562 11.9845C0.407239 10.6013 0.768659 9.24349 1.45189 8.05997C2.13524 6.87622 3.11547 5.91058 4.28869 5.2735Z"
  })),
  name: 'SqlRightOuterJoinIcon',
  tags: ["sql"],
  category: 'data'
};
var StackOverflowIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.3021 15.0157H20.0961V22.1918H3.95001V15.0157H5.74402V20.3978H18.3021V15.0157Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.69926 14.4827L16.5103 16.3346L16.8807 14.5732L8.06964 12.7205L7.69926 14.4827ZM8.8652 10.2637L17.0273 14.065L17.7876 12.4326L9.62537 8.6313L8.8652 10.2637ZM11.1237 6.25929L18.0433 12.0215L19.1957 10.6376L12.2761 4.87563L11.1237 6.25929ZM15.5903 2L14.1453 3.07477L19.5188 10.2997L20.9638 9.22511L15.5903 2ZM7.53815 18.604H16.5082V16.81H7.53815V18.604Z"
  })),
  name: 'StackOverflowIcon',
  tags: ["stack-overflow"],
  category: 'system'
};
var StarFilledIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M11.9077 2.222C11.9418 2.13987 12.0582 2.13987 12.0923 2.222L14.8862 8.9393C14.9005 8.97375 14.9329 8.99736 14.97 9.00054L21.7665 9.58088C21.8543 9.58837 21.8902 9.69742 21.8241 9.7556L17.0457 13.9598C17.0176 13.9845 17.0057 14.0228 17.0148 14.0591L18.9432 21.7727C18.9645 21.8581 18.873 21.9274 18.7965 21.8837L12.0496 18.0284C12.0189 18.0108 11.9811 18.0108 11.9504 18.0284L5.20346 21.8837C5.127 21.9274 5.03548 21.8581 5.05684 21.7727L6.98523 14.0591C6.9943 14.0228 6.98236 13.9845 6.95427 13.9598L2.17592 9.7556C2.1098 9.69742 2.14572 9.58837 2.23347 9.58088L9.02996 9.00054C9.06714 8.99736 9.09945 8.97375 9.11378 8.9393L11.9077 2.222Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9843 1.83797C11.3601 0.934548 12.6399 0.934542 13.0157 1.83797L15.5997 8.05066L21.8516 8.58451C22.8168 8.66692 23.2119 9.86648 22.4846 10.5064L18.1179 14.3484L19.9133 21.5301C20.1483 22.47 19.1415 23.2326 18.3004 22.752L12 19.1518L5.6996 22.752C4.85848 23.2326 3.85174 22.4699 4.08669 21.5301L5.88212 14.3484L1.51536 10.5064C0.788078 9.86648 1.18318 8.66693 2.14839 8.58451L8.40034 8.05066L10.9843 1.83797ZM12 4.60396L10.0371 9.32333C9.87948 9.7023 9.52399 9.96199 9.11504 9.99691L4.41974 10.3978L7.61483 13.209C7.92379 13.4808 8.05518 13.9024 7.95537 14.3016L6.5385 19.9691L11.4542 17.1601C11.7924 16.9669 12.2076 16.9669 12.5458 17.1601L17.4615 19.9691L16.0446 14.3016C15.9448 13.9024 16.0762 13.4808 16.3852 13.209L19.5803 10.3978L14.885 9.99691C14.476 9.96199 14.1205 9.7023 13.9629 9.32333L12 4.60396Z"
  })),
  name: 'StarFilledIcon',
  tags: ["star", "filled", "favorite", "rating"],
  category: 'toggle'
};
var StarHalfIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.69979 22.752L12.0002 19.1518L18.3006 22.752C19.1417 23.2326 20.1484 22.47 19.9135 21.5301L18.1181 14.3484L22.4848 10.5064C23.2121 9.86648 22.817 8.66692 21.8518 8.58451L15.5998 8.05066L13.0158 1.83797C12.828 1.38625 12.4141 1.1604 12.0002 1.1604C11.5863 1.1604 11.1724 1.38626 10.9845 1.83797L8.40053 8.05066L2.14857 8.58451C1.18336 8.66693 0.788261 9.86648 1.51554 10.5064L5.88231 14.3484L4.08688 21.5301C3.85192 22.4699 4.85866 23.2326 5.69979 22.752ZM12.0002 17.0152C12.1885 17.0152 12.3768 17.0635 12.5459 17.1601L17.4617 19.9691L16.0448 14.3016C15.945 13.9024 16.0764 13.4808 16.3854 13.209L19.5804 10.3978L14.8851 9.99691C14.4762 9.96199 14.1207 9.7023 13.9631 9.32333L12.0002 4.60396V17.0152Z"
  })),
  name: 'StarHalfIcon',
  tags: ["star", "half", "filled", "rating"],
  category: 'toggle'
};
var StarIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.9843 1.83797C11.3601 0.934548 12.6399 0.934542 13.0157 1.83797L15.5997 8.05066L21.8516 8.58451C22.8168 8.66692 23.2119 9.86648 22.4846 10.5064L18.1179 14.3484L19.9133 21.5301C20.1483 22.47 19.1415 23.2326 18.3004 22.752L12 19.1518L5.6996 22.752C4.85848 23.2326 3.85174 22.4699 4.08669 21.5301L5.88212 14.3484L1.51536 10.5064C0.788078 9.86648 1.18318 8.66693 2.14839 8.58451L8.40034 8.05066L10.9843 1.83797ZM12 4.60396L10.0371 9.32333C9.87948 9.7023 9.52399 9.96199 9.11504 9.99691L4.41974 10.3978L7.61483 13.209C7.92379 13.4808 8.05518 13.9024 7.95537 14.3016L6.5385 19.9691L11.4542 17.1601C11.7924 16.9669 12.2076 16.9669 12.5458 17.1601L17.4615 19.9691L16.0446 14.3016C15.9448 13.9024 16.0762 13.4808 16.3852 13.209L19.5803 10.3978L14.885 9.99691C14.476 9.96199 14.1205 9.7023 13.9629 9.32333L12 4.60396Z"
  })),
  name: 'StarIcon',
  tags: ["star", "rating", "favorite"],
  category: 'toggle'
};
var StopIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 7.16217C5 5.96804 5.96803 5 7.16217 5H17.2378C18.432 5 19.4 5.96803 19.4 7.16217V17.2378C19.4 18.432 18.432 19.4 17.2378 19.4H7.16217C5.96804 19.4 5 18.432 5 17.2378V7.16217ZM7.16217 7.16217V17.2378L17.2378 17.2378L17.2378 7.16217L7.16217 7.16217Z"
  })),
  name: 'StopIcon',
  tags: ["stop"],
  category: 'system'
};
var StoreAltIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 7C2 5.89543 2.89543 5 4 5H6V7L4 7V19H20V7H17.5V5H20C21.1046 5 22 5.89543 22 7V19C22 20.1046 21.1046 21 20 21H4C2.89543 21 2 20.1046 2 19V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16C6 14.8954 6.89543 14 8 14H16C17.1046 14 18 14.8954 18 16V19C18 20.1046 17.1046 21 16 21H8C6.89543 21 6 20.1046 6 19V16ZM11 16H8V19H11V16ZM13 16V19H16V16H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 6C10 6.55228 9.55228 7 9 7C8.44772 7 8 6.55228 8 6C8 5.44772 8.44772 5 9 5C9.55228 5 10 5.44772 10 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 7H11V5H16V7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 4C5 2.89543 5.89543 2 7 2H17C18.1046 2 19 2.89543 19 4V8C19 9.10457 18.1046 10 17 10H7C5.89543 10 5 9.10457 5 8V4ZM17 4H7V8H17V4Z"
  })),
  name: 'StoreAltIcon',
  tags: ["store", "alt", "target"],
  category: 'system'
};
var StoreMapIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5 3C8.70125 3 6.5 5.17186 6.5 7.76923C6.5 8.80301 6.84388 9.76044 7.43376 10.5449L7.48136 10.6069L11.5 15.4366L15.5186 10.607L15.5663 10.5448C16.1561 9.76039 16.5 8.80298 16.5 7.76923C16.5 5.17186 14.2988 3 11.5 3ZM4.5 7.76923C4.5 3.99408 7.67133 1 11.5 1C15.3287 1 18.5 3.99408 18.5 7.76923C18.5 9.25943 18.0011 10.6367 17.1612 11.7516L17.1559 11.7587L17.0813 11.8558L16.1292 13H18.1827L22.7161 21H0.283936L4.81727 13H6.87077L5.91868 11.8558L5.83877 11.7516C4.9989 10.6367 4.5 9.25943 4.5 7.76923ZM8.53494 15H5.98273L3.71606 19H19.2839L17.0173 15H14.4651L11.5 18.5634L8.53494 15ZM11.5 7C10.9477 7 10.5 7.44772 10.5 8C10.5 8.55228 10.9477 9 11.5 9C12.0523 9 12.5 8.55228 12.5 8C12.5 7.44772 12.0523 7 11.5 7ZM8.5 8C8.5 6.34315 9.84314 5 11.5 5C13.1569 5 14.5 6.34315 14.5 8C14.5 9.65685 13.1569 11 11.5 11C9.84314 11 8.5 9.65685 8.5 8Z"
  })),
  name: 'StoreMapIcon',
  tags: ["store", "map"],
  category: 'system'
};
var StoreIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 5C5 3.89543 5.89543 3 7 3H17C18.1046 3 19 3.89543 19 5V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V5ZM7 5V19H17V5H7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 11C1 9.89543 1.89543 9 3 9H6V11H3V19H21V11H18V9H21C22.1046 9 23 9.89543 23 11V19C23 20.1046 22.1046 21 21 21H3C1.89543 21 1 20.1046 1 19V11Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10 8C10 8.55228 9.55229 9 9 9C8.44772 9 8 8.55228 8 8C8 7.44772 8.44772 7 9 7C9.55229 7 10 7.44772 10 8Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 9H11V7H16V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 16C5 14.8954 5.89543 14 7 14H17C18.1046 14 19 14.8954 19 16V19C19 20.1046 18.1046 21 17 21H7C5.89543 21 5 20.1046 5 19V16ZM11 16H7V19H11V16ZM13 16V19H17V16H13Z"
  })),
  name: 'StoreIcon',
  tags: ["store", "target"],
  category: 'system'
};
var SubDirectoryIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.04053 13.5963L2.04053 1.42928L4.07201 1.42928L4.07201 11.5648L14.1847 11.5648L10.582 7.96214L12.0185 6.52566L18.0734 12.5806L12.0185 18.6355L10.582 17.199L14.1847 13.5963L2.04053 13.5963Z"
  })),
  name: 'SubDirectoryIcon',
  tags: ["direction", "sub-direction"],
  category: 'navigation'
};
var SumIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.99995 5.41421C2.74002 4.15428 3.63236 2 5.41417 2H20C21.1045 2 22 2.89543 22 4V6H20V4H5.41417L12 10.5858C12.781 11.3668 12.781 12.6332 12 13.4142L5.41417 20H20V18H22V20C22 21.1046 21.1045 22 20 22H5.41417C3.63236 22 2.74003 19.8457 3.99995 18.5858L10.5857 12L3.99995 5.41421Z"
  })),
  name: 'SumIcon',
  tags: ["sum", "addition"],
  category: 'data'
};
var SupportIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 11.8857H14.5807V9.88574H5.42041V11.8857Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.42041 15.3056H14.5807V13.3056H5.42041V15.3056Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M23.0005 3.04004C23.0005 1.93547 22.1051 1.04004 21.0005 1.04004H7.00049C5.89592 1.04004 5.00049 1.93547 5.00049 3.04004V5.61084H3.00098C1.89641 5.61084 1.00098 6.50627 1.00098 7.61084V17.6253C1.00098 18.7299 1.89641 19.6253 3.00098 19.6253H3.30255V20.2085C3.30255 21.774 5.01998 22.7326 6.35246 21.9107L10.0579 19.6253H17.001C18.1055 19.6253 19.001 18.7299 19.001 17.6253V15.0545H21.0005C22.1051 15.0545 23.0005 14.1591 23.0005 13.0545V3.04004ZM17.001 5.61084H7.00049V3.04004H21.0005V13.0545H19.001V7.61084C19.001 6.50627 18.1055 5.61084 17.001 5.61084ZM3.00098 7.61084V17.6253H5.30255L5.30255 20.2085L9.00798 17.9231C9.32359 17.7284 9.68709 17.6253 10.0579 17.6253H17.001V7.61084L3.00098 7.61084Z"
  })),
  name: 'SupportIcon',
  tags: ["support", "chat"],
  category: 'sasc'
};
var TagIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 2.58579C12.375 2.21071 12.8838 2 13.4142 2H20C21.1045 2 22 2.89543 22 4V10.5858C22 11.1162 21.7893 11.6249 21.4142 12L12.4142 21C11.6331 21.781 10.3668 21.781 9.58576 21L2.99997 14.4142C2.21892 13.6332 2.21892 12.3668 2.99997 11.5858L12 2.58579ZM20 4H13.4142L4.41418 13L11 19.5858L20 10.5858V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 8C17 8.55228 16.5523 9 16 9C15.4477 9 15 8.55228 15 8C15 7.44772 15.4477 7 16 7C16.5523 7 17 7.44772 17 8Z"
  })),
  name: 'TagIcon',
  tags: ["tag", "price"],
  category: 'system'
};
var TakeLocationIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M19 14H13V12H19V14Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.952 6.00016C14.5736 3.60894 11.9747 2 9 2C4.59217 2 1 5.53689 1 9.92308C1 11.6587 1.56463 13.2658 2.52036 14.5708L2.5344 14.5899L9.00004 22.591L12.0692 18.793C13.1897 19.5548 14.5429 20 16 20C19.866 20 23 16.866 23 13C23 9.13401 19.866 6 16 6C15.984 6 15.968 6.00006 15.952 6.00016ZM9 4C5.67585 4 3 6.66224 3 9.92308C3 11.2098 3.41452 12.3989 4.12044 13.3706L9.00003 19.409L10.5896 17.4419C9.59632 16.2334 9 14.6864 9 13C9 9.90612 11.0072 7.28104 13.7904 6.35589C12.6959 4.92594 10.9589 4 9 4ZM11 13C11 10.2386 13.2386 8 16 8C18.7614 8 21 10.2386 21 13C21 15.7614 18.7614 18 16 18C13.2386 18 11 15.7614 11 13Z"
  })),
  name: 'TakeLocationIcon',
  tags: ["take", "location", "remove", "delete"],
  category: 'sasc'
};
var TeacherIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M7.5 4C6.39543 4 5.5 4.89543 5.5 6V8H7.5V6H20V16H18V15C18 14.4477 17.5523 14 17 14H15C14.4477 14 14 14.4477 14 15V16H12V18H20C21.1046 18 22 17.1046 22 16V6C22 4.89543 21.1046 4 20 4H7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.5 9C4.84315 9 3.5 10.3431 3.5 12C3.5 13.6569 4.84315 15 6.5 15C8.15685 15 9.5 13.6569 9.5 12C9.5 10.3431 8.15685 9 6.5 9ZM5.5 12C5.5 11.4477 5.94772 11 6.5 11C7.05228 11 7.5 11.4477 7.5 12C7.5 12.5523 7.05228 13 6.5 13C5.94772 13 5.5 12.5523 5.5 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2 20C2 17.5147 4.01472 15.5 6.5 15.5C8.98528 15.5 11 17.5147 11 20H9C9 18.6193 7.88071 17.5 6.5 17.5C5.11929 17.5 4 18.6193 4 20H2Z"
  })),
  name: 'TeacherIcon',
  tags: ["teacher", "school", "learn", "person", "presentation"],
  category: 'system'
};
var TelephoneIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.75255 1.73469C6.63812 1.38076 6.36612 1.21341 6.25772 1.15495C6.12255 1.08205 5.9865 1.04276 5.88232 1.01958C5.66763 0.971823 5.42447 0.957275 5.18355 0.964736C4.69534 0.979855 4.08132 1.08986 3.47286 1.35128C2.86046 1.61439 2.22409 2.04437 1.74563 2.71621C1.26112 3.39654 0.978139 4.26999 0.99564 5.34436C1.05854 9.20607 2.79969 12.5839 4.98628 14.7837C7.30728 17.1132 10.8935 18.872 14.6407 18.952C15.6934 18.9744 16.5532 18.6938 17.2254 18.2144C17.888 17.7419 18.3177 17.113 18.5847 16.5087C18.8503 15.9078 18.9696 15.2999 18.993 14.8152C19.0046 14.5764 18.9946 14.3336 18.9503 14.1182C18.9288 14.0138 18.8913 13.8755 18.8186 13.7375C18.7593 13.6249 18.5907 13.3483 18.2311 13.2341C18.1203 13.1989 17.9305 13.1617 17.7679 13.1307C17.5759 13.0942 17.3265 13.0494 17.0425 12.9998C16.4736 12.9006 15.7529 12.7799 15.0464 12.6634C14.3394 12.5468 13.6444 12.434 13.1264 12.3504C12.8673 12.3085 12.6524 12.274 12.5022 12.2499L12.2664 12.2121L12.1837 12.1989L12.1 12.2012C11.7496 12.2107 11.5156 12.3972 11.4039 12.5106C11.2896 12.6267 11.2168 12.7513 11.174 12.8336C11.133 12.9124 11.0978 12.9956 11.0677 13.076C10.942 13.0129 10.8051 12.9406 10.6604 12.8595C9.92195 12.4461 9.09783 11.8744 8.5791 11.3079C8.08817 10.7673 7.53131 9.94199 7.11699 9.22687C7.0468 9.10571 6.98245 8.99066 6.92459 8.88355C6.99485 8.8556 7.06643 8.8237 7.13472 8.78748C7.21681 8.74393 7.3406 8.67027 7.45556 8.55537C7.56766 8.44333 7.75229 8.20859 7.75992 7.85881L7.76165 7.77983L7.74958 7.70169L7.71306 7.4661C7.68975 7.31605 7.65633 7.10135 7.61585 6.84254C7.53491 6.32503 7.42566 5.63077 7.31255 4.92444C7.19954 4.21867 7.08229 3.49851 6.98545 2.93003C6.9371 2.64624 6.89325 2.39676 6.85721 2.20444C6.82707 2.04364 6.78969 1.84959 6.75255 1.73469ZM7.24619 12.5162C6.63596 11.844 6.00584 10.8996 5.5595 10.1292C5.33501 9.74172 5.14209 9.37263 5.01545 9.08065C4.95539 8.94219 4.89255 8.78124 4.85672 8.62803C4.84101 8.56083 4.81238 8.423 4.82573 8.26125C4.83642 8.1316 4.91305 7.64556 5.42888 7.45234C5.49634 7.42707 5.56739 7.40704 5.61445 7.39417C5.6664 7.37996 5.72504 7.36495 5.77904 7.35112L5.78238 7.35026L5.86983 7.32777L5.83748 7.1207C5.75673 6.60445 5.64784 5.91249 5.5352 5.20905C5.42246 4.50505 5.30634 3.79187 5.21101 3.23232C5.18184 3.06106 5.15483 2.9055 5.13063 2.7698C4.86123 2.79065 4.52012 2.86041 4.18341 3.00508C3.80354 3.16828 3.45894 3.41337 3.21182 3.76036C2.97075 4.09886 2.78356 4.58801 2.7954 5.31504C2.84987 8.65895 4.36472 11.6089 6.26224 13.5179L6.25959 13.5205C8.28138 15.549 11.4374 17.0832 14.6791 17.1524C15.3739 17.1672 15.8473 16.9864 16.1803 16.749C16.5229 16.5046 16.7703 16.1613 16.9383 15.7812C17.0838 15.4519 17.1588 15.1187 17.1857 14.8534C17.0522 14.8292 16.9 14.8022 16.7331 14.773C16.1726 14.6752 15.4583 14.5556 14.7535 14.4394C14.0491 14.3232 13.3563 14.2108 12.8395 14.1273L12.6411 14.0953L12.6242 14.1622L12.6204 14.1775C12.6063 14.2334 12.5908 14.2945 12.5757 14.3494C12.5625 14.3977 12.5412 14.4727 12.5131 14.5449C12.3167 15.0501 11.8378 15.1248 11.7288 15.1366C11.5738 15.1533 11.4394 15.1314 11.3692 15.1178C11.2119 15.0875 11.0449 15.0303 10.8966 14.9723C10.5861 14.851 10.1943 14.6615 9.78107 14.4301C8.96545 13.9735 7.95029 13.289 7.24552 12.5168L7.24619 12.5162Z"
  })),
  name: 'TelephoneIcon',
  tags: ["telephone", "phone", "communication"],
  category: 'system'
};
var TemperatureIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11 14C11 14.0565 11.0047 14.1119 11.0137 14.1659C9.84135 14.5738 9 15.6887 9 17C9 18.6569 10.3431 20 12 20C13.6569 20 15 18.6569 15 17C15 15.6887 14.1586 14.5738 12.9863 14.1659C12.9953 14.1119 13 14.0565 13 14V9C13 8.44772 12.5523 8 12 8C11.4477 8 11 8.44772 11 9V14ZM12 16C11.4477 16 11 16.4477 11 17C11 17.5523 11.4477 18 12 18C12.5523 18 13 17.5523 13 17C13 16.4477 12.5523 16 12 16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 1C9.74315 1 8 2.91051 8 5.1579V12.5406L7.82352 12.6921L7.79996 12.7152C6.69032 13.803 6 15.3218 6 17C6 20.3137 8.68629 23 12 23C15.3137 23 18 20.3137 18 17C18 15.3218 17.3097 13.803 16.2 12.7152L16.1765 12.6921L16 12.5406V5.1579C16 2.91051 14.2569 1 12 1ZM10 5.1579C10 3.91717 10.9431 3 12 3C13.0569 3 14 3.91717 14 5.1579V13.4594L14.8221 14.1653C15.5508 14.8908 16 15.8921 16 17C16 19.2092 14.2091 21 12 21C9.79086 21 8 19.2092 8 17C8 15.8921 8.44919 14.8908 9.17787 14.1653L10 13.4594V5.1579Z"
  })),
  name: 'TemperatureIcon',
  tags: ["temperature", "cold", "hot", "weather"],
  category: 'sasc'
};
var TemplateIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 2C3.89543 2 3 2.89543 3 4V7C3 8.10457 3.89543 9 5 9H19C20.1046 9 21 8.10457 21 7V4C21 2.89543 20.1046 2 19 2H5ZM19 4H5L5 7H19V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 11C3.89543 11 3 11.8954 3 13V20C3 21.1046 3.89543 22 5 22H9C10.1046 22 11 21.1046 11 20V13C11 11.8954 10.1046 11 9 11H5ZM9 13H5V20H9V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 13H20V11H13V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20 17H13V15H20V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 21H20V19H13V21Z"
  })),
  name: 'TemplateIcon',
  tags: ["template", "layout"],
  category: 'system'
};
var TextStringIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M4 3C3.44772 3 3 3.44772 3 4V9H5V5H11V19H8V21H16V19H13V5H19V9H21V4C21 3.44772 20.5523 3 20 3H4Z"
  })),
  name: 'TextStringIcon',
  tags: ["text", "string"],
  category: 'data'
};
var ThumbsDownIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 12C22 13.1046 21.1046 14 20 14H16V12H20V4H14V2H20C21.1046 2 22 2.89543 22 4V12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.135 21.4629C14.9464 22.3587 14.1561 23 13.2406 23C10.3874 23 8.1798 20.4993 8.5337 17.6681L8.86721 15H4.19821C2.9504 15 2.00725 13.8699 2.23047 12.6422L3.86683 3.64223C4.03974 2.69125 4.868 2 5.83457 2H15C16.1046 2 17 2.89543 17 4V12.3959C17 12.5343 16.9856 12.6724 16.9571 12.8079L15.135 21.4629ZM13.1887 20.9995L15 12.3959V4H5.83457L4.19821 13H8.86721C10.0702 13 11.001 14.0544 10.8518 15.2481L10.5183 17.9162C10.3157 19.5364 11.5637 20.9696 13.1887 20.9995Z"
  })),
  name: 'ThumbsDownIcon',
  tags: ["thumbs", "down", "no", "rating", "rejected"],
  category: 'system'
};
var ThumbsUpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 13C2 11.8954 2.89543 11 4 11H8V13H4V21H10V23H4C2.89543 23 2 22.1046 2 21V13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.86501 3.53707C9.05361 2.64125 9.84392 2 10.7594 2C13.6126 2 15.8202 4.50071 15.4663 7.33191L15.1328 10H19.8018C21.0496 10 21.9927 11.1301 21.7695 12.3578L20.1332 21.3578C19.9603 22.3088 19.132 23 18.1654 23H9C7.89543 23 7 22.1046 7 21V12.6041C7 12.4657 7.01438 12.3276 7.0429 12.1921L8.86501 3.53707ZM10.8113 4.00048L9 12.6041V21H18.1654L19.8018 12H15.1328C13.9298 12 12.999 10.9456 13.1482 9.75193L13.4817 7.08385C13.6843 5.46356 12.4363 4.03043 10.8113 4.00048Z"
  })),
  name: 'ThumbsUpIcon',
  tags: ["thumbs", "up", "yes", "rating", "approved"],
  category: 'system'
};
var TieLocationIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M17 14V16H15V14H13V12H15V10H17V12H19V14H17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.952 6.00016C14.5736 3.60894 11.9747 2 9 2C4.59217 2 1 5.53689 1 9.92308C1 11.6587 1.56463 13.2658 2.52036 14.5708L2.5344 14.5899L9.00004 22.591L12.0692 18.793C13.1897 19.5548 14.5429 20 16 20C19.866 20 23 16.866 23 13C23 9.13401 19.866 6 16 6C15.984 6 15.968 6.00006 15.952 6.00016ZM9 4C5.67585 4 3 6.66224 3 9.92308C3 11.2098 3.41452 12.3989 4.12044 13.3706L9.00003 19.409L10.5896 17.4419C9.59632 16.2334 9 14.6864 9 13C9 9.90612 11.0072 7.28104 13.7904 6.35589C12.6959 4.92594 10.9589 4 9 4ZM11 13C11 10.2386 13.2386 8 16 8C18.7614 8 21 10.2386 21 13C21 15.7614 18.7614 18 16 18C13.2386 18 11 15.7614 11 13Z"
  })),
  name: 'TieLocationIcon',
  tags: ["tie", "location", "add", "connect"],
  category: 'sasc'
};
var TimerIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9 2L15 2V4L9 4L9 2ZM12 7C8.68629 7 6 9.68629 6 13C6 16.3137 8.68629 19 12 19C15.3137 19 18 16.3137 18 13C18 9.68629 15.3137 7 12 7ZM4 13C4 8.58172 7.58172 5 12 5C14.1038 5 16.0179 5.81205 17.446 7.13981L18.7929 5.79289L20.2071 7.20711L18.7344 8.67984C19.5354 9.92587 20 11.4087 20 13C20 17.4183 16.4183 21 12 21C7.58172 21 4 17.4183 4 13ZM11 13V8H13V13H11Z"
  })),
  name: 'TimerIcon',
  tags: ["overdue", "due", "timer", "second", "minute", "fast"],
  category: 'system'
};
var TmInProgressIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.7637 3.12341C15.3367 3.03882 14.9122 2.99818 14.4946 2.99805L14.4952 0.998047C15.0425 0.998223 15.5971 1.05151 16.1526 1.16159C16.7081 1.27167 17.241 1.43389 17.747 1.64244L17.747 1.6425C18.798 2.07572 19.7305 2.70792 20.5067 3.48441L20.5068 3.48433C21.2949 4.27275 21.922 5.20988 22.3503 6.23912L22.3501 6.23919C22.7719 7.2526 23.001 8.35532 23.0006 9.49272C23.0004 10.04 22.9471 10.5945 22.837 11.15C22.727 11.7055 22.5647 12.2385 22.3562 12.7445L22.3561 12.7445C22.0302 13.5351 21.5916 14.2589 21.0635 14.8996C20.8898 15.1104 20.7064 15.3121 20.5142 15.5042L20.5143 15.5042C19.7259 16.2924 18.7887 16.9195 17.7595 17.3478L16.9911 15.5013C17.385 15.3374 17.7614 15.1353 18.1148 14.8989L18.1147 14.8988C18.6406 14.547 19.115 14.1191 19.5203 13.6275C20.1808 12.8262 20.6584 11.8544 20.8751 10.7613C21.3125 8.55385 20.5769 6.3857 19.0954 4.90155C18.2168 4.02142 17.0773 3.38378 15.7637 3.12347L15.7637 3.12341ZM9.90081 4.90633C10.5043 4.30303 11.2221 3.82267 12.01 3.49482L11.2416 1.64831C10.2124 2.07658 9.27527 2.70373 8.48686 3.49186L9.90081 4.90633ZM8.12596 8.23482C8.21058 7.80783 8.3349 7.39988 8.49406 7.01371L6.64496 6.2516C6.43641 6.7576 6.27419 7.29055 6.16411 7.84605L5.96973 8.82697L7.93158 9.21575L8.12596 8.23482ZM13.2373 15.8727L12.2564 15.6783L11.8677 17.6401L12.8486 17.8345C13.4041 17.9446 13.9586 17.9979 14.5059 17.998L14.5065 15.998C14.0889 15.9979 13.6643 15.9573 13.2373 15.8727ZM13.0173 10.8025L17.747 6.07275L19.1612 7.48697L13.0173 13.6309L9.83887 10.4525L11.2531 9.0383L13.0173 10.8025ZM7 14C6.44772 14 6 14.4477 6 15C6 15.5523 6.44772 16 7 16C7.55228 16 8 15.5523 8 15C8 14.4477 7.55228 14 7 14ZM4 15C4 13.3431 5.34315 12 7 12C8.65685 12 10 13.3431 10 15C10 16.6569 8.65685 18 7 18C5.34315 18 4 16.6569 4 15ZM7 18H8C10.2091 18 12 19.7909 12 22H10C10 20.8954 9.10457 20 8 20H6C4.89543 20 4 20.8954 4 22H2C2 19.7909 3.79086 18 6 18H7Z"
  })),
  name: 'TmInProgressIcon',
  tags: ["team", "member", "in", "progress"],
  category: 'sasc'
};
var TouchscreenIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2307 3C10.0008 3 9.84609 3.17627 9.84609 3.36132V14.3358L5.5757 13.4545L9.88641 17H15.6738L16.0107 16.6688L16.996 12.2162L16.9986 12.1974L16.9992 12.1879C16.9903 12.0527 16.9004 11.9316 16.7821 11.8833L16.7573 11.8732L12.4336 9.83205L12.389 9.81621C12.3627 9.80935 12.3392 9.80658 12.3169 9.80658H10.6153V3.39335C10.6047 3.26976 10.5535 3.16943 10.4893 3.10402C10.4275 3.04107 10.3454 3 10.2307 3ZM16.9999 18.5009V22H7.99993V18.038L4.15945 14.8792C3.27707 14.1535 3.21398 12.8246 4.02361 12.0185L4.02807 12.0141C4.56294 11.4882 5.25236 11.377 5.83262 11.4666L5.85745 11.4705L7.84609 11.8809V3.36132C7.84609 2.03984 8.92833 1 10.2307 1C11.6104 1 12.5523 2.10457 12.614 3.31022L12.6153 3.33575V7.82631C12.744 7.84339 12.8685 7.87111 12.9881 7.90764L13.0094 7.91417L13.197 7.98077L17.566 10.0433C18.4049 10.3988 18.9999 11.2392 18.9999 12.2099V12.2429L18.9897 12.3971L18.9669 12.5665L17.8354 17.6795L16.9999 18.5009ZM9.99993 19V20H14.9999V19H9.99993Z"
  })),
  name: 'TouchscreenIcon',
  tags: ["touch", "screen", "point", "hand"],
  category: 'system'
};
var TrainingIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 5.91205L22 10.1978V16H20V12.3737L19 12.8023V16.6784L12 19.5827L5.00002 16.6784V12.8023L0.461426 10.8572L12 5.91205ZM7.00002 13.6594V15.3429L12 17.4174L17 15.3429V13.6594L12 15.8023L7.00002 13.6594ZM18.4614 10.8572L12 13.6263L5.53861 10.8572L12 8.08798L18.4614 10.8572Z"
  })),
  name: 'TrainingIcon',
  tags: ["training", "learning", "school"],
  category: 'system'
};
var TrashIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.13824 6.23368C2.99836 5.0447 3.92736 4 5.12454 4H18.8755C20.0726 4 21.0016 5.0447 20.8618 6.23368L19.0971 21.2337C18.9786 22.2409 18.1249 23 17.1108 23H6.88925C5.87508 23 5.02145 22.2409 4.90295 21.2337L3.13824 6.23368ZM18.8755 6H5.12454L6.88925 21H17.1108L18.8755 6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 3C7 1.89543 7.89543 1 9 1H15C16.1046 1 17 1.89543 17 3V4C17 5.10457 16.1046 6 15 6H9C7.89543 6 7 5.10457 7 4V3ZM15 3H9V4H15V3Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 6H2V4H22V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9 9H11V18H9V9Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13 9H15V18H13V9Z"
  })),
  name: 'TrashIcon',
  tags: ["trash", "delete", "remove"],
  category: 'system'
};
var TroubleshootIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.74905 3.00627L11.152 6.4092L10.1357 10.1356L6.40923 11.152L3.00619 7.74892C2.93798 9.11267 3.42461 10.4958 4.46442 11.5356C5.93832 13.0095 8.10529 13.3723 9.92089 12.618L10.5386 12.3614L18.7997 20.6225C19.303 21.1258 20.1192 21.1258 20.6226 20.6225C21.1259 20.1192 21.1259 19.3031 20.6224 18.7997L12.3614 10.5386L12.618 9.92083C13.3722 8.10527 13.0093 5.93837 11.5355 4.46451C10.4957 3.42476 9.11274 2.93813 7.74905 3.00627ZM7.09282 1.05877C9.17062 0.788531 11.351 1.45164 12.9497 3.05029C14.8437 4.94431 15.4243 7.65213 14.6959 10.0446L22.0367 17.3854C23.321 18.6698 23.3213 20.7522 22.0368 22.0367C20.7524 23.3211 18.6698 23.3211 17.3854 22.0367L10.0447 14.6959C7.65218 15.4244 4.94426 14.8439 3.0502 12.9498C1.45148 11.3511 0.788381 9.17052 1.05871 7.09264C1.16141 6.30324 1.71753 5.76476 2.37813 5.59938C3.01127 5.44088 3.71071 5.62501 4.20971 6.12401L7.00274 8.91704L8.50685 8.50683L8.91707 7.00271L6.12412 4.20977C5.62512 3.71076 5.44099 3.01131 5.59951 2.37815C5.7649 1.71755 6.3034 1.16144 7.09282 1.05877Z"
  })),
  name: 'TroubleshootIcon',
  tags: ["troubleshoot", "wrench", "fix", "bug"],
  category: 'system'
};
var TruckIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 5C1 3.89543 1.89543 3 3 3H15C16.1046 3 17 3.89543 17 5V15H15V5L3 5V19C1.89543 19 1 18.1046 1 17V5ZM9 17H12.5V19H9V17Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 6H18.4338C19.1363 6 19.7873 6.3686 20.1488 6.97101L22.8575 11.4855C22.9507 11.6409 23 11.8188 23 12V17C23 18.1046 22.1046 19 21 19H19V17H21V13H17V15H15V11H20.2338L18.4338 8H17V6Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6 16C4.89543 16 4 16.8954 4 18C4 19.1046 4.89543 20 6 20C7.10457 20 8 19.1046 8 18C8 16.8954 7.10457 16 6 16ZM2 18C2 15.7909 3.79086 14 6 14C8.20914 14 10 15.7909 10 18C10 20.2091 8.20914 22 6 22C3.79086 22 2 20.2091 2 18Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 16C14.8954 16 14 16.8954 14 18C14 19.1046 14.8954 20 16 20C17.1046 20 18 19.1046 18 18C18 16.8954 17.1046 16 16 16ZM12 18C12 15.7909 13.7909 14 16 14C18.2091 14 20 15.7909 20 18C20 20.2091 18.2091 22 16 22C13.7909 22 12 20.2091 12 18Z"
  })),
  name: 'TruckIcon',
  tags: ["truck", "shipping"],
  category: 'system'
};
var UndoIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.00008C15.866 7.00008 19 10.1341 19 14.0001C19 17.8661 15.866 21.0001 12 21.0001C8.13404 21.0001 5.00003 17.8661 5.00003 14.0001H3.00003C3.00003 18.9706 7.02947 23.0001 12 23.0001C16.9706 23.0001 21 18.9706 21 14.0001C21 9.02951 16.9706 5.00008 12 5.00008H4.18185V7.00008H12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.41424 6.00008L7.70714 2.70718L6.29292 1.29297L1.58582 6.00008L6.29292 10.7072L7.70714 9.29297L4.41424 6.00008Z"
  })),
  name: 'UndoIcon',
  tags: ["undo", "delete", "arrow"],
  category: 'system'
};
var UploadIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.29289 12.2929L12 6.58579L17.7071 12.2929L16.2929 13.7071L12 9.41421L7.70711 13.7071L6.29289 12.2929Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13 9V22H11V9H13Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H20C21.1046 2 22 2.89543 22 4V8H20V4H4V8H2V4Z"
  })),
  name: 'UploadIcon',
  tags: ["upload", "arrow"],
  category: 'system'
};
var VideoIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 5C2.89543 5 2 5.89543 2 7V17C2 18.1046 2.89543 19 4 19H16C17.1046 19 18 18.1046 18 17V16.2198L20.6078 16.7413C21.8453 16.9889 23 16.0423 23 14.7802V9.2198C23 7.9577 21.8454 7.01112 20.6078 7.25863L18 7.78019V7C18 5.89543 17.1046 5 16 5H4ZM18 9.8198V14.1802L21 14.7802V9.2198L18 9.8198ZM16 9.8198V7L4 7V17H16V14.1802V9.8198Z"
  })),
  name: 'VideoIcon',
  tags: ["video", "camera", "movie"],
  category: 'system'
};
var VisibleHideIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.1924 21.1924L19.7782 22.6066L16.8713 19.6997C15.508 20.4776 13.8884 21 12 21C8.57234 21 6.03033 19.2789 4.29879 17.4329C2.57381 15.5939 1.58549 13.5647 1.22757 12.7471C1.01871 12.27 1.01871 11.73 1.22757 11.2529C1.56658 10.4785 2.47115 8.61712 4.03157 6.85996L1.39344 4.22183L2.80765 2.80762L21.1924 21.1924ZM13.0361 15.8645L15.3919 18.2203C14.3981 18.7023 13.2707 19 12 19C9.30585 19 7.25566 17.6618 5.75749 16.0646C4.28978 14.4999 3.41745 12.751 3.08393 12C3.39335 11.3033 4.16653 9.74765 5.44864 8.27704L8.13553 10.9639C8.04715 11.2944 8.00004 11.6417 8.00004 12C8.00004 14.2091 9.7909 16 12 16C12.3584 16 12.7057 15.9529 13.0361 15.8645Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5514 15.723L19.9685 17.1401C21.5289 15.3829 22.4335 13.5216 22.7725 12.7471C22.9814 12.27 22.9814 11.73 22.7725 11.2529C22.4146 10.4353 21.4263 8.40613 19.7013 6.56715C17.9697 4.72116 15.4277 3.00001 12 3.00001C10.1116 3.00001 8.49205 3.52241 7.12871 4.30028L8.6082 5.77977C9.602 5.29767 10.7294 5.00001 12 5.00001C14.6942 5.00001 16.7444 6.33824 18.2426 7.93542C19.7103 9.50013 20.5826 11.249 20.9161 12C20.6067 12.6967 19.8335 14.2524 18.5514 15.723Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.8645 13.0361C15.9529 12.7057 16 12.3583 16 12C16 9.79087 14.2092 8.00001 12 8.00001C11.6417 8.00001 11.2944 8.04712 10.9639 8.1355L13.4074 10.579C13.412 10.5835 13.4165 10.5881 13.4211 10.5927L15.8645 13.0361Z"
  })),
  name: 'VisibleHideIcon',
  tags: ["visible", "hide", "show", "eye"],
  category: 'toggle'
};
var VisibleShowIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    d: "M10 12C10 10.8954 10.8954 10 12 10C13.1046 10 14 10.8954 14 12C14 13.1046 13.1046 14 12 14C10.8954 14 10 13.1046 10 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 3C8.57234 3 6.03033 4.72116 4.29879 6.56714C2.57381 8.40612 1.58549 10.4353 1.22757 11.2529C1.01871 11.73 1.01871 12.27 1.22757 12.7471C1.58549 13.5647 2.57381 15.5939 4.29879 17.4329C6.03033 19.2788 8.57234 21 12 21C15.4277 21 17.9697 19.2788 19.7013 17.4329C21.4263 15.5939 22.4146 13.5647 22.7725 12.7471C22.9814 12.27 22.9814 11.73 22.7725 11.2529C22.4146 10.4353 21.4263 8.40612 19.7013 6.56714C17.9697 4.72116 15.4277 3 12 3ZM12 8C9.79086 8 8 9.79086 8 12C8 14.2091 9.79086 16 12 16C14.2091 16 16 14.2091 16 12C16 9.79086 14.2091 8 12 8Z"
  })),
  name: 'VisibleShowIcon',
  tags: ["visible", "show", "hide", "eye"],
  category: 'toggle'
};
var VisualMerchIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 2H7V4H4V7H2V2ZM17 2H22V7H20V4H17V2ZM7 7H17V17H7V7ZM9 9V15H15V9H9ZM2 17H4V20H7V22H2V17ZM20 20V17H22V22H17V20H20Z"
  })),
  name: 'VisualMerchIcon',
  tags: ["visual", "merchandise", "square"],
  category: 'sasc'
};
var VolumeDownIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.43077C12 5.64434 9.83617 4.75412 8.57904 6.02334L6.31631 8.30782L4 8.30782C2.89543 8.30782 2 9.20325 2 10.3078V13.6924C2 14.797 2.89543 15.6924 4 15.6924H6.31631L8.57903 17.9769C9.83617 19.2461 12 18.3559 12 16.5695V7.43077ZM8.57903 17.9769L10 16.5695L7.73728 14.285C7.36167 13.9058 6.85007 13.6924 6.31631 13.6924H4V10.3078H6.31631C6.85007 10.3078 7.36167 10.0945 7.73728 9.71525L10 7.43077V16.5695L8.57903 17.9769ZM14 10.0001C13.4453 10.8322 13.4449 10.8319 13.4446 10.8317L13.4438 10.8312L13.4425 10.8303L13.44 10.8286L13.436 10.8259L13.4317 10.8229L13.4313 10.8226C13.4313 10.8226 13.4319 10.8231 13.4331 10.8239C13.434 10.8246 13.4353 10.8256 13.4369 10.8268C13.4461 10.8338 13.4655 10.8491 13.4919 10.8725C13.5454 10.9201 13.6223 10.9965 13.7 11.1001C13.8531 11.3043 14 11.599 14 12.0001C14 12.4013 13.8531 12.696 13.7 12.9001C13.6223 13.0037 13.5454 13.0802 13.4919 13.1277C13.4655 13.1511 13.4461 13.1664 13.4369 13.1734C13.4333 13.1762 13.4313 13.1776 13.4313 13.1776L13.4317 13.1774L13.436 13.1744L13.44 13.1717L13.4425 13.17L13.4438 13.1691L13.4446 13.1686C13.4449 13.1683 13.4453 13.1681 14 14.0001C14.5547 14.8322 14.5551 14.8319 14.5555 14.8317L14.5562 14.8311L14.5579 14.83L14.5615 14.8276L14.5698 14.822L14.5908 14.8073C14.6066 14.796 14.6262 14.7817 14.649 14.7643C14.6945 14.7296 14.7532 14.6824 14.8206 14.6225C14.9546 14.5034 15.1277 14.3299 15.3 14.1001C15.6469 13.6376 16 12.9323 16 12.0001C16 11.068 15.6469 10.3626 15.3 9.90013C15.1277 9.67038 14.9546 9.49684 14.8206 9.37772C14.7532 9.31781 14.6945 9.27061 14.649 9.23595C14.6262 9.21858 14.6066 9.20427 14.5908 9.19298L14.5698 9.1783L14.5615 9.17263L14.5579 9.17022L14.5562 9.16911L14.5555 9.16859C14.5551 9.16833 14.5547 9.16808 14 10.0001Z"
  })),
  name: 'VolumeDownIcon',
  tags: ["audio", "down", "sound", "volume"],
  category: 'system'
};
var VolumeMuteIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 7.43077C12 5.64434 9.83617 4.75412 8.57904 6.02334L6.31631 8.30782L4 8.30782C2.89543 8.30782 2 9.20325 2 10.3078V13.6924C2 14.797 2.89543 15.6924 4 15.6924H6.31631L8.57904 17.9769C9.83618 19.2461 12 18.3559 12 16.5695V7.43077ZM7.73728 9.71525L10 7.43077V16.5695L7.73728 14.285C7.36167 13.9058 6.85006 13.6924 6.31631 13.6924L4 13.6924V10.3078H6.31631C6.85006 10.3078 7.36167 10.0945 7.73728 9.71525ZM20.293 15.7072L18.0001 13.4144L15.7072 15.7072L14.293 14.293L16.5859 12.0001L14.293 9.70725L15.7072 8.29303L18.0001 10.5859L20.293 8.29303L21.7072 9.70725L19.4143 12.0001L21.7072 14.293L20.293 15.7072Z"
  })),
  name: 'VolumeMuteIcon',
  tags: ["audio", "mute", "sound", "volume"],
  category: 'system'
};
var VolumeUpIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 5.99976C17.4188 6.81349 17.4184 6.81326 17.4181 6.81303L17.4175 6.81262L17.4166 6.81193L17.4301 6.82202C17.4443 6.83282 17.4685 6.85149 17.5013 6.87791C17.5669 6.93081 17.6663 7.01437 17.7883 7.12764C18.0331 7.35495 18.3639 7.69725 18.6949 8.14653C19.3576 9.04583 20 10.3425 20 11.9998C20 13.657 19.3576 14.9537 18.6949 15.853C18.3639 16.3023 18.0331 16.6446 17.7883 16.8719C17.6663 16.9851 17.5669 17.0687 17.5013 17.1216C17.4685 17.148 17.4443 17.1667 17.4301 17.1775L17.4166 17.1876L17.4175 17.1869L17.4181 17.1865C17.4184 17.1863 17.4188 17.186 18 17.9998C18.5812 18.8135 18.5816 18.8132 18.5819 18.813L18.5827 18.8124L18.5845 18.8112L18.5889 18.808L18.6009 18.7992C18.6103 18.7923 18.6225 18.7832 18.6373 18.772C18.667 18.7495 18.7072 18.7184 18.7565 18.6787C18.8549 18.5993 18.9899 18.4854 19.1492 18.3375C19.4669 18.0425 19.8861 17.608 20.3051 17.0394C21.1424 15.903 22 14.1997 22 11.9998C22 9.79985 21.1424 8.09654 20.3051 6.96013C19.8861 6.39155 19.4669 5.95706 19.1492 5.66205C18.9899 5.51416 18.8549 5.40018 18.7565 5.32083C18.7072 5.28112 18.667 5.24998 18.6373 5.22751C18.6225 5.21627 18.6103 5.20718 18.6009 5.20027L18.5889 5.19152L18.5845 5.18836L18.5827 5.18709L18.5819 5.18653C18.5816 5.18627 18.5812 5.18602 18 5.99976ZM17.4155 6.81112C17.4153 6.81097 17.4153 6.81097 17.4155 6.81113L17.4155 6.81112ZM12 7.4304C12 5.64397 9.83617 4.75375 8.57904 6.02297L6.31631 8.30745L4 8.30745C2.89543 8.30745 2 9.20288 2 10.3074V13.6921C2 14.7966 2.89543 15.6921 4 15.6921H6.31631L8.57904 17.9765C9.83618 19.2458 12 18.3555 12 16.5691V7.4304ZM7.73728 9.71488L10 7.4304V16.5691L7.73728 14.2846C7.36167 13.9054 6.85006 13.6921 6.31631 13.6921L4 13.6921V10.3074H6.31631C6.85006 10.3074 7.36167 10.0941 7.73728 9.71488ZM14 9.99976C13.4453 10.8318 13.4449 10.8316 13.4446 10.8313L13.4438 10.8308L13.4425 10.8299L13.44 10.8282L13.436 10.8255L13.4317 10.8225L13.4328 10.8233L13.4369 10.8264C13.4461 10.8334 13.4655 10.8487 13.4919 10.8722C13.5454 10.9197 13.6223 10.9962 13.7 11.0998C13.8531 11.3039 14 11.5986 14 11.9998C14 12.4009 13.8531 12.6956 13.7 12.8998C13.6223 13.0033 13.5454 13.0798 13.4919 13.1273C13.4655 13.1508 13.4461 13.1661 13.4369 13.1731L13.4317 13.177L13.436 13.174L13.44 13.1713L13.4425 13.1696L13.4438 13.1687L13.4446 13.1682C13.4449 13.168 13.4453 13.1677 14 13.9998C14.5547 14.8318 14.5551 14.8316 14.5555 14.8313L14.5562 14.8308L14.5579 14.8297L14.5615 14.8273L14.5698 14.8216L14.5908 14.8069C14.6066 14.7956 14.6262 14.7813 14.649 14.7639C14.6945 14.7293 14.7532 14.6821 14.8206 14.6222C14.9546 14.503 15.1277 14.3295 15.3 14.0998C15.6469 13.6373 16 12.9319 16 11.9998C16 11.0676 15.6469 10.3623 15.3 9.89976C15.1277 9.67001 14.9546 9.49647 14.8206 9.37735C14.7532 9.31744 14.6945 9.27024 14.649 9.23558C14.6262 9.21821 14.6066 9.2039 14.5908 9.19261L14.5698 9.17793L14.5615 9.17226L14.5579 9.16985L14.5562 9.16874L14.5555 9.16822C14.5551 9.16796 14.5547 9.16771 14 9.99976ZM15.4446 8.83132C15.4449 8.83156 15.4453 8.83181 16 7.99976C16.5547 7.16771 16.5551 7.16796 16.5555 7.16822L16.5563 7.16877L16.5581 7.16997L16.5622 7.17275L16.5726 7.17988C16.5806 7.18533 16.5904 7.19218 16.602 7.20043C16.6252 7.21692 16.6555 7.23905 16.692 7.26683C16.7648 7.32232 16.8626 7.40078 16.9769 7.50235C17.2046 7.7048 17.5027 8.00334 17.8 8.39976C18.3969 9.19559 19 10.4009 19 11.9998C19 13.5986 18.3969 14.8039 17.8 15.5998C17.5027 15.9962 17.2046 16.2947 16.9769 16.4972C16.8626 16.5987 16.7648 16.6772 16.692 16.7327C16.6555 16.7605 16.6252 16.7826 16.602 16.7991C16.5904 16.8073 16.5806 16.8142 16.5726 16.8196L16.5622 16.8268L16.5581 16.8295L16.5563 16.8307L16.5555 16.8313C16.5551 16.8316 16.5547 16.8318 16 15.9998C15.4453 15.1677 15.4449 15.168 15.4446 15.1682L15.4439 15.1687L15.4427 15.1695L15.4407 15.1708L15.4388 15.1721L15.4429 15.1692C15.449 15.1648 15.4617 15.1557 15.4799 15.1418C15.5164 15.114 15.5749 15.0674 15.6481 15.0023C15.7954 14.8715 15.9973 14.67 16.2 14.3998C16.6031 13.8623 17 13.0676 17 11.9998C17 10.9319 16.6031 10.1373 16.2 9.59976C15.9973 9.32951 15.7954 9.12805 15.6481 8.99717C15.5749 8.93207 15.5164 8.88552 15.4799 8.85769C15.4617 8.8438 15.449 8.83468 15.4429 8.83034C15.4399 8.82817 15.4385 8.82721 15.4388 8.82745L15.4407 8.82872L15.4427 8.83004L15.4439 8.83086L15.4446 8.83132Z"
  })),
  name: 'VolumeUpIcon',
  tags: ["audio", "up", "sound", "volume"],
  category: 'system'
};
var WeeklyAdIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17 0.631592V4.18799H19V22.188H5V4.45721L17 0.631592ZM15 4.18799V3.36837L12.429 4.18799H15ZM7 6.18799H17V20.188H7V6.18799Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 9.68799C13.9367 9.68799 15.5 11.256 15.5 13.188C15.5 13.7517 15.3665 14.2837 15.1304 14.7551C14.5545 15.9012 13.3692 16.688 12 16.688C10.6317 16.688 9.4464 15.9021 8.87053 14.7579C8.63347 14.2856 8.5 13.7517 8.5 13.188C8.5 11.256 10.068 9.68799 12 9.68799ZM12 10.8547C10.712 10.8547 9.66667 11.9 9.66667 13.188C9.66667 13.5641 9.75627 13.9197 9.914 14.2343C10.2976 14.9977 11.0881 15.5213 12 15.5213C12.9128 15.5213 13.7033 14.9968 14.0869 14.2333C14.2447 13.9188 14.3333 13.5632 14.3333 13.188C14.3333 11.9 13.2908 10.8547 12 10.8547ZM12 12.0213C12.6449 12.0213 13.1667 12.544 13.1667 13.188C13.1667 13.3756 13.1219 13.5529 13.0435 13.7107C12.8521 14.0924 12.4564 14.3547 12 14.3547C11.5436 14.3547 11.1488 14.0924 10.9575 13.7116C10.8781 13.5539 10.8333 13.3756 10.8333 13.188C10.8333 12.544 11.356 12.0213 12 12.0213Z"
  })),
  name: 'WeeklyAdIcon',
  tags: ["weekly", "ad"],
  category: 'sasc'
};
var WifiIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9956 7C9.14964 7 6.57435 8.15068 4.70636 10.0146L3.2937 8.5988C5.52132 6.37608 8.59872 5 11.9956 5C15.3974 5 18.4788 6.38006 20.7071 8.60844L19.2929 10.0227C17.4243 8.15401 14.8457 7 11.9956 7ZM11.9956 10.396C10.0813 10.396 8.35013 11.1715 7.09573 12.4279L5.6804 11.0148C7.29462 9.398 9.52904 8.39599 11.9956 8.39599C14.4622 8.39599 16.6966 9.398 18.3108 11.0148L16.8955 12.4279C15.6411 11.1715 13.9098 10.396 11.9956 10.396ZM11.9956 13.792C11.0211 13.792 10.1405 14.1858 9.50093 14.8253L8.08671 13.4111C9.08599 12.4118 10.4694 11.792 11.9956 11.792C13.5218 11.792 14.9052 12.4118 15.9045 13.4111L14.4903 14.8253C13.8507 14.1858 12.9701 13.792 11.9956 13.792Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.1276 16.1879C13.1276 16.8131 12.6208 17.3199 11.9956 17.3199C11.3704 17.3199 10.8636 16.8131 10.8636 16.1879C10.8636 15.5627 11.3704 15.0559 11.9956 15.0559C12.6208 15.0559 13.1276 15.5627 13.1276 16.1879Z"
  })),
  name: 'WifiIcon',
  tags: ["wifi", "internet"],
  category: 'system'
};
var WorkIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9999 6.00008H9.99995V4.00008H22.9999V6.00008Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9999 13.0001H9.99995V11.0001H22.9999V13.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.9999 20.0001H9.99995V18.0001H22.9999V20.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.91325 3.39954L3.44961 7.86336L0.635742 5.04974L2.04989 3.63547L3.44952 5.03497L6.49901 1.98535L7.91325 3.39954Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27453 12.0001C2.27453 10.8955 3.16996 10.0001 4.27453 10.0001C5.3791 10.0001 6.27453 10.8955 6.27453 12.0001C6.27453 13.1047 5.3791 14.0001 4.27453 14.0001C3.16996 14.0001 2.27453 13.1047 2.27453 12.0001Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.27453 19.0001C2.27453 17.8955 3.16996 17.0001 4.27453 17.0001C5.3791 17.0001 6.27453 17.8955 6.27453 19.0001C6.27453 20.1047 5.3791 21.0001 4.27453 21.0001C3.16996 21.0001 2.27453 20.1047 2.27453 19.0001Z"
  })),
  name: 'WorkIcon',
  tags: ["work", "tasks", "todo"],
  category: 'sasc'
};
var WorkspaceIcon = {
  path: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 4C2 2.89543 2.89543 2 4 2H10C11.1046 2 12 2.89543 12 4V10C12 11.1046 11.1046 12 10 12H4C2.89543 12 2 11.1046 2 10V4ZM10 4H4V10H10V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 4C14 2.89543 14.8954 2 16 2H20C21.1046 2 22 2.89543 22 4V7C22 8.10457 21.1046 9 20 9H16C14.8954 9 14 8.10457 14 7V4ZM20 4H16V7H20V4Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2 16C2 14.8954 2.89543 14 4 14H10C11.1046 14 12 14.8954 12 16V20C12 21.1046 11.1046 22 10 22H4C2.89543 22 2 21.1046 2 20V16ZM10 16H4V20H10V16Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14 13C14 11.8954 14.8954 11 16 11H20C21.1046 11 22 11.8954 22 13V20C22 21.1046 21.1046 22 20 22H16C14.8954 22 14 21.1046 14 20V13ZM20 13H16V20H20V13Z"
  })),
  name: 'WorkspaceIcon',
  tags: ["workspace", "layout", "shape"],
  category: 'system'
};

export { AccessibilityIcon, ActivityIcon, AddCalendarIcon, AppSwitcherIcon, ArchiveIcon, ArrowDiagonalBackIcon, ArrowDiagonalForwardIcon, ArrowDownIcon, ArrowLeftIcon, ArrowRightIcon, ArrowUpIcon, ArrowsHorizontalIcon, ArrowsVerticalIcon, BackroomLocationManagementIcon, BackstockIcon, BadgeIcon, BagIcon, BellIcon, BlockIcon, BookIcon, BookmarkFilledIcon, BookmarkIcon, BoxIcon, BrandIcon, BulkIcon, CalculationIcon, CalendarIcon, CameraIcon, CampaignIcon, CancelCircleIcon, CancelIcon, CaretDownIcon, CaretLeftIcon, CaretRightIcon, CaretUpIcon, CaretsHorizontalIcon, CaretsVerticalIcon, CartIcon, CashIcon, CatalogIcon, CautionFilledIcon, CautionIcon, ChartAreaIcon, ChartBarHorizontalIcon, ChartBarLineIcon, ChartBarStacked100PercentIcon, ChartBarStackedGroupIcon, ChartBarStackedIcon, ChartBarStackedLineIcon, ChartBarVerticalIcon, ChartLineIcon, ChartMaximumIcon, ChartMinimumIcon, ChartParetoIcon, ChartPieIcon, ChartRingIcon, ChartWaveSquareIcon, ChatIcon, CheckCircleFilledIcon, CheckCircleIcon, CheckDatesIcon, CheckIcon, CheckboxIcon, ChecklistIcon, ChevronDownDoubleIcon, ChevronDownIcon, ChevronLeftDoubleIcon, ChevronLeftIcon, ChevronRightDoubleIcon, ChevronRightIcon, ChevronUpDoubleIcon, ChevronUpIcon, CleaningIcon, ClipboardIcon, ClockIcon, CloudAlertIcon, CloudCheckIcon, CloudDownloadIcon, CloudIcon, CloudLockIcon, CloudOffIcon, CloudRefreshIcon, CloudUploadIcon, CollectionIcon, CommIcon, CommentIcon, CreateBarcodeIcon, CreditCardIcon, DashboardIcon, DataTableIcon, DataTreeIcon, DatabaseCheckIcon, DatabaseIcon, DatabaseXIcon, DeviceIcon, DevicesIcon, DivisionBabyIcon, DivisionBakeryIcon, DivisionBeautyIcon, DivisionCenterStoreGroceryIcon, DivisionDecorIcon, DivisionDecorativeHomeIcon, DivisionDeliIcon, DivisionDomesticsIcon, DivisionElectronicsIcon, DivisionEntertainmentIcon, DivisionFoodServiceIcon, DivisionHealthcareIcon, DivisionHouseholdPaperPetIcon, DivisionIcon, DivisionIntimatesHosierySleepwareIcon, DivisionJewelryAccessoriesIcon, DivisionKidsApparelIcon, DivisionKitchenIcon, DivisionMeatFrozenDairyIcon, DivisionMensIcon, DivisionOutdoorLivingIcon, DivisionPerformanceIcon, DivisionProduceIcon, DivisionReadyToWearIcon, DivisionSeasonalIcon, DivisionShoesIcon, DivisionSportingGoodsIcon, DivisionStationeryHolidayIcon, DivisionStationeryIcon, DivisionStorageUtilityIcon, DivisionToysIcon, DollarSignCircleIcon, DollarSignIcon, DownloadIcon, DragIcon, DuplicateIcon, EmergencyIcon, EnterpriseIcon, ErrorFilledIcon, ErrorIcon, ExportIcon, ExternalIcon, FileIcon, FileTextIcon, FileZipIcon, FilesIcon, FillAndBackstockIcon, FillIcon, FilterFunnelClearIcon, FilterFunnelIcon, FilterIcon, FixturesIcon, FlagFilledIcon, FlagIcon, FolderIcon, FolderMoveIcon, FolderOpenIcon, FolderSharedIcon, FoldersIcon, FulfillmentIcon, FunctionIcon, GearIcon, GithubIcon, GlobeIcon, GoCartIcon, GridIcon, GroupIcon, GroupingIcon, GuestPriceChallengeIcon, HashtagIcon, HeartFilledIcon, HeartIcon, HelpIcon, HistoryIcon, HouseIcon, HuddleIcon, ImageIcon, ImagesIcon, ImportIcon, InProgressFilledIcon, InProgressIcon, InboxIcon, InfoFilledIcon, InfoIcon, InventoryAuditIcon, JiraIcon, LightDarkModeFilledIcon, LightDarkModeIcon, LinkIcon, ListCheckIcon, ListOrderedIcon, ListUnorderedIcon, LockIcon, LockLockedIcon, LockUnlockedIcon, LoginIcon, LogoutIcon, LoyaltyIcon, MailIcon, ManufacturingIcon, MarketplaceIcon, MaximizeIcon, MenuIcon, MicIcon, MinimizeIcon, MinusCircleIcon, MinusIcon, MydayIcon, NetworkIcon, NewIcon, NotebookIcon, OrderPickupIcon, OverflowMenuHorizontalIcon, OverflowMenuVerticalIcon, PageFirstIcon, PageLastIcon, PaperAirplaneIcon, PaperclipIcon, PauseIcon, PencilIcon, PersonHappyIcon, PersonIcon, PersonNeutralIcon, PersonSadIcon, PersonVeryHappyIcon, PersonVerySadIcon, PickIcon, PinFilledIcon, PinIcon, PlayIcon, PluginIcon, PlusCircleIcon, PlusIcon, PowerEquipmentCertificationIcon, PriceAuditIcon, PriceChangeIcon, PrinterConnectedIcon, PrinterIcon, ProcessingIcon, ProfileIcon, PutToHoldIcon, PyramidApparelAccessoriesIcon, PyramidFoodBeverageIcon, PyramidHardlinesIcon, PyramidHealthBeautyIcon, PyramidHomeIcon, PyramidIcon, PyramidSpecialProjectIcon, ReadyForReviewFilledIcon, ReadyForReviewIcon, ReceiptIcon, RedoIcon, RefreshIcon, ReplyIcon, RewrapIcon, RupeeIcon, SaveIcon, ScanIcon, SearchIcon, ShelfIcon, ShipIcon, SignIcon, SlackIcon, SqlFullOuterJoinIcon, SqlInnerJoinIcon, SqlLeftOuterJoinIcon, SqlRightOuterJoinIcon, StackOverflowIcon, StarFilledIcon, StarHalfIcon, StarIcon, StopIcon, StoreAltIcon, StoreIcon, StoreMapIcon, SubDirectoryIcon, SumIcon, SupportIcon, TagIcon, TakeLocationIcon, TeacherIcon, TelephoneIcon, TemperatureIcon, TemplateIcon, TextStringIcon, ThumbsDownIcon, ThumbsUpIcon, TieLocationIcon, TimerIcon, TmInProgressIcon, TouchscreenIcon, TrainingIcon, TrashIcon, TroubleshootIcon, TruckIcon, UndoIcon, UploadIcon, VideoIcon, VisibleHideIcon, VisibleShowIcon, VisualMerchIcon, VolumeDownIcon, VolumeMuteIcon, VolumeUpIcon, WeeklyAdIcon, WifiIcon, WorkIcon, WorkspaceIcon, EnterpriseIcon as default };
